define(["react","underscore","prop-types","@bingads-webui-universal/primitive-utilities","@bingads-webui-react/scope-service","@bingads-webui-react/router","react-router-dom","urijs","@bingads-webui-react/hoc-with-permissions","@bingads-webui-react/user-context","@bingads-webui-react/settings-context","@bingads-webui/with-state-store","@bingads-webui/state-store","@bingads-webui-react/yahoo-iframe"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__110__, __WEBPACK_EXTERNAL_MODULE__162__, __WEBPACK_EXTERNAL_MODULE__183__, __WEBPACK_EXTERNAL_MODULE__327__, __WEBPACK_EXTERNAL_MODULE__533__, __WEBPACK_EXTERNAL_MODULE__559__, __WEBPACK_EXTERNAL_MODULE__574__, __WEBPACK_EXTERNAL_MODULE__867__, __WEBPACK_EXTERNAL_MODULE__870__, __WEBPACK_EXTERNAL_MODULE__1526__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1323);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__110__;

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1324);


/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  siteMapPropType: true,
  customMapperStore: true,
  getRoutePathById: true,
  findSiteMap: true,
  findDeepSiteMap: true,
  findSelectedNode: true,
  findAllSiteMap: true,
  isRouteMatch: true,
  filterMapByRootIds: true,
  CampaignType: true,
  AdGroupType: true,
  Scope: true,
  ScopeV2: true,
  defaultItem: true,
  buildTree: true,
  BaseHost: true,
  RoutePrefix: true,
  getCurrentScope: true,
  trimScope: true,
  updateSelected: true,
  navRefreshPageIds: true
};
Object.defineProperty(exports, "siteMapPropType", {
  enumerable: true,
  get: function get() {
    return _siteMapPropType.siteMapPropType;
  }
});
Object.defineProperty(exports, "customMapperStore", {
  enumerable: true,
  get: function get() {
    return _customMapperProcessor.customMapperStore;
  }
});
Object.defineProperty(exports, "getRoutePathById", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.getRoutePathById;
  }
});
Object.defineProperty(exports, "findSiteMap", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.findSiteMap;
  }
});
Object.defineProperty(exports, "findDeepSiteMap", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.findDeepSiteMap;
  }
});
Object.defineProperty(exports, "findSelectedNode", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.findSelectedNode;
  }
});
Object.defineProperty(exports, "findAllSiteMap", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.findAllSiteMap;
  }
});
Object.defineProperty(exports, "isRouteMatch", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.isRouteMatch;
  }
});
Object.defineProperty(exports, "filterMapByRootIds", {
  enumerable: true,
  get: function get() {
    return _siteMapUtilities.filterMapByRootIds;
  }
});
Object.defineProperty(exports, "CampaignType", {
  enumerable: true,
  get: function get() {
    return _shared.CampaignType;
  }
});
Object.defineProperty(exports, "AdGroupType", {
  enumerable: true,
  get: function get() {
    return _shared.AdGroupType;
  }
});
Object.defineProperty(exports, "Scope", {
  enumerable: true,
  get: function get() {
    return _shared.Scope;
  }
});
Object.defineProperty(exports, "ScopeV2", {
  enumerable: true,
  get: function get() {
    return _shared.ScopeV2;
  }
});
Object.defineProperty(exports, "defaultItem", {
  enumerable: true,
  get: function get() {
    return _shared.defaultItem;
  }
});
Object.defineProperty(exports, "buildTree", {
  enumerable: true,
  get: function get() {
    return _shared.buildTree;
  }
});
Object.defineProperty(exports, "BaseHost", {
  enumerable: true,
  get: function get() {
    return _shared.BaseHost;
  }
});
Object.defineProperty(exports, "RoutePrefix", {
  enumerable: true,
  get: function get() {
    return _shared.RoutePrefix;
  }
});
Object.defineProperty(exports, "getCurrentScope", {
  enumerable: true,
  get: function get() {
    return _processorHelpers.getCurrentScope;
  }
});
Object.defineProperty(exports, "trimScope", {
  enumerable: true,
  get: function get() {
    return _processorHelpers.trimScope;
  }
});
Object.defineProperty(exports, "updateSelected", {
  enumerable: true,
  get: function get() {
    return _pathProcessor.updateSelected;
  }
});
Object.defineProperty(exports, "navRefreshPageIds", {
  enumerable: true,
  get: function get() {
    return _configsV.navRefreshPageIds;
  }
});

var _withSiteMap = __webpack_require__(1325);

Object.keys(_withSiteMap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withSiteMap[key];
    }
  });
});

var _siteMapPropType = __webpack_require__(1513);

var _customMapperProcessor = __webpack_require__(1521);

var _siteMapUtilities = __webpack_require__(1519);

var _shared = __webpack_require__(1327);

var _processorHelpers = __webpack_require__(1515);

var _pathProcessor = __webpack_require__(1518);

var _configsV = __webpack_require__(1528);

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSiteMap = withSiteMap;
Object.defineProperty(exports, "navRefreshSiteMap", {
  enumerable: true,
  get: function get() {
    return _configsV.navRefreshSiteMap;
  }
});
exports.Configs = exports.allSiteMap = exports.withAdInsightSiteMap = exports.withUnifiedSmartSiteMap = exports.withSmartSiteMap = exports.withClientCenterStandaloneSiteMap = exports.withClientCenterSiteMap = exports.withAllClientCenterSiteMap = exports.withStandaloneSiteMap = exports.withHotelCenterV2SiteMap = exports.withHotelCenterSiteMap = exports.withReportsV4SiteMap = exports.withReportsSiteMap = exports.withFlatSmartImportSiteMap = exports.withImportSiteMap = exports.withFlatSetupSiteMap = exports.withFlatSmartToolsSiteMap = exports.withFlatToolsSiteMap = exports.withToolsSiteMap = exports.withCampaignSiteMap = exports.withBidStrategiesSiteMap = exports.withAccountsSiteMap = exports.processorSet = exports.processor = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var Configs = _interopRequireWildcard(__webpack_require__(1326));

exports.Configs = Configs;

var _permissionProcessor = __webpack_require__(1512);

var _scopeProcessor = __webpack_require__(1514);

var _scopeProcessorV = __webpack_require__(1517);

var _pathProcessor = __webpack_require__(1518);

var _customMapperProcessor = __webpack_require__(1521);

var _rootFilterProcessor = __webpack_require__(1522);

var _campaignUiContextProcessor = __webpack_require__(1523);

var _yahooShowProcessor = __webpack_require__(1524);

var _siteMapWrapper = __webpack_require__(1527);

var _configsV = __webpack_require__(1528);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const accountsSiteMap = Configs.accountsSiteMap,
      campaignSiteMap = Configs.campaignSiteMap,
      toolsSiteMap = Configs.toolsSiteMap,
      flatToolsSiteMap = Configs.flatToolsSiteMap,
      importSiteMap = Configs.importSiteMap,
      reportsSiteMap = Configs.reportsSiteMap,
      reportsV4SiteMap = Configs.reportsV4SiteMap,
      hotelCenterSiteMap = Configs.hotelCenterSiteMap,
      hotelCenterV2SiteMap = Configs.hotelCenterV2SiteMap,
      standaloneSiteMap = Configs.standaloneSiteMap,
      flatSetupSiteMap = Configs.flatSetupSiteMap,
      allSiteMap = Configs.allSiteMap,
      allClientCenterSiteMap = Configs.allClientCenterSiteMap,
      bidStrategiesSiteMap = Configs.bidStrategiesSiteMap,
      clientCenterSiteMap = Configs.clientCenterSiteMap,
      clientCenterStandAloneSiteMap = Configs.clientCenterStandAloneSiteMap,
      smartCampaignsSiteMap = Configs.smartCampaignsSiteMap,
      unifiedSmartSiteMap = Configs.unifiedSmartSiteMap,
      adInsightSiteMap = Configs.adInsightSiteMap,
      flatSmartToolsSiteMap = Configs.flatSmartToolsSiteMap,
      flatSmartImportSiteMap = Configs.flatSmartImportSiteMap;
exports.allSiteMap = allSiteMap;

const processPermissionsCached = _underscore.default.partial(_permissionProcessor.processPermissions, _underscore.default, true);

const processScopeCached = _underscore.default.partial(_scopeProcessor.processScope, _underscore.default, _underscore.default, true);

const processScopeSkipRootCached = _underscore.default.partial(_scopeProcessor.processScope, _underscore.default, _underscore.default, true, true);

const processPathCached = _underscore.default.partial(_pathProcessor.processPath, _underscore.default, true);

const processor = {
  processPermissions: processPermissionsCached,
  processPermissionsCached,
  processScope: processScopeCached,
  processScopeCached,
  processPath: processPathCached,
  processCampaignUIContext: _campaignUiContextProcessor.processCampaignUIContext,
  processPathCached,
  processCustomMapper: _customMapperProcessor.processCustomMapper,
  processScopeSkipRoot: processScopeSkipRootCached,
  processRootFilter: _rootFilterProcessor.processRootFilter,
  processScopeV2: _scopeProcessorV.processScopeV2,
  processScopeV2Cached: _underscore.default.partial(_scopeProcessorV.processScopeV2, _underscore.default, _underscore.default, true),
  processShowYahoo: _yahooShowProcessor.processShowYahoo
};
exports.processor = processor;
const processorSet = {
  basic: [processPermissionsCached, processPathCached],
  default: [processPermissionsCached, processScopeCached, processPathCached],
  all: [processPermissionsCached, processScopeCached, processPathCached, _customMapperProcessor.processCustomMapper],
  navRefreshL1: [processPermissionsCached, processScopeSkipRootCached]
};
exports.processorSet = processorSet;

function withSiteMap(Component, processors = processorSet.default, siteMap = allSiteMap, rootId = null, propName = _siteMapWrapper.defaultPropName) {
  const composedProcessor = rootId === null ? _underscore.default.compose(...processors) : _underscore.default.compose(...processors, _underscore.default.partial(_rootFilterProcessor.processRootFilter, _underscore.default, rootId));
  return (0, _siteMapWrapper.createSiteMapWrapper)(Component, composedProcessor, siteMap, propName);
}

const withAccountsSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, accountsSiteMap);

exports.withAccountsSiteMap = withAccountsSiteMap;

const withBidStrategiesSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, bidStrategiesSiteMap);

exports.withBidStrategiesSiteMap = withBidStrategiesSiteMap;

const withCampaignSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, campaignSiteMap);

exports.withCampaignSiteMap = withCampaignSiteMap;

const withToolsSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, toolsSiteMap);

exports.withToolsSiteMap = withToolsSiteMap;

const withFlatToolsSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, flatToolsSiteMap);

exports.withFlatToolsSiteMap = withFlatToolsSiteMap;

const withFlatSmartToolsSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, flatSmartToolsSiteMap);

exports.withFlatSmartToolsSiteMap = withFlatSmartToolsSiteMap;

const withFlatSetupSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, flatSetupSiteMap);

exports.withFlatSetupSiteMap = withFlatSetupSiteMap;

const withImportSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, importSiteMap);

exports.withImportSiteMap = withImportSiteMap;

const withFlatSmartImportSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, flatSmartImportSiteMap);

exports.withFlatSmartImportSiteMap = withFlatSmartImportSiteMap;

const withReportsSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, reportsSiteMap);

exports.withReportsSiteMap = withReportsSiteMap;

const withReportsV4SiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, reportsV4SiteMap);

exports.withReportsV4SiteMap = withReportsV4SiteMap;

const withHotelCenterSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, hotelCenterSiteMap);

exports.withHotelCenterSiteMap = withHotelCenterSiteMap;

const withHotelCenterV2SiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, hotelCenterV2SiteMap);

exports.withHotelCenterV2SiteMap = withHotelCenterV2SiteMap;

const withStandaloneSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, standaloneSiteMap);

exports.withStandaloneSiteMap = withStandaloneSiteMap;

const withAllClientCenterSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, processorSet.basic, allClientCenterSiteMap);

exports.withAllClientCenterSiteMap = withAllClientCenterSiteMap;

const withClientCenterSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, clientCenterSiteMap);

exports.withClientCenterSiteMap = withClientCenterSiteMap;

const withClientCenterStandaloneSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, clientCenterStandAloneSiteMap);

exports.withClientCenterStandaloneSiteMap = withClientCenterStandaloneSiteMap;

const withSmartSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, smartCampaignsSiteMap);

exports.withSmartSiteMap = withSmartSiteMap;

const withUnifiedSmartSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, unifiedSmartSiteMap);

exports.withUnifiedSmartSiteMap = withUnifiedSmartSiteMap;

const withAdInsightSiteMap = _underscore.default.partial(withSiteMap, _underscore.default, _underscore.default, adInsightSiteMap);

exports.withAdInsightSiteMap = withAdInsightSiteMap;

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allSiteMap = exports.allClientCenterSiteMap = exports.adInsightSiteMap = exports.smartCampaignsSiteMap = exports.unifiedSmartSiteMap = exports.clientCenterStandAloneSiteMap = exports.clientCenterSiteMap = exports.hotelCenterV2SiteMap = exports.hotelCenterSiteMap = exports.standaloneSiteMap = exports.flatSmartImportSiteMap = exports.importSiteMap = exports.reportsV4SiteMap = exports.flatSetupSiteMap = exports.flatSmartToolsSiteMap = exports.flatToolsSiteMap = exports.toolsSiteMap = exports.campaignSiteMap = exports.bidStrategiesSiteMap = exports.accountsSiteMap = exports.ccAlwaysDisplayedItem = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

var _index = __webpack_require__(1329);

var _index2 = __webpack_require__(1335);

var _index3 = __webpack_require__(1363);

var _reportsV = __webpack_require__(1435);

var _hotelCenter = __webpack_require__(1398);

var _hotelCenterV = __webpack_require__(1408);

var _import = __webpack_require__(1450);

var _index4 = __webpack_require__(1453);

var _index5 = __webpack_require__(1454);

var _standalone = __webpack_require__(1455);

var _clientCenter = __webpack_require__(1491);

var _unifiedProduct = __webpack_require__(1504);

var _bidStrategies = __webpack_require__(1509);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

window.performance.siteMapLatency = {
  eventName: 'PerfMarker/SiteMapLatency',
  eventStartTime: window.performance.now()
};

const ccAlwaysDisplayedItem = _objectSpread({}, _shared.alwaysDisplayedItem, _shared.defaultCCItemProperties);

exports.ccAlwaysDisplayedItem = ccAlwaysDisplayedItem;

const smartItem = _objectSpread({}, _shared.alwaysDisplayedItem, _shared.defaultSmartItemProperties);

const unifiedSmartItem = _objectSpread({}, _shared.alwaysDisplayedItem, _shared.defaultUpItemProperties);

const hiddenItem = _underscore.default.defaults({
  campaignTypes: _shared.alwaysDisplayed,
  searchable: false
}, _shared.defaultItem);

const ccHiddenItem = _objectSpread({}, hiddenItem, _shared.defaultCCItemProperties);

const accountsSiteMap = (0, _shared.buildTree)(_index.accountsPages, _shared.alwaysDisplayedItem, true);
exports.accountsSiteMap = accountsSiteMap;
const bidStrategiesSiteMap = (0, _shared.buildTree)(_bidStrategies.bidStrategiesPages, _shared.alwaysDisplayedItem, true);
exports.bidStrategiesSiteMap = bidStrategiesSiteMap;
const campaignSiteMap = (0, _shared.buildTree)(_index2.campaignPages, _shared.defaultItem, true);
exports.campaignSiteMap = campaignSiteMap;
const toolsSiteMap = (0, _shared.buildTree)(_index3.toolsPages, _shared.alwaysDisplayedItem, true);
exports.toolsSiteMap = toolsSiteMap;
const flatToolsSiteMap = (0, _shared.buildTree)(_index3.flatToolsPages, hiddenItem, true);
exports.flatToolsSiteMap = flatToolsSiteMap;
const flatSmartToolsSiteMap = (0, _shared.buildTree)(_index3.flatSmartToolsPages, hiddenItem, true);
exports.flatSmartToolsSiteMap = flatSmartToolsSiteMap;
const flatSetupSiteMap = (0, _shared.buildTree)(_index3.flatSetupPages, hiddenItem, true);
exports.flatSetupSiteMap = flatSetupSiteMap;
const reportsV4SiteMap = (0, _shared.buildTree)(_reportsV.reportsV4Pages, _shared.alwaysDisplayedItem, true);
exports.reportsV4SiteMap = reportsV4SiteMap;
const importSiteMap = (0, _shared.buildTree)(_import.importPages, _shared.alwaysDisplayedItem, true);
exports.importSiteMap = importSiteMap;
const flatSmartImportSiteMap = (0, _shared.buildTree)(_import.flatSmartImportPages, _shared.alwaysDisplayedItem, true);
exports.flatSmartImportSiteMap = flatSmartImportSiteMap;
const standaloneSiteMap = (0, _shared.buildTree)(_standalone.standalonePages, hiddenItem, true);
exports.standaloneSiteMap = standaloneSiteMap;
const hotelCenterSiteMap = (0, _shared.buildTree)(_hotelCenter.hotelCenterPages, hiddenItem, true);
exports.hotelCenterSiteMap = hotelCenterSiteMap;
const hotelCenterV2SiteMap = (0, _shared.buildTree)(_hotelCenterV.hotelCenterV2Pages, hiddenItem, true);
exports.hotelCenterV2SiteMap = hotelCenterV2SiteMap;
const clientCenterSiteMap = (0, _shared.buildTree)(_clientCenter.clientCenterPages, ccAlwaysDisplayedItem, true);
exports.clientCenterSiteMap = clientCenterSiteMap;
const clientCenterStandAloneSiteMap = (0, _shared.buildTree)(_clientCenter.clientCenterStandalonePages, ccHiddenItem, true);
exports.clientCenterStandAloneSiteMap = clientCenterStandAloneSiteMap;
const unifiedSmartSiteMap = (0, _shared.buildTree)(_unifiedProduct.unifiedSmartPages, unifiedSmartItem, true); // we need to add this smartCampaignsSiteMap to allSiteMap when smart new ui is ready.
// currently we use another smart sitemap in campaign folder when ui-next user click smart campaign
// global filter. we may use this one to replace it later.
// this one has the same search string and id, so we don't add it to allSiteMap for now

exports.unifiedSmartSiteMap = unifiedSmartSiteMap;
const smartCampaignsSiteMap = (0, _shared.buildTree)(_index4.smartCampaignPages, smartItem, true);
exports.smartCampaignsSiteMap = smartCampaignsSiteMap;
const adInsightSiteMap = (0, _shared.buildTree)(_index5.adInsightPages, _shared.adInsightItem, true);
exports.adInsightSiteMap = adInsightSiteMap;

const allClientCenterSiteMap = _underscore.default.union(clientCenterSiteMap, clientCenterStandAloneSiteMap);

exports.allClientCenterSiteMap = allClientCenterSiteMap;

const allSiteMap = _underscore.default.union(campaignSiteMap, accountsSiteMap, toolsSiteMap, standaloneSiteMap, reportsV4SiteMap, importSiteMap, clientCenterSiteMap, clientCenterStandAloneSiteMap, adInsightSiteMap, bidStrategiesSiteMap);

exports.allSiteMap = allSiteMap;
window.performance.siteMapLatency.eventEndTime = window.performance.now();

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTree = buildTree;
Object.defineProperty(exports, "ScopeV2", {
  enumerable: true,
  get: function get() {
    return _scope.ScopeV2;
  }
});
exports.adInsightItem = exports.defaultUpItemProperties = exports.isUnifiedProductSubscriptionEnabled = exports.isUnifiedProductEnabled = exports.isSmartPageStandalone = exports.defaultSmartItemProperties = exports.alwaysDisplayedItem = exports.defaultCCItemProperties = exports.defaultItem = exports.allScopes = exports.accountScopes = exports.defaultScopes = exports.alwaysDisplayed = exports.RoutePrefix = exports.BaseHost = exports.Scope = exports.AdGroupType = exports.CampaignType = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _scope = __webpack_require__(1328);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const CampaignType = {
  None: 0,
  Default: 1 << 0,
  Shopping: 1 << 1,
  DynamicSearchAds: 1 << 2,
  Audience: 1 << 3,
  Smart: 1 << 4,
  Hotel: 1 << 5,
  PerformanceMax: 1 << 6,
  All: 0xFFFF
};
exports.CampaignType = CampaignType;
const AdGroupType = {
  SearchStandard: 'SearchStandard',
  SearchDynamic: 'SearchDynamic'
};
exports.AdGroupType = AdGroupType;
const Scope = {
  Customer: 0,
  Account: 1,
  Campaign: 2,
  AdGroup: 3,
  Ad: 4,
  PerformanceTarget: 5,
  Store: 6,
  MerchantFeed: 7
};
exports.Scope = Scope;

_scope.ScopeV2.add('User', 'uid');

_scope.ScopeV2.add('Customer', 'cid', _scope.ScopeV2.User);

_scope.ScopeV2.add('Account', 'aid', _scope.ScopeV2.Customer);

_scope.ScopeV2.add('Campaign', 'campaignId', _scope.ScopeV2.Account);

_scope.ScopeV2.add('AdGroup', 'adGroupId', _scope.ScopeV2.Campaign);

_scope.ScopeV2.add('Feed', 'feedId', _scope.ScopeV2.Account);

// refer to settingContext.Url for bastHost details
const BaseHost = {
  ClientCenter: 'ClientCenterBaseUrl',
  Campaign: 'CampaignBaseUrl',
  Smart: 'SmartBaseUrl',
  AdInsight: 'AdInsightBaseUrl',
  UnifiedProduct: 'UnifiedProductBaseUrl'
};
exports.BaseHost = BaseHost;
const RoutePrefix = {
  ClientCenter: '/',
  Campaign: '/campaign/vnext/',
  Smart: '/campaign/smart/',
  AdInsight: '/research/vnext/',
  UnifiedProduct: '/campaign/mca/'
};
exports.RoutePrefix = RoutePrefix;
const alwaysDisplayed = [CampaignType.None, CampaignType.All];
exports.alwaysDisplayed = alwaysDisplayed;
const defaultScopes = [Scope.Account, Scope.Campaign, Scope.AdGroup];
exports.defaultScopes = defaultScopes;
const accountScopes = [Scope.Customer, Scope.Account];
exports.accountScopes = accountScopes;
const allScopes = [Scope.Customer, Scope.Account, Scope.Campaign, Scope.AdGroup, Scope.Ad, Scope.PerformanceTarget, Scope.Store, Scope.MerchantFeed];
exports.allScopes = allScopes;
const defaultItem = {
  id: '',
  name: '',
  route: '',
  routePrefix: RoutePrefix.Campaign,
  children: [],
  scope: defaultScopes,
  campaignTypes: [CampaignType.All],
  available: true,
  selected: false,
  checkPermission: () => true,
  searchable: true,
  baseHost: BaseHost.Campaign
};
exports.defaultItem = defaultItem;
const defaultCCItemProperties = {
  baseHost: BaseHost.ClientCenter,
  routePrefix: RoutePrefix.ClientCenter,
  scope: accountScopes,
  available: true,
  checkPermission: () => true
};
exports.defaultCCItemProperties = defaultCCItemProperties;

const alwaysDisplayedItem = _underscore.default.defaults({
  campaignTypes: alwaysDisplayed
}, defaultItem);

exports.alwaysDisplayedItem = alwaysDisplayedItem;

const isNewSmartEnabled = permissions => permissions.dynamic.SmartNewUI && permissions.IsSmartCampaignPhase2Enabled;

const defaultSmartItemProperties = {
  baseHost: BaseHost.Smart,
  routePrefix: RoutePrefix.Smart,
  scope: accountScopes,
  isSmartPage: true,
  available: true,
  checkPermission: isNewSmartEnabled
}; // permissions.dynamic.IsSmartPageStandalone is set only by standalone app ui side.
// So it will be undefined in other apps.

exports.defaultSmartItemProperties = defaultSmartItemProperties;

const isSmartPageStandalone = permissions => permissions.dynamic.IsSmartPageStandalone;

exports.isSmartPageStandalone = isSmartPageStandalone;

const isUnifiedProductEnabled = permissions => permissions.dynamic.UnifiedProductPhase2 && permissions.IsUnifiedSmartMode;

exports.isUnifiedProductEnabled = isUnifiedProductEnabled;

const isUnifiedProductSubscriptionEnabled = permissions => permissions.dynamic.UnifiedProductSubscription;

exports.isUnifiedProductSubscriptionEnabled = isUnifiedProductSubscriptionEnabled;
const defaultUpItemProperties = {
  baseHost: BaseHost.UnifiedProduct,
  routePrefix: RoutePrefix.UnifiedProduct,
  scope: accountScopes,
  searchable: false,
  available: true,
  checkPermission: isUnifiedProductEnabled
};
exports.defaultUpItemProperties = defaultUpItemProperties;
const defaultAdInsightItemProperties = {
  baseHost: BaseHost.AdInsight,
  routePrefix: RoutePrefix.AdInsight,
  scope: accountScopes,
  available: true,
  checkPermission: () => false
};

const adInsightItem = _objectSpread({}, alwaysDisplayedItem, defaultAdInsightItemProperties); // todo [rayduan]: below section is for migration period only (from scope to scope V2)
// Will clean up when we deprecate all current Scope and rename ScopeV2 to Scope


exports.adInsightItem = adInsightItem;
const scopeMapping = {
  [Scope.Customer]: _scope.ScopeV2.Customer,
  [Scope.Account]: _scope.ScopeV2.Account,
  [Scope.Campaign]: _scope.ScopeV2.Campaign,
  [Scope.AdGroup]: _scope.ScopeV2.AdGroup
};

const addV2Scopes = item => {
  if (_underscore.default.has(item, 'scope') && !_underscore.default.has(item, 'scopeV2')) {
    const scopeV2 = _underscore.default.compact(_underscore.default.map(item.scope, scope => _underscore.default.result(scopeMapping, scope, null)));

    _underscore.default.extend(item, {
      scopeV2
    });
  }
}; // end of todo


function buildTree(children, defaults, addParent, parent, clone = false) {
  return _underscore.default.map(children, item => {
    let withDefaults;
    let withParent;

    if (clone) {
      withDefaults = _underscore.default.defaults({}, item, defaults);
      withParent = _underscore.default.extend({}, withDefaults, {
        parent
      });
    } else {
      withDefaults = _underscore.default.defaults(item, defaults);
      withParent = _underscore.default.extend(withDefaults, {
        parent
      });
    }

    withParent.children = buildTree(withParent.children, defaults, addParent, addParent ? item : null, clone);
    addV2Scopes(withParent);
    return withParent;
  });
}

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopeV2 = exports.Scope = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const aggregateParents = (node, iteratee, memo) => {
  let result = memo;

  for (let cur = node; cur !== null; cur = cur.parent) {
    result = iteratee(result, cur);
  }

  return result;
};

class ScopeNode {
  constructor(name, key, parent) {
    _defineProperty(this, "children", []);

    this.name = name;
    this.key = key;
    this.parent = parent;
  }

  isMatch(key) {
    return this.key === key;
  }

  isEqual(other) {
    return this.name === other.name;
  }

  isChildOf(parent) {
    return aggregateParents(this, (result, node) => result || node.parent === parent, false);
  }

  get level() {
    return aggregateParents(this.parent, l => l + 1, 0);
  }

  get keys() {
    return aggregateParents(this, (result, node) => {
      if (node.key !== null) {
        result.push(node.key);
      }

      return result;
    }, []);
  }

}

class ScopeContainer {
  constructor() {
    _defineProperty(this, "$root", new ScopeNode('$root', null, null));

    _defineProperty(this, "add", (name, key, parent = this.$root) => {
      if (_underscore.default.isEmpty(this.findNode(parent))) {
        return null; // invalid parent node
      }

      const newNode = new ScopeNode(name, key, parent);

      if (!_underscore.default.isEmpty(this.findNode(newNode))) {
        return null; // node with name already exists
      }

      parent.children.push(newNode);
      this[name] = newNode;
      return newNode;
    });

    _defineProperty(this, "find", (condition, current = this.$root) => {
      if (_underscore.default.isEmpty(current)) {
        return null;
      }

      const nodes = [current];

      while (!_underscore.default.isEmpty(nodes)) {
        const node = nodes.pop();

        if (condition(node)) {
          return node;
        }

        nodes.unshift(...node.children);
      }

      return null;
    });

    _defineProperty(this, "findAll", (condition, current = null) => {
      const result = [];
      const nodes = current == null ? [...this.$root.children] : [current];

      while (!_underscore.default.isEmpty(nodes)) {
        const node = nodes.pop();

        if (condition(node)) {
          result.push(node);
          nodes.unshift(...node.children);
        }
      }

      return result;
    });

    _defineProperty(this, "findNode", node => this.find(current => current.isEqual(node)));

    _defineProperty(this, "findByKey", key => this.find(current => current.isMatch(key)));

    _defineProperty(this, "getCurrentScope", queryParams => {
      const scopes = this.findAll(node => _underscore.default.has(queryParams, node.key), this.Customer);
      return this.findDeepest(scopes);
    });

    _defineProperty(this, "findDeepest", scopes => _underscore.default.reduce(scopes, (result, scope) => result.level > scope.level ? result : scope, this.$root));

    _defineProperty(this, "trimToScope", (target, queryParams) => {
      const targetScope = _underscore.default.isArray(target) ? this.findDeepest(target) : target;
      const currentScope = this.getCurrentScope(queryParams);

      const keysToRemove = _underscore.default.without(currentScope.keys, ...targetScope.keys);

      return _underscore.default.omit(queryParams, ...keysToRemove);
    });
  }

}

const Scope = new ScopeContainer();
exports.Scope = Scope;
const ScopeV2 = Scope; // todo [rayduan]: remove ScopeV2 after finishing scope migration

exports.ScopeV2 = ScopeV2;

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsPages = void 0;

var _accounts = __webpack_require__(1330);

var _accountsSummary = __webpack_require__(1331);

var _overview = __webpack_require__(1332);

var _recommendations = __webpack_require__(1333);

var _auctionInsights = __webpack_require__(1334);

const accountsPages = [_accounts.accounts, _overview.overview, _accountsSummary.accountsSummary, _recommendations.recommendations, _auctionInsights.auctionInsights];
exports.accountsPages = accountsPages;

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accounts = void 0;

var _shared = __webpack_require__(1327);

const accounts = {
  id: 'accounts',
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'accounts',
    route: 'accounts',
    scope: [_shared.Scope.Customer],
    available: permissions => permissions.dynamic.WebUIVnext,
    searchable: false
  }]
};
exports.accounts = accounts;

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsSummary = void 0;

var _shared = __webpack_require__(1327);

const accountsSummary = {
  id: 'accounts-summary',
  name: _TL_('Accounts summary'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'performance',
    name: _TL_('Performance'),
    route: 'accounts/performance',
    available: permissions => permissions.dynamic.WebUIVnext,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'management',
    name: _TL_('Management'),
    route: 'accounts/management',
    available: permissions => permissions.dynamic.WebUIVnext,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'requests',
    name: _TL_('Requests'),
    route: 'accounts/requests',
    available:
    /* istanbul ignore next */
    permissions => permissions.dynamic.WebUIVnext,
    checkPermission: permissions => permissions.IsRequestsTabEnabled,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'notifications',
    name: _TL_('Notifications'),
    route: 'accounts/notifications',
    available: permissions => permissions.dynamic.WebUIVnext,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'import',
    name: _TL_('Import'),
    route: 'accounts/import',
    available:
    /* istanbul ignore next */
    permissions => permissions.dynamic.WebUIVnext,
    checkPermission: permissions => permissions.IsAccountLevelImportStatusGridEnabled,
    scope: [_shared.Scope.Customer]
  }]
};
exports.accountsSummary = accountsSummary;

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overview = void 0;

var _shared = __webpack_require__(1327);

const overview = {
  id: 'accounts-overview',
  name: _TL_('Overview'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'accounts-overview',
    name: _TL_('Overview'),
    scope: [_shared.Scope.Customer],
    children: [{
      id: 'accounts-overview',
      name: _TL_('Overview'),
      route: 'accounts/overview',
      scope: [_shared.Scope.Customer],
      available: true
    }, {
      id: 'accounts-overview-expert',
      name: _TL_('Overview'),
      route: 'accounts/overview/expert',
      scope: [_shared.Scope.Customer],
      available: permissions => permissions.dynamic.UnifiedProductPhase2,
      checkPermission: permissions => permissions.dynamic.UnifiedProductPhase2,
      searchable: false
    }, {
      id: 'accounts-overview-smart',
      name: _TL_('Overview'),
      route: 'accounts/overview/smart',
      scope: [_shared.Scope.Customer],
      available: permissions => permissions.dynamic.UnifiedProductPhase2,
      checkPermission: permissions => permissions.dynamic.UnifiedProductPhase2,
      searchable: false
    }]
  }]
};
exports.overview = overview;

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendations = void 0;

var _shared = __webpack_require__(1327);

const recommendations = {
  id: 'recommendations',
  name: _TL_('Recommendations'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'All',
    name: _TL_('All'),
    route: 'accounts/recommendations/All',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'Repairs',
    name: _TL_('Repairs'),
    route: 'accounts/recommendations/Repairs',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'Bids',
    name: _TL_('Bidding & budgets'),
    route: 'accounts/recommendations/Bids',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'Keywords',
    name: _TL_('Keywords & targeting'),
    route: 'accounts/recommendations/Keywords',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'Ads',
    name: _TL_('Ads & extensions'),
    route: 'accounts/recommendations/Ads',
    scope: [_shared.Scope.Customer]
  }]
};
exports.recommendations = recommendations;

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auctionInsights = void 0;

var _shared = __webpack_require__(1327);

const auctionInsights = {
  id: 'accounts-auction-insights',
  name: _TL_('Auction insights'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'accounts-auction-insights',
    name: _TL_('Auction insights'),
    route: 'accounts/auctioninsights',
    scope: [_shared.Scope.Customer],
    checkPermission: permissions => permissions.IsMCCAuctionInsightsEnabledInMenu && !permissions.IsDomesticSimplifiedChineseEnabled
  }]
};
exports.auctionInsights = auctionInsights;

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignPages = void 0;

var _overview = __webpack_require__(1336);

var _recommendations = __webpack_require__(1337);

var _campaigns = __webpack_require__(1338);

var _adgroups = __webpack_require__(1339);

var _products = __webpack_require__(1340);

var _adsAndExtensions = __webpack_require__(1341);

var _assets = __webpack_require__(1342);

var _landingPages = __webpack_require__(1343);

var _dynamicAdTargets = __webpack_require__(1344);

var _feedsItems = __webpack_require__(1345);

var _keywords = __webpack_require__(1346);

var _productGroups = __webpack_require__(1347);

var _hotelGroups = __webpack_require__(1348);

var _hotels = __webpack_require__(1349);

var _audiences = __webpack_require__(1350);

var _demographics = __webpack_require__(1351);

var _settings = __webpack_require__(1352);

var _locations = __webpack_require__(1353);

var _adSchedule = __webpack_require__(1354);

var _devices = __webpack_require__(1355);

var _changeHistory = __webpack_require__(1356);

var _competition = __webpack_require__(1357);

var _experiments = __webpack_require__(1358);

var _smartCampaigns = __webpack_require__(1359);

var _queryInsights = __webpack_require__(1360);

var _assetGroups = __webpack_require__(1361);

var _listingGroups = __webpack_require__(1362);

const campaignPages = [_overview.overview, _recommendations.recommendations, _queryInsights.queryInsights, _campaigns.campaigns, _adgroups.adGroups, _assetGroups.assetGroups, _listingGroups.listingGroups, _products.products, _adsAndExtensions.adsAndExtensions, _assets.assets, _landingPages.landingPages, _keywords.keywords, _dynamicAdTargets.dynamicAdTargets, _feedsItems.feedsItems, _productGroups.productGroups, _hotelGroups.hotelGroups, _hotelGroups.propertyGroups, _hotels.hotels, _hotels.properties, _audiences.audiences, _demographics.demographics, _settings.settings, _locations.locations, _adSchedule.adSchedule, _devices.devices, _changeHistory.changeHistory, _competition.competition, _experiments.experiments, _smartCampaigns.smartCampaigns];
exports.campaignPages = campaignPages;

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overview = void 0;

var _shared = __webpack_require__(1327);

const overview = {
  id: 'overview',
  name: _TL_('Overview'),
  campaignTypes: _shared.alwaysDisplayed,
  scope: [_shared.Scope.Account, _shared.Scope.Campaign],
  children: [{
    id: 'overview',
    name: _TL_('Overview'),
    route: 'overview',
    campaignTypes: _shared.alwaysDisplayed,
    shortcut: 'g+o',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign]
  }]
};
exports.overview = overview;

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendations = void 0;

var _shared = __webpack_require__(1327);

const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const recommendations = {
  id: 'recommendations',
  name: _TL_('Recommendations'),
  hotelCampaignScope: [],
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel],
  adGroupTypes,
  shortcut: 'g+y',
  children: [{
    id: 'All',
    name: _TL_('All'),
    route: 'recommendations/All'
  }, {
    id: 'Repairs',
    name: _TL_('Repairs'),
    route: 'recommendations/Repairs'
  }, {
    id: 'Bids',
    name: _TL_('Bidding & budgets'),
    route: 'recommendations/Bids'
  }, {
    id: 'Keywords',
    name: _TL_('Keywords & targeting'),
    route: 'recommendations/Keywords'
  }, {
    id: 'Ads',
    name: _TL_('Ads & extensions'),
    route: 'recommendations/Ads'
  }, {
    id: 'Dismissed',
    name: _TL_('Dismissed'),
    route: 'recommendations/Dismissed'
  }]
};
exports.recommendations = recommendations;

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaigns = void 0;

var _shared = __webpack_require__(1327);

const campaigns = {
  id: 'campaigns',
  name: _TL_('Campaigns'),
  scope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'campaigns',
    name: _TL_('Campaigns'),
    route: 'campaigns',
    campaignTypes: _shared.alwaysDisplayed,
    shortcut: 'g+c',
    scope: [_shared.Scope.Account]
  }, {
    id: 'auction-insights',
    name: _TL_('Auction insights'),
    route: 'campaignsauction',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    checkPermission: permissions => !permissions.IsHideAuctionInsightsCompetitionUI && !permissions.IsDomesticSimplifiedChineseEnabled,
    scope: [_shared.Scope.Account]
  }]
};
exports.campaigns = campaigns;

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adGroups = void 0;

var _shared = __webpack_require__(1327);

const adGroups = {
  id: 'adgroups',
  name: _TL_('Ad groups'),
  scope: [_shared.Scope.Account, _shared.Scope.Campaign],
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel],
  children: [{
    id: 'adgroups',
    name: _TL_('Ad groups'),
    route: 'adgroups',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign],
    shortcut: 'g+j'
  }, {
    id: 'auction-insights',
    name: _TL_('Auction insights'),
    route: 'adgroupsauction',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    scope: [_shared.Scope.Account, _shared.Scope.Campaign],
    checkPermission: permissions => !permissions.IsHideAuctionInsightsCompetitionUI && !permissions.IsDomesticSimplifiedChineseEnabled
  }]
};
exports.adGroups = adGroups;

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.products = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const products = {
  id: 'products',
  name: _TL_('Products'),
  campaignTypes: [_shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.PerformanceMax],
  scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup],
  currentCampaign: campaign => _underscore.default.isEmpty(campaign) || _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.Shopping || _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.PerformanceMax || _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.Audience && _underscore.default.has(_underscore.default.take(campaign.CampaignSettings), 'ProviderId') && campaign.CampaignSubType !== 'AudienceDynamicFeedBased',
  children: [{
    id: 'products',
    name: _TL_('Products'),
    route: 'products',
    scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup]
  }]
};
exports.products = products;

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adsAndExtensions = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const campaignTypes = [_shared.CampaignType.Default, _shared.CampaignType.Shopping];
const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const apexViewName = 'extensions';
const supportAll = ['action', 'app', 'callout', 'image', 'price', 'review', 'sitelink', 'structuredsnippet', 'promotion', 'filterlink', 'flyer', 'video', 'businessinfo'];
const supportLevel = {
  account: [...supportAll, 'location', 'leadform'],
  campaign: [...supportAll, 'location', 'leadform'],
  adgroup: supportAll
};
const automatedExtensionsChildren = [{
  id: 'automated-extensions',
  name: _TL_('Automated extensions'),
  route: 'extensions/automated',
  campaignTypes,
  adGroupTypes
}, {
  id: 'image-annoation',
  name: _TL_('Image annotation'),
  route: 'extensions/imageannotation',
  searchAlias: _TL_('Automated extension - Image annotation'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.DynamicSearchAds],
  adGroupTypes
}];
const extensionChildrens = [{
  id: 'action',
  name: _TL_('Action extension'),
  route: 'extensions/action',
  searchAlias: _TL_('Ad extension - Action'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'app',
  name: _TL_('App extension'),
  route: 'extensions/app',
  searchAlias: _TL_('Ad extension - App'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'call',
  name: _TL_('Call extension'),
  route: 'extensions/call',
  searchAlias: _TL_('Ad extension - Call'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'callout',
  name: _TL_('Callout extension'),
  route: 'extensions/callout',
  searchAlias: _TL_('Ad extension - Callout'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Hotel, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'image',
  name: _TL_('Image extension'),
  route: 'extensions/image',
  searchAlias: _TL_('Ad extension - Image'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'location',
  name: _TL_('Location extension'),
  route: 'extensions/location',
  searchAlias: _TL_('Ad extension - Location'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'price',
  name: _TL_('Price extension'),
  route: 'extensions/price',
  searchAlias: _TL_('Ad extension - Price'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'review',
  name: _TL_('Review extension'),
  route: 'extensions/review',
  searchAlias: _TL_('Ad extension - Review'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'sitelink',
  name: _TL_('Sitelink extension'),
  route: 'extensions/sitelink',
  searchAlias: _TL_('Ad extension - Sitelink'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'structuredsnippet',
  name: _TL_('Structured snippet extension'),
  route: 'extensions/structuredsnippet',
  searchAlias: _TL_('Ad extension - Structured snippet'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  apexViewName
}, {
  id: 'promotion',
  name: _TL_('Promotion extension'),
  route: 'extensions/promotion',
  searchAlias: _TL_('Ad extension - Promotion'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'filterlink',
  name: _TL_('Filter link extension'),
  route: 'extensions/filterlink',
  searchAlias: _TL_('Ad extension - Filter'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'flyer',
  name: _TL_('Flyer extension'),
  route: 'extensions/flyer',
  searchAlias: _TL_('Ad extension - Flyer'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'video',
  name: _TL_('Video extension'),
  route: 'extensions/video',
  searchAlias: _TL_('Ad extension - Video'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'leadform',
  name: _TL_('Lead Form extension'),
  route: 'extensions/leadform',
  searchAlias: _TL_('Ad extension - Lead Form'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}, {
  id: 'businessinfo',
  name: _TL_('Business Info extension'),
  route: 'extensions/businessinfo',
  searchAlias: _TL_('Ad extension - Business Info Form'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.PerformanceMax],
  adGroupTypes,
  apexViewName
}];

const extensionChildrensWithLevels = _underscore.default.map(extensionChildrens, child => {
  const withLevel = [];

  _underscore.default.each(supportLevel, (value, key) => {
    if (_underscore.default.contains(value, child.id)) {
      const currentCampaignTypes = key === 'adgroup' ? _underscore.default.without(child.campaignTypes, _shared.CampaignType.PerformanceMax) : child.campaignTypes;
      withLevel.push({
        id: `${child.id}-${key}`,
        name: _TL_(''),
        // global search duplicate names
        route: `${child.route}/association/${key}`,
        campaignTypes: currentCampaignTypes,
        apexViewName
      });
    }
  });

  return withLevel;
});

const adsAndExtensions = {
  id: 'ads-and-extensions',
  name: _TL_('Ads & extensions'),
  children: [{
    id: 'ads',
    name: _TL_('Ads'),
    route: 'ads',
    shortcut: 'g+a',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel],
    adGroupTypes
  }, {
    id: 'assets-report',
    name: _TL_('Assets'),
    route: 'assets-report',
    checkPermission: permissions => permissions.dynamic.RSAAssets || permissions.IsRSAAssetsEnabled,
    scope: [_shared.Scope.Account],
    campaignTypes: [_shared.CampaignType.Default]
  }, {
    id: 'extensions',
    name: _TL_('Extensions'),
    route: 'extensions/sitelink',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Hotel, _shared.CampaignType.PerformanceMax],
    adGroupTypes,
    children: _underscore.default.flatten([extensionChildrens, extensionChildrensWithLevels]),
    shortcut: 'g+x',
    apexViewName
  }, {
    id: 'automated-extensions',
    name: _TL_('Automated extensions'),
    route: 'extensions/automated',
    campaignTypes,
    adGroupTypes,
    children: automatedExtensionsChildren
  }]
};
exports.adsAndExtensions = adsAndExtensions;

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assets = void 0;

var _shared = __webpack_require__(1327);

// The actual scope for assets page is ad scope. Correcting them in scopeV2
_shared.ScopeV2.add('Ad', 'adId', _shared.ScopeV2.AdGroup);

const assets = {
  id: 'responsive-search-ad',
  name: _TL_('Responsive search ad'),
  scope: [_shared.Scope.AdGroup],
  scopeV2: [_shared.ScopeV2.AdGroup, _shared.ScopeV2.Ad],
  children: [{
    id: 'assets',
    name: _TL_('Assets'),
    route: 'assets',
    searchable: false,
    scope: [_shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.AdGroup, _shared.ScopeV2.Ad]
  }, {
    id: 'combinations',
    name: _TL_('Combinations'),
    route: 'combinations',
    searchable: false,
    scope: [_shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.AdGroup, _shared.ScopeV2.Ad]
  }]
};
exports.assets = assets;

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.landingPages = void 0;

var _shared = __webpack_require__(1327);

const campaignTypes = [_shared.CampaignType.Default, _shared.CampaignType.Audience];
const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const landingPages = {
  id: 'landing-pages',
  name: _TL_('Landing pages'),
  route: 'landingpages',
  campaignTypes,
  adGroupTypes,
  children: [{
    id: 'landing-pages',
    name: _TL_('Landing pages'),
    route: 'landingpages',
    campaignTypes
  }]
};
exports.landingPages = landingPages;

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicAdTargets = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const dynamicAdTargets = {
  id: 'dsa',
  name: _TL_('Dynamic ad targets'),
  campaignTypes: campaignType => {
    const allowedCampaignTypes = [_shared.CampaignType.Default];

    const result = _underscore.default.some(allowedCampaignTypes, type => type === campaignType || type & campaignType); // eslint-disable-line no-bitwise


    return result;
  },
  adGroupTypes: [_shared.AdGroupType.SearchDynamic],
  currentCampaign: (campaign, permissions) => {
    const isDSAMixedModeCampaignEnabled = permissions.IsDSAMixedModeCampaignEnabled;

    if (!isDSAMixedModeCampaignEnabled) {
      return true;
    }

    return _underscore.default.isEmpty(campaign) || // if current campaign is search campaign with DSA settings added,
    // the dynamic ad targets pages should be available.
    _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.Default && _underscore.default.some(campaign.CampaignSettings, CampaignSettings => _underscore.default.has(CampaignSettings, 'DomainName')) && permissions.IsDSAMixedModeCampaignEnabled;
  },
  mixedModeAdGroup: (adgroup, _item, permissions) => {
    if (!permissions.IsDSAMixedModeCampaignEnabled) {
      return true;
    }

    if (_underscore.default.isEmpty(adgroup)) {
      return true;
    }

    return adgroup.AdGroupType === 'SearchDynamic';
  },
  checkPermission: permissions => permissions.dynamic.DynamicSearchAdsV1 || permissions.IsDynamicSearchAdsV1Enabled,
  children: [{
    id: 'dsa',
    name: _TL_('Dynamic ad targets'),
    route: 'dynamicadtargets/targets'
  }, {
    id: 'negative-dsa',
    name: _TL_('Negative dynamic ad targets'),
    children: [{
      id: 'negative-dsa-campaign',
      name: _TL_('Negative dynamic ad targets'),
      route: 'dynamicadtargets/negative/campaign'
    }, {
      id: 'negative-dsa-adgroup',
      name: _TL_(''),
      // global search duplicate names
      route: 'dynamicadtargets/negative/adgroup'
    }]
  }, {
    id: 'dsa-search-terms',
    name: _TL_('Search terms'),
    route: 'dynamicadtargets/searchterms'
  }]
};
exports.dynamicAdTargets = dynamicAdTargets;

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedsItems = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const feedsItems = {
  id: 'feeds-items',
  name: _TL_('Feed items'),
  scope: [_shared.Scope.Campaign],
  campaignTypes: [_shared.CampaignType.Audience],
  currentCampaign: campaign => _underscore.default.isEmpty(campaign) || _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.Audience && campaign.CampaignSubType === 'AudienceDynamicFeedBased' && campaign.CampaignSettings.length > 0 && (_underscore.default.has(campaign.CampaignSettings[0], 'FeedId') || _underscore.default.has(campaign.CampaignSettings[0], 'ProviderId')),
  children: [{
    id: 'feeds-items',
    name: _TL_('Feed items'),
    route: 'feeds/feeditems',
    checkPermission: permissions => permissions.IsEnabledForDynamicFeedCampaign
  }]
};
exports.feedsItems = feedsItems;

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keywords = void 0;

var _shared = __webpack_require__(1327);

const keywords = {
  id: 'keywords',
  name: _TL_('Keywords'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
  adGroupTypes: [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic],
  smartShoppingCampaignScope: [_shared.Scope.Account],
  children: [{
    id: 'keywords',
    name: _TL_('Keywords'),
    route: 'keywords',
    campaignTypes: [_shared.CampaignType.Default],
    shortcut: 'g+k'
  }, {
    id: 'negative-keywords',
    name: _TL_('Negative keywords'),
    route: 'negative-keywords',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    adGroupTypes: [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic]
  }, {
    id: 'negative-keywords-lists',
    name: _TL_('Negative keywords lists'),
    route: 'negativekeywordslists',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    adGroupTypes: [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic]
  }, {
    id: 'search-terms',
    name: _TL_('Search terms'),
    route: 'searchterms',
    exact: false,
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping]
  }, {
    id: 'auction-insights',
    name: _TL_('Auction insights'),
    route: 'keywordsauction',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    checkPermission: permissions => !permissions.IsHideAuctionInsightsCompetitionUI && !permissions.IsDomesticSimplifiedChineseEnabled
  }]
};
exports.keywords = keywords;

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productGroups = void 0;

var _shared = __webpack_require__(1327);

const productGroups = {
  id: 'product-groups',
  name: _TL_('Product groups'),
  campaignTypes: [_shared.CampaignType.Shopping],
  scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  checkPermission: permissions => permissions.dynamic.ShoppingCampaignsV2,
  children: [{
    id: 'product-groups',
    name: _TL_('Product groups'),
    route: 'productgroups/hierarchy',
    children: [{
      id: 'hierarchy',
      name: _TL_('Product groups'),
      route: 'productgroups/hierarchy'
    }, {
      id: 'list',
      name: _TL_('List View'),
      route: 'productgroups/list'
    }]
  }]
};
exports.productGroups = productGroups;

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyGroups = exports.hotelGroups = void 0;

var _shared = __webpack_require__(1327);

const hotelGroups = {
  id: 'hotel-groups',
  name: _TL_('Hotel groups'),
  campaignTypes: [_shared.CampaignType.Hotel],
  scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  checkPermission: permissions => permissions.dynamic.HotelCampaign && !permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'hotel-groups',
    name: _TL_('Hotel groups'),
    route: 'hotelgroups/hierarchy',
    children: [{
      id: 'hierarchy',
      name: _TL_('Hotel groups'),
      route: 'hotelgroups/hierarchy'
    }, {
      id: 'list',
      name: _TL_('List View'),
      route: 'hotelgroups/list'
    }]
  }]
};
exports.hotelGroups = hotelGroups;
const propertyGroups = {
  id: 'property-groups',
  name: _TL_('Property groups'),
  campaignTypes: [_shared.CampaignType.Hotel],
  scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  checkPermission: permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'property-groups',
    name: _TL_('Property groups'),
    route: 'propertygroups/hierarchy',
    children: [{
      id: 'hierarchy',
      name: _TL_('Property groups'),
      route: 'propertygroups/hierarchy'
    }, {
      id: 'list',
      name: _TL_('List View'),
      route: 'propertygroups/list'
    }]
  }]
};
exports.propertyGroups = propertyGroups;

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = exports.hotels = void 0;

var _shared = __webpack_require__(1327);

const hotels = {
  id: 'hotels',
  name: _TL_('Hotels'),
  campaignTypes: [_shared.CampaignType.Hotel],
  scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup],
  checkPermission: permissions => permissions.dynamic.HotelCampaign && !permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'hotels',
    name: _TL_('Hotels'),
    route: 'hotels',
    scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup]
  }]
};
exports.hotels = hotels;
const properties = {
  id: 'properties',
  name: _TL_('Properties'),
  campaignTypes: [_shared.CampaignType.Hotel],
  scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup],
  checkPermission: permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'properties',
    name: _TL_('Properties'),
    route: 'properties',
    scope: [_shared.Scope.Campaign, _shared.Scope.AdGroup]
  }]
};
exports.properties = properties;

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audiences = void 0;

var _shared = __webpack_require__(1327);

const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const audiences = {
  id: 'audiences',
  name: _TL_('Audiences'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel],
  adGroupTypes,
  smartShoppingCampaignScope: [_shared.Scope.Account],
  children: [{
    id: 'audiences',
    name: _TL_('Audiences'),
    route: 'audiences',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup]
  }]
};
exports.audiences = audiences;

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demographics = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const demographicsChildrens = [{
  id: 'age',
  name: _TL_('Age'),
  route: 'demographics/age'
}, {
  id: 'gender',
  name: _TL_('Gender'),
  route: 'demographics/gender'
}, {
  id: 'company',
  name: _TL_('Company'),
  route: 'demographics/company',
  currentCampaign: campaign => _underscore.default.isEmpty(campaign) || campaign.CampaignSubType !== 'BrandAwarenessVideoAds',
  checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled
}, {
  id: 'industry',
  name: _TL_('Industry'),
  route: 'demographics/industry',
  currentCampaign: campaign => _underscore.default.isEmpty(campaign) || campaign.CampaignSubType !== 'BrandAwarenessVideoAds',
  checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled
}, {
  id: 'job-function',
  name: _TL_('Job function'),
  route: 'demographics/jobfunction',
  currentCampaign: campaign => _underscore.default.isEmpty(campaign) || campaign.CampaignSubType !== 'BrandAwarenessVideoAds',
  checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled
}];

const demographicsWithLevels = _underscore.default.map(demographicsChildrens, child => ({
  id: child.id,
  name: child.name,
  currentCampaign: child.currentCampaign,
  checkPermission: child.checkPermission,
  children: [child, {
    id: `${child.id}-campaign`,
    name: child.name,
    route: `${child.route}/campaign`,
    apexViewName: child.route,
    checkPermission: permissions => permissions.dynamic.LinkedInTargeting,
    searchable: false
  }, {
    id: `${child.id}-adgroup`,
    name: child.name,
    route: `${child.route}/adgroup`,
    apexViewName: child.route,
    searchable: false,
    currentCampaign: child.currentCampaign
  }]
}));

const demographics = {
  id: 'demographics',
  name: _TL_('Demographics'),
  smartShoppingCampaignScope: [_shared.Scope.Account],
  hotelCampaignScope: [],
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel],
  adGroupTypes,
  checkPermission: permissions => permissions.dynamic.AIMCampaign || permissions.dynamic.LinkedInTargeting,
  currentCampaign: (campaign, permissions) => permissions.dynamic.LinkedInTargeting || _underscore.default.isEmpty(campaign) || _underscore.default.result(_shared.CampaignType, campaign.CampaignType) === _shared.CampaignType.Audience,
  children: demographicsWithLevels
};
exports.demographics = demographics;

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;

var _shared = __webpack_require__(1327);

const settings = {
  id: 'settings',
  name: _TL_('Settings'),
  campaignTypes: _shared.alwaysDisplayed,
  smartShoppingCampaignScope: [_shared.Scope.Account, _shared.Scope.Campaign],
  children: [{
    id: 'campaign-settings',
    name: _TL_('Campaign settings'),
    route: 'settings',
    scope: [_shared.Scope.Campaign],
    shortcut: 'g+s'
  }, {
    id: 'adgroup-settings',
    name: _TL_('Ad group settings'),
    route: 'settings',
    scope: [_shared.Scope.AdGroup],
    shortcut: 'g+s'
  }, {
    id: 'settings',
    name: _TL_('Settings'),
    route: 'settings',
    scope: [_shared.Scope.Account],
    shortcut: 'g+s'
  }, {
    id: 'account-settings',
    name: _TL_('Account level options'),
    route: 'accountsettings',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Account]
  }]
};
exports.settings = settings;

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locations = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const campaignTypes = [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel];
const locations = {
  id: 'locations',
  name: _TL_('Locations'),
  smartShoppingCampaignScope: [_shared.Scope.Account, _shared.Scope.Campaign],
  hotelCampaignScope: [_shared.Scope.Account, _shared.Scope.Campaign],
  children: [{
    id: 'targeted',
    name: _TL_('Targeted'),
    children: [{
      id: 'targeted',
      name: _TL_('Targeted'),
      route: 'locations'
    }, {
      id: 'targeted-campaign',
      name: _TL_('Targeted'),
      route: 'locations/campaign',
      searchable: false
    }, {
      id: 'targeted-adgroup',
      name: _TL_('Targeted'),
      route: 'locations/adgroup',
      searchable: false
    }]
  }, {
    id: 'excluded',
    name: _TL_('Excluded'),
    currentCampaign: (campaign, permissions) => {
      if (_underscore.default.isEmpty(campaign)) {
        return true;
      }

      if (campaign.CampaignSubType === 'BrandAwarenessVideoAds' || campaign.CampaignSubType === 'DisplayAds') {
        if (!_underscore.default.result(permissions, ['dynamic', 'XandrNegativeTarget'], false)) {
          return false;
        }
      }

      return true;
    },
    children: [{
      id: 'excluded',
      name: _TL_('Excluded'),
      route: 'excluded'
    }, {
      id: 'excluded-campaign',
      name: _TL_('Excluded'),
      route: 'excluded/campaign',
      searchable: false
    }, {
      id: 'excluded-adgroup',
      name: _TL_('Excluded'),
      route: 'excluded/adgroup',
      searchable: false
    }]
  }, {
    id: 'geographic-report',
    name: _TL_('Geographic report'),
    route: 'geographicreport',
    campaignTypes
  }, {
    id: 'user-location-report',
    name: _TL_('User location report'),
    route: 'userlocationreport',
    campaignTypes
  }]
};
exports.locations = locations;

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adSchedule = void 0;

var _shared = __webpack_require__(1327);

const campaignTypes = [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel];
const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const adSchedule = {
  id: 'ad-schedule',
  name: _TL_('Ad schedule'),
  campaignTypes,
  adGroupTypes,
  smartShoppingCampaignScope: [_shared.Scope.Account, _shared.Scope.Campaign],
  hotelCampaignScope: [_shared.Scope.Account, _shared.Scope.Campaign],
  children: [{
    id: 'ad-schedule',
    name: _TL_('Ad schedule'),
    children: [{
      id: 'ad-schedule',
      name: _TL_('Ad schedule'),
      route: 'adschedule'
    }, {
      id: 'ad-schedule-campaign',
      name: _TL_('Ad schedule'),
      route: 'adschedule/campaign',
      searchable: false
    }, {
      id: 'ad-schedule-adgroup',
      name: _TL_('Ad schedule'),
      route: 'adschedule/adgroup',
      searchable: false
    }]
  }, {
    id: 'adschedule-day',
    name: _TL_('Day'),
    route: 'adscheduleday'
  }, {
    id: 'adschedule-hour',
    name: _TL_('Hour'),
    route: 'adschedulehour'
  }, {
    id: 'adschedule-date',
    name: _TL_('Date'),
    route: 'adscheduledate'
  }, {
    id: 'adschedule-week',
    name: _TL_('Week'),
    route: 'adscheduleweek'
  }, {
    id: 'adschedule-month',
    name: _TL_('Month'),
    route: 'adschedulemonth'
  }, {
    id: 'adschedule-quarter',
    name: _TL_('Quarter'),
    route: 'adschedulequarter'
  }, {
    id: 'adschedule-year',
    name: _TL_('Year'),
    route: 'adscheduleyear'
  }]
};
exports.adSchedule = adSchedule;

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMSStoreIdByEnv = getMSStoreIdByEnv;
exports.devices = exports.MS_STORE_PROVIDER_ID_MAP = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const campaignTypes = [_shared.CampaignType.Default, _shared.CampaignType.Shopping, _shared.CampaignType.Audience, _shared.CampaignType.DynamicSearchAds, _shared.CampaignType.Smart, _shared.CampaignType.Hotel];
const adGroupTypes = [_shared.AdGroupType.SearchStandard, _shared.AdGroupType.SearchDynamic];
const MS_STORE_PROVIDER_ID_MAP = {
  SI: [10624440, 5104030, 5353239],
  PROD: [182978],
  CI: [108]
};
exports.MS_STORE_PROVIDER_ID_MAP = MS_STORE_PROVIDER_ID_MAP;

function getMSStoreIdByEnv(url) {
  if (url.includes('redmond.corp.microsoft.com')) {
    return MS_STORE_PROVIDER_ID_MAP.CI;
  }

  if (url.includes('ads-int.microsoft.com') || url.includes('si.bingads.microsoft.com')) {
    return MS_STORE_PROVIDER_ID_MAP.SI;
  }

  return MS_STORE_PROVIDER_ID_MAP.PROD;
}

const devices = {
  id: 'devices',
  name: _TL_('Devices'),
  campaignTypes,
  adGroupTypes,
  smartShoppingCampaignScope: [_shared.Scope.Account],
  currentCampaign: (campaign, permissions) => {
    if (campaign == null) {
      return true;
    }

    const isMSStoreAdsGAEnabled = _underscore.default.chain(permissions).result('dynamic').result('MSStoreAdsGA').value() && _underscore.default.chain(permissions).result('dynamic').result('WindowsStoreAds').value();

    if (!isMSStoreAdsGAEnabled) {
      return true;
    }

    const msStoreIds = getMSStoreIdByEnv(window.location.href);

    const providerId = _underscore.default.chain(campaign).result('CampaignSettings').result('0').result('ProviderId').value();

    const result = !(isMSStoreAdsGAEnabled && msStoreIds.some(id => String(id) === String(providerId)));
    return result;
  },
  children: [{
    id: 'devices',
    name: _TL_('Devices'),
    children: [{
      id: 'devices',
      name: _TL_('Devices'),
      route: 'devices'
    }, {
      id: 'devices-campaign',
      name: _TL_('Devices'),
      route: 'devices/campaign',
      searchable: false
    }, {
      id: 'devices-adgroup',
      name: _TL_('Devices'),
      route: 'devices/adgroup',
      searchable: false
    }]
  }]
};
exports.devices = devices;

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeHistory = void 0;

var _shared = __webpack_require__(1327);

const changeHistory = {
  id: 'change-history',
  name: _TL_('Change history'),
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'change-history',
    name: _TL_('Change history'),
    route: 'changehistory',
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.changeHistory = changeHistory;

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.competition = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('RecSrc', 'recsrc', _shared.ScopeV2.Account);

_shared.ScopeV2.add('RecSrc', 'recsrc', _shared.ScopeV2.Campaign);

_shared.ScopeV2.add('RecSrc', 'recsrc', _shared.ScopeV2.AdGroup);

const scopeV2 = [_shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup, _shared.ScopeV2.RecSrc];
const competition = {
  id: 'competition',
  name: _TL_('Competition'),
  campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
  checkPermission: permissions => !permissions.IsHideAuctionInsightsCompetitionUI && !permissions.IsDomesticSimplifiedChineseEnabled,
  scopeV2,
  children: [{
    id: 'auction-insights',
    name: _TL_('Auction insights'),
    route: 'competitionauction',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    scopeV2
  }, {
    id: 'competition-recommendations',
    name: _TL_('Deeper insights and actions'),
    route: 'competitionrecommendations',
    campaignTypes: [_shared.CampaignType.Default, _shared.CampaignType.Shopping],
    scopeV2
  }]
};
exports.competition = competition;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experiments = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const isExperiment = campaign => campaign && campaign.ExperimentId > 0;

const isSearchCampaignWithDSASettings = (campaign, permissions) => {
  const isDSAMixedModeCampaignEnabled = _underscore.default.result(permissions, 'IsDSAMixedModeCampaignEnabled', false);

  if (!isDSAMixedModeCampaignEnabled) {
    return false;
  }

  const domainName = _underscore.default.chain(campaign).result('CampaignSettings').result('0').result('DomainName').value();

  if (domainName) {
    return true;
  }

  return false;
};

const experiments = {
  id: 'experiments',
  name: _TL_('Experiments'),
  scope: [_shared.Scope.Account, _shared.Scope.Campaign],
  campaignTypes: [_shared.CampaignType.Default],
  currentCampaign: (campaign, permissions) => (_underscore.default.isEmpty(campaign) || !isExperiment(campaign)) && !isSearchCampaignWithDSASettings(campaign, permissions),
  children: [{
    id: 'experiments',
    name: _TL_('Experiments'),
    route: 'experiments',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign]
  }]
};
exports.experiments = experiments;

/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartCampaigns = void 0;

var _shared = __webpack_require__(1327);

const smartCampaigns = {
  id: 'smart-campaigns',
  name: _TL_('Smart Campaigns'),
  campaignTypes: _shared.alwaysDisplayed,
  isSmartPage: true,
  children: [{
    id: 'smart-campaigns',
    name: _TL_('Smart Campaigns'),
    route: 'smartcampaigns',
    campaignTypes: _shared.alwaysDisplayed,
    isSmartPage: true
  }]
};
exports.smartCampaigns = smartCampaigns;

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryInsights = void 0;

var _shared = __webpack_require__(1327);

const queryInsights = {
  id: 'query-insights',
  name: _TL_('Search insights'),
  checkPermission: permissions => permissions.IsQueryInsightsEnabled,
  campaignTypes: [_shared.CampaignType.Default],
  scope: [_shared.Scope.Account],
  showTag: {
    text: _TL_('New'),
    expDate: new Date('2022/12/31')
  },
  children: [{
    id: 'account-optimization',
    name: _TL_('Account optimization'),
    route: 'accountoptimization',
    checkPermission: permissions => permissions.IsQueryInsightsEnabled,
    campaignTypes: [_shared.CampaignType.Default],
    scope: [_shared.Scope.Account]
  }, {
    id: 'new-opportunities',
    name: _TL_('New opportunities'),
    route: 'newopportunities',
    checkPermission: permissions => permissions.IsQueryInsightsEnabled,
    campaignTypes: [_shared.CampaignType.Default],
    scope: [_shared.Scope.Account]
  }]
};
exports.queryInsights = queryInsights;

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetGroups = void 0;

var _shared = __webpack_require__(1327);

const assetGroups = {
  id: 'asset-groups',
  name: _TL_('Asset groups'),
  campaignTypes: [_shared.CampaignType.PerformanceMax],
  scope: [_shared.Scope.Campaign],
  checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns,
  children: [{
    id: 'asset-groups',
    name: _TL_('Asset groups'),
    route: 'assetgroups',
    scope: [_shared.Scope.Campaign],
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }]
};
exports.assetGroups = assetGroups;

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listingGroups = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('AssetGroup', 'assetGroupId', _shared.ScopeV2.Campaign);

const listingGroups = {
  id: 'listing-groups',
  name: _TL_('Listing groups'),
  campaignTypes: [_shared.CampaignType.PerformanceMax],
  scope: [_shared.Scope.Campaign],
  scopeV2: [_shared.ScopeV2.AssetGroup],
  checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns,
  children: [{
    id: 'listing-groups',
    name: _TL_('Listing groups'),
    route: 'listinggroups/list',
    scope: [_shared.Scope.Campaign],
    scopeV2: [_shared.ScopeV2.AssetGroup],
    children: [{
      id: 'hierarchy',
      name: _TL_('Listing groups'),
      route: 'listinggroups/hierarchy'
    }, {
      id: 'list',
      name: _TL_('List View'),
      route: 'listinggroups/list'
    }]
  }]
};
exports.listingGroups = listingGroups;

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatSetupPages = exports.toolsPages = exports.flatSmartToolsPages = exports.flatToolsPages = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

var _planning = __webpack_require__(1364);

var _index = __webpack_require__(1365);

var _bulkActions = __webpack_require__(1378);

var _conversionTracking = __webpack_require__(1383);

var _index2 = __webpack_require__(1388);

var _app = __webpack_require__(1434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const toolsPages = [_planning.planning, ..._index.sharedLibrary, _bulkActions.bulkActions, ..._conversionTracking.conversionTracking, ..._index2.setup];
exports.toolsPages = toolsPages;
const flatSharedLibrary = {
  id: 'shared-library',
  name: _TL_('Shared Library'),
  oldUIScope: [_shared.Scope.Account]
};
flatSharedLibrary.children = _index.sharedLibrary;
const flatSetup = {
  id: 'setup',
  name: _TL_('Setup'),
  oldUIScope: [_shared.Scope.Account]
};
flatSetup.children = _underscore.default.flatten(_underscore.default.map(_index2.setup, value => value.children[0]));
const flatConversionTracking = {
  id: 'conversion-tracking',
  name: _TL_('Conversion tracking'),
  oldUIScope: [_shared.Scope.Account],
  children: _underscore.default.flatten(_underscore.default.map(_conversionTracking.conversionTracking, value => value.children[0]))
};
const flatToolsPages = [_planning.planning, flatSharedLibrary, _bulkActions.bulkActions, flatConversionTracking, flatSetup];
exports.flatToolsPages = flatToolsPages;
const flatSmartToolsPages = [flatSetup, _app.mobileApp];
exports.flatSmartToolsPages = flatSmartToolsPages;
const flatSetupPages = [flatSetup];
exports.flatSetupPages = flatSetupPages;

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.planning = exports.keywordPlanner = exports.audiencePlanner = void 0;

var _shared = __webpack_require__(1327);

const audiencePlanner = {
  id: 'audience-planner',
  name: _TL_('Audience network planner'),
  route: 'audienceplanner',
  checkPermission: permissions => permissions.dynamic.AIMCampaign
};
exports.audiencePlanner = audiencePlanner;
const keywordPlanner = {
  id: 'keyword-planner',
  name: _TL_('Keyword planner'),
  route: 'keywordplanner',
  showTag: {
    text: _TL_('BETA'),
    expDate: new Date('2023/03/31')
  },
  tagClass: 'blueTag'
};
exports.keywordPlanner = keywordPlanner;
const planning = {
  id: 'planning',
  name: _TL_('Planning'),
  oldUIScope: [_shared.Scope.Account],
  children: [keywordPlanner, {
    id: 'bid-strategies',
    name: _TL_('Bid strategies'),
    route: 'bidstrategies',
    showTag: _TL_('New'),
    checkPermission: permissions => permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions
  }, {
    id: 'ad-preview',
    name: _TL_('Ad preview & diagnostics'),
    route: 'adpreview',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup]
  }, audiencePlanner]
};
exports.planning = planning;

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedLibrary = void 0;

var _audiencesLibrary = __webpack_require__(1366);

var _businessLocationFeed = __webpack_require__(1367);

var _productFeed = __webpack_require__(1368);

var _labels = __webpack_require__(1369);

var _negativeKeywordListsLibrary = __webpack_require__(1370);

var _performanceTargets = __webpack_require__(1371);

var _siteExclusionListsAccountLevelViewLists = __webpack_require__(1372);

var _siteExclusionListsCustomerLevelCreateLists = __webpack_require__(1373);

var _sharedBudgets = __webpack_require__(1374);

var _portfolioBidStrategy = __webpack_require__(1375);

var _seasonalityAdjustment = __webpack_require__(1376);

var _creativeStudioAssetLibrary = __webpack_require__(1377);

const sharedLibrary = [_creativeStudioAssetLibrary.creativeStudioAssetLibraryPage, _productFeed.ProductFeedPage, _productFeed.SponsoredProductsPage, _productFeed.MicrosoftStoreAdsPageGA, _audiencesLibrary.audiencesLibraryPages, _businessLocationFeed.businessLocationFeedPages, _labels.labelsPage, _negativeKeywordListsLibrary.negativeKeywordListsLibraryPage, _performanceTargets.performanceTargetsPage, _siteExclusionListsAccountLevelViewLists.siteExclusionListsAccountLevelViewListsPage, _siteExclusionListsCustomerLevelCreateLists.siteExclusionListsCustomerLevelCreateListsPage, _sharedBudgets.sharedBudgetsPage, _portfolioBidStrategy.portfolioBidStrategyPage, _seasonalityAdjustment.seasonalityAdjustmentPage];
exports.sharedLibrary = sharedLibrary;

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audiencesLibraryPages = void 0;

var _shared = __webpack_require__(1327);

const scope = [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup];
const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup];
const audiencesLibraryPages = {
  id: 'audiences-library',
  name: _TL_('Audiences'),
  oldUIScope: [_shared.Scope.Customer, _shared.Scope.Account],
  scope,
  scopeV2,
  children: [{
    id: 'audiences-library',
    name: _TL_('Audiences'),
    route: 'audienceslibrary',
    scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup]
  }]
};
exports.audiencesLibraryPages = audiencesLibraryPages;

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessLocationFeedPages = exports.businessLocationFeed = void 0;

var _shared = __webpack_require__(1327);

const businessLocationFeed = [{
  id: 'business-location-feed',
  name: _TL_('Business location feed'),
  route: 'businesslocationfeed',
  checkPermission: permissions => permissions.dynamic.GoogleMyBusinessImport || permissions.IsLocalInventoryAdsEnabled
}];
exports.businessLocationFeed = businessLocationFeed;
const businessLocationFeedPages = {
  id: 'business-location-feed',
  name: _TL_('Business location feed'),
  oldUIScope: [_shared.Scope.Account],
  children: businessLocationFeed
};
exports.businessLocationFeedPages = businessLocationFeedPages;

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrosoftStoreAdsPageGA = exports.SponsoredProductsPage = exports.ProductFeedPage = void 0;

var _shared = __webpack_require__(1327);

const ProductFeedPage = {
  id: 'product-feed',
  name: _TL_('Product feeds'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'product-feed',
    name: _TL_('Product feeds'),
    route: 'productfeed',
    checkPermission: permissions => permissions.dynamic.CoOpCampaign && !permissions.dynamic.SponsoredProductAdsV2
  }, {
    id: 'linked-store',
    name: _TL_('Linked stores'),
    route: 'linkedstore',
    checkPermission: permissions => permissions.dynamic.CoOpCampaign && !permissions.dynamic.SponsoredProductAdsV2
  }]
};
exports.ProductFeedPage = ProductFeedPage;
const SponsoredProductsPage = {
  id: 'sponsored-products',
  name: _TL_('Shopping for brands'),
  oldUIScope: [_shared.Scope.Account],
  route: 'feedsummary',
  checkPermission: permissions => permissions.dynamic.SponsoredProductAdsV2,
  children: [{
    id: 'feed-summary',
    name: _TL_('Overview'),
    route: 'feedsummary',
    checkPermission: permissions => permissions.dynamic.SponsoredProductAdsV2
  }, {
    id: 'brand',
    name: _TL_('Brands'),
    route: 'brand',
    checkPermission: permissions => permissions.dynamic.SponsoredProductAdsV2 && !permissions.IsSPAAndSPBSimplificationEnabled
  }, {
    id: 'linked-store',
    name: _TL_('Retail partners'),
    route: 'linkedstore',
    checkPermission: permissions => permissions.dynamic.SponsoredProductAdsV2 && !permissions.dynamic.SponsoredPromotionsByBrands && !permissions.dynamic.SpaViaNewMmcApi && !permissions.IsSPAAndSPBSimplificationEnabled
  }]
};
exports.SponsoredProductsPage = SponsoredProductsPage;
const MicrosoftStoreAdsPageGA = {
  id: 'ms-store-ads',
  name: _TL_('Microsoft Store Ads'),
  children: [{
    id: 'ms-store-ads-seller-ids',
    name: _TL_('Microsoft Store Ads'),
    route: 'msstoreads',
    checkPermission: permissions => permissions.dynamic.WindowsStoreAds
  }]
};
exports.MicrosoftStoreAdsPageGA = MicrosoftStoreAdsPageGA;

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelsPage = void 0;

var _shared = __webpack_require__(1327);

const labelsPage = {
  id: 'labels',
  name: _TL_('Labels'),
  scope: permissions => permissions.IsAccountLabelsEnabled ? [_shared.Scope.Account, _shared.Scope.Customer] : [_shared.Scope.Account],
  scopeV2: permissions => permissions.IsAccountLabelsEnabled ? [_shared.ScopeV2.Account, _shared.ScopeV2.Customer] : [_shared.ScopeV2.Account],
  children: [{
    id: 'labels',
    name: _TL_('Labels'),
    route: 'labels',
    checkPermission: permissions => !permissions.IsAccountLabelsEnabled,
    scope: [_shared.Scope.Account]
  }, {
    id: 'labels',
    name: _TL_('Labels'),
    route: 'labels',
    checkPermission: permissions => permissions.IsAccountLabelsEnabled,
    scope: [_shared.Scope.Customer, _shared.Scope.Account]
  }, {
    id: 'labels-report',
    name: _TL_('Labels report'),
    scope: permissions => permissions.IsAccountLabelsEnabled ? [_shared.Scope.Account, _shared.Scope.Customer] : [_shared.Scope.Account],
    scopeV2: permissions => permissions.IsAccountLabelsEnabled ? [_shared.ScopeV2.Account, _shared.ScopeV2.Customer] : [_shared.ScopeV2.Account],
    children: [{
      id: 'labels-campaigns',
      name: _TL_('Campaigns'),
      route: 'labelscampaign',
      ariaDescription: _TL_('Labels report by campaigns'),
      scope: [_shared.Scope.Account]
    }, {
      id: 'labels-ad-groups',
      name: _TL_('Ad groups'),
      route: 'labelsadgroup',
      ariaDescription: _TL_('Labels report by ad groups'),
      scope: [_shared.Scope.Account]
    }, {
      id: 'labels-keywords',
      name: _TL_('Keywords'),
      route: 'labelskeyword',
      ariaDescription: _TL_('Labels report by keywords'),
      scope: [_shared.Scope.Account]
    }, {
      id: 'labels-ads',
      name: _TL_('Ads'),
      route: 'labelsad',
      ariaDescription: _TL_('Labels report by ads'),
      scope: [_shared.Scope.Account]
    }, {
      id: 'labels-account',
      name: _TL_('Accounts'),
      route: 'labelsaccount',
      ariaDescription: _TL_('Labels report by accounts'),
      checkPermission: permissions => permissions.IsAccountLabelsEnabled,
      scope: [_shared.Scope.Customer]
    }]
  }]
};
exports.labelsPage = labelsPage;

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.negativeKeywordListsLibraryPage = exports.negativeKeyword = void 0;

var _shared = __webpack_require__(1327);

const negativeKeyword = {
  id: 'negative-keyword-lists-library',
  name: _TL_('Negative keyword lists'),
  route: 'negativekeywordlistslibrary',
  scope: [_shared.Scope.Account]
};
exports.negativeKeyword = negativeKeyword;
const negativeKeywordListsLibraryPage = {
  id: 'negative-keyword-lists-library',
  name: _TL_('Negative keyword lists'),
  oldUIScope: [_shared.Scope.Account],
  children: [negativeKeyword]
};
exports.negativeKeywordListsLibraryPage = negativeKeywordListsLibraryPage;

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTargetsPage = exports.performanceTargets = void 0;

var _shared = __webpack_require__(1327);

const performanceTargets = {
  id: 'performance-targets',
  name: _TL_('Performance Targets'),
  route: 'performancetargets',
  scope: [_shared.Scope.Account]
};
exports.performanceTargets = performanceTargets;
const performanceTargetsPage = {
  id: 'performance-targets',
  name: _TL_('Performance targets'),
  oldUIScope: [_shared.Scope.Account],
  children: [performanceTargets]
};
exports.performanceTargetsPage = performanceTargetsPage;

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteExclusionListsAccountLevelViewListsPage = exports.siteExclusionViewLists = void 0;

var _shared = __webpack_require__(1327);

const siteExclusionViewLists = {
  id: 'site-exclusion-lists-entrypoint',
  name: _TL_('Website exclusion lists'),
  scope: _shared.defaultScopes,
  route: 'siteexclusionlists/viewlists',
  checkPermission: permissions => permissions.IsManagerAccountSharedWebsiteExclusionsEnabled,
  searchAlias: _TL_('View website exclusion lists')
};
exports.siteExclusionViewLists = siteExclusionViewLists;
const siteExclusionListsAccountLevelViewListsPage = {
  id: 'site-exclusion-lists-entrypoint',
  name: _TL_('Website exclusion lists'),
  // Allows entry to account-level SEL view lists page from tools menu unless if at customer scope
  scope: _shared.defaultScopes,
  children: [siteExclusionViewLists, {
    id: 'site-exclusion-list-account-level-exclusions',
    name: _TL_('Website exclusion lists'),
    scope: _shared.defaultScopes,
    route: 'siteexclusionlists/viewexclusions',
    checkPermission: permissions => permissions.IsManagerAccountSharedWebsiteExclusionsEnabled,
    searchable: false
  }]
};
exports.siteExclusionListsAccountLevelViewListsPage = siteExclusionListsAccountLevelViewListsPage;

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteExclusionListsCustomerLevelCreateListsPage = exports.siteExclusionListCreate = void 0;

var _shared = __webpack_require__(1327);

const siteExclusionListCreate = {
  id: 'site-exclusion-lists-entrypoint',
  name: _TL_('Website exclusion lists'),
  scope: [_shared.Scope.Customer],
  route: 'siteexclusionlists/create',
  // CustomerHierarchy is needed for the multi-account-selector used in this page.
  checkPermission: permissions => permissions.IsManagerAccountSharedWebsiteExclusionsEnabled,
  searchAlias: _TL_('Create website exclusion lists')
};
exports.siteExclusionListCreate = siteExclusionListCreate;
const siteExclusionListsCustomerLevelCreateListsPage = {
  id: 'site-exclusion-lists-entrypoint',
  name: _TL_('Website exclusion lists'),
  // Enforce customer-level scope when routing to customer-level SiteExclusionLists pages
  scope: [_shared.Scope.Customer],
  children: [siteExclusionListCreate, {
    id: 'site-exclusion-list-customer-edit',
    name: _TL_('Website exclusion lists'),
    scope: [_shared.Scope.Customer],
    route: 'siteexclusionlists/edit',
    // CustomerHierarchy is needed for the multi-account-selector used in this page.
    checkPermission: permissions => permissions.IsManagerAccountSharedWebsiteExclusionsEnabled,
    searchable: false
  }]
};
exports.siteExclusionListsCustomerLevelCreateListsPage = siteExclusionListsCustomerLevelCreateListsPage;

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedBudgetsPage = void 0;

var _shared = __webpack_require__(1327);

const sharedBudgetsPage = {
  id: 'shared-budgets',
  name: _TL_('Shared budgets'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'shared-budgets',
    name: _TL_('Shared budgets'),
    route: 'sharedbudgets'
  }]
};
exports.sharedBudgetsPage = sharedBudgetsPage;

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portfolioBidStrategyPage = exports.portfolioBid = void 0;
const portfolioBid = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'),
  // Show in summary bar and page title
  route: 'portfoliobidstrategy',
  checkPermission: permissions => permissions.dynamic.PortfolioBidStrategy // moved to sub-item under "planning/bid-strategies" rather than standlong item
  && !(permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions)
};
exports.portfolioBid = portfolioBid;
const portfolioBidStrategyPage = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'),
  // Show in tools menu
  children: [portfolioBid]
};
exports.portfolioBidStrategyPage = portfolioBidStrategyPage;

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seasonalityAdjustmentPage = exports.seasonalityAdjustment = void 0;

var _shared = __webpack_require__(1327);

const seasonalityAdjustment = {
  id: 'seasonality-adjustment',
  name: _TL_('Seasonality adjustment'),
  route: 'seasonalityadjustment',
  checkPermission: permissions => permissions.dynamic.SeasonalityAdjustment // moved to sub-item under "planning/bid-strategies" rather than standlong item
  && !(permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions)
};
exports.seasonalityAdjustment = seasonalityAdjustment;
const seasonalityAdjustmentPage = {
  id: 'seasonality-adjustment',
  name: _TL_('Seasonality adjustment'),
  oldUIScope: [_shared.Scope.Account],
  children: [seasonalityAdjustment]
};
exports.seasonalityAdjustmentPage = seasonalityAdjustmentPage;

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creativeStudioAssetLibraryPage = exports.performancePage = exports.assetsPage = void 0;

var _shared = __webpack_require__(1327);

const assetsPage = {
  id: 'creative-studio-asset-library',
  name: _TL_('Assets'),
  route: 'assetlibrary',
  scope: [_shared.Scope.Account]
};
exports.assetsPage = assetsPage;
const performancePage = {
  id: 'creative-studio-asset-library-performance',
  name: _TL_('Performance'),
  route: 'assetlibrary/performance',
  scope: [_shared.Scope.Account],
  apexViewName: 'assetlibrary',
  searchable: false,
  checkPermission: permissions => permissions.dynamic.AssetLibraryV4
};
exports.performancePage = performancePage;
const creativeStudioAssetLibraryPage = {
  id: 'creative-studio-asset-library',
  name: _TL_('Asset Library'),
  oldUIScope: [_shared.Scope.Account],
  scope: [_shared.Scope.Account],
  route: 'assetlibrary',
  children: [// images
  assetsPage, {
    id: 'creative-studio-asset-library-image-add-folder',
    name: _TL_('Add images folder'),
    route: 'assetlibrary/image/addfolder',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => !permissions.dynamic.AssetLibraryV3EnableVideoUpload
  }, {
    id: 'creative-studio-asset-library-image-add',
    name: _TL_('Add images'),
    route: 'assetlibrary/image/add',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false
  }, {
    id: 'creative-studio-asset-library-image-aigc',
    name: _TL_('AIGC'),
    route: 'assetlibrary/image/aigenerate',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.AssetLibraryAIGCMVP
  }, {
    id: 'creative-studio-asset-library-image-details',
    name: _TL_('Asset library images'),
    route: 'assetlibrary/image/:imageId',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false
  }, {
    id: 'creative-studio-asset-library-image-edit',
    name: _TL_('Edit image'),
    route: 'assetlibrary/image/:imageId/edit',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false
  }, // videos
  {
    id: 'creative-studio-asset-library-video-add',
    name: _TL_('Add videos'),
    route: 'assetlibrary/video/add',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    checkPermission: permissions => permissions.dynamic.AssetLibraryV3EnableVideoUpload,
    searchable: false
  }, {
    id: 'creative-studio-asset-library-video-details',
    name: _TL_('Asset library videos'),
    route: 'assetlibrary/video/:videoId',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false
  }, // mix assets
  {
    id: 'creative-studio-asset-library-add-folder',
    name: _TL_('Add assets folder'),
    route: 'assetlibrary/addfolder',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.AssetLibraryV3EnableVideoUpload
  }, {
    id: 'creative-studio-asset-library-add',
    name: _TL_('Add assets'),
    route: 'assetlibrary/add',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.AssetLibraryV3EnableVideoUpload
  }, // performance
  performancePage, // performance -> image deails
  {
    id: 'creative-studio-asset-library-performance-image-details',
    name: _TL_('Performance'),
    route: 'assetlibrary/performance/image/:imageId',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.AssetLibraryV4
  }, // performance -> edit image
  {
    id: 'creative-studio-asset-library-performance-image-edit',
    name: _TL_('Edit image'),
    route: 'assetlibrary/performance/image/:imageId/edit',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.AssetLibraryV4
  }, // task progress
  {
    id: 'creative-studio-asset-library-task-progress',
    name: _TL_('Asset library'),
    route: 'assetlibrary/taskprogress',
    scope: [_shared.Scope.Account],
    apexViewName: 'assetlibrary',
    searchable: false
  }]
};
exports.creativeStudioAssetLibraryPage = creativeStudioAssetLibraryPage;

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkActions = exports.smartPage = exports.advertisingMobile = exports.advertisingEditor = exports.bulkActionsPages = void 0;

var _shared = __webpack_require__(1327);

var _bulkEdits = __webpack_require__(1379);

var _rules = __webpack_require__(1380);

var _scriptsPage = __webpack_require__(1381);

var _bulkUploads = __webpack_require__(1382);

const bulkActionsPages = [_bulkEdits.bulkEdit, _rules.automatedRule, _scriptsPage.scriptsPage, _bulkUploads.bulkUploads, {
  id: 'mcm-campaign-control',
  name: _TL_('MCM Campaign Control'),
  route: 'mcmcampaigncontrol',
  scope: [_shared.Scope.Customer, _shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  checkPermission: permissions => permissions.IsInternalUser
}];
exports.bulkActionsPages = bulkActionsPages;
const advertisingEditor = {
  id: 'advertising-editor',
  name: _TL_('Microsoft Advertising Editor'),
  description: _TL_(''),
  route: 'advertisingeditor',
  externalLink: 'http://go.microsoft.com/fwlink/?LinkID=193932'
};
exports.advertisingEditor = advertisingEditor;
const advertisingMobile = {
  id: 'advertising-mobile',
  name: _TL_('Microsoft Advertising mobile app'),
  description: _TL_(''),
  route: 'advertisingmobile',
  externalLink: 'https://go.microsoft.com/fwlink/?linkid=2173918'
};
exports.advertisingMobile = advertisingMobile;
const smartPage = {
  id: 'expert-my-website',
  name: _TL_('Smart Pages'),
  route: 'smartpage',
  externalLink: `${window.location.origin}/campaign/sp/landing${window.location.search}`,
  scope: [_shared.Scope.Account],
  checkPermission: permissions => permissions.dynamic.PMaxLite && !(0, _shared.isSmartPageStandalone)(permissions) && !permissions.IsUnifiedSmartMode && !permissions.IsSmartMode
};
exports.smartPage = smartPage;
const bulkActions = {
  id: 'bulk-actions',
  name: _TL_('Bulk actions & apps'),
  scope: [_shared.Scope.Customer, _shared.Scope.Account],
  children: [...bulkActionsPages, advertisingEditor, advertisingMobile, smartPage]
};
exports.bulkActions = bulkActions;

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkEdit = void 0;

var _shared = __webpack_require__(1327);

const bulkEdit = {
  id: 'bulk-edits',
  name: _TL_('Bulk edits'),
  scope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'bulk-edits',
    name: _TL_('Bulk edits'),
    route: 'bulkeditoperation',
    scope: [_shared.Scope.Account],
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.bulkEdit = bulkEdit;

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.automatedRule = void 0;

var _shared = __webpack_require__(1327);

const automatedRule = {
  id: 'rules',
  name: _TL_('Automated rules'),
  scope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'automated-rules',
    name: _TL_('Automated rules'),
    route: 'automatedruleoperation',
    scope: [_shared.Scope.Account],
    campaignTypes: _shared.alwaysDisplayed
  }, {
    id: 'rule-history',
    name: _TL_('Logs'),
    route: 'automatedrulehistory',
    scope: [_shared.Scope.Account],
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.automatedRule = automatedRule;

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scriptsPage = void 0;

var _shared = __webpack_require__(1327);

const scriptsPage = {
  id: 'scripts',
  name: _TL_('Scripts'),
  scope: [_shared.Scope.Customer, _shared.Scope.Account],
  children: [{
    id: 'scripts-page',
    name: _TL_('Scripts'),
    route: 'scripts',
    scope: [_shared.Scope.Customer, _shared.Scope.Account]
  }, {
    id: 'scripts-history',
    name: _TL_('Scripts History'),
    route: 'scriptshistory',
    scope: [_shared.Scope.Customer, _shared.Scope.Account]
  }]
};
exports.scriptsPage = scriptsPage;

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkUploads = void 0;

var _shared = __webpack_require__(1327);

const bulkUploads = {
  id: 'bulk-uploads',
  name: _TL_('Bulk uploads'),
  checkPermission: permissions => permissions.IsCampaignBAMEnabled,
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'bulk-download-history',
    name: _TL_('Download history'),
    route: 'bulkuploads/downloadhistory',
    checkPermission: permissions => permissions.IsCampaignBAMEnabled,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'bulk-scheduled-downloads',
    name: _TL_('Scheduled downloads'),
    route: 'bulkuploads/scheduleddownloads',
    checkPermission: permissions => permissions.IsCampaignBAMEnabled,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'bulk-uploads',
    name: _TL_('Uploads'),
    route: 'bulkuploads/uploads',
    checkPermission: permissions => permissions.IsCampaignBAMEnabled,
    scope: [_shared.Scope.Customer]
  }]
};
exports.bulkUploads = bulkUploads;

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "uetTags", {
  enumerable: true,
  get: function get() {
    return _uetTags.uetTags;
  }
});
Object.defineProperty(exports, "conversionGoals", {
  enumerable: true,
  get: function get() {
    return _conversionGoals.conversionGoals;
  }
});
Object.defineProperty(exports, "offlineConversions", {
  enumerable: true,
  get: function get() {
    return _offlineConversions.offlineConversions;
  }
});
exports.conversionTracking = void 0;

var _uetTags = __webpack_require__(1384);

var _conversionGoals = __webpack_require__(1385);

var _offlineConversions = __webpack_require__(1386);

var _clarityWebsite = __webpack_require__(1387);

const conversionTracking = [_uetTags.uetTags, _conversionGoals.conversionGoals, _offlineConversions.offlineConversions, _clarityWebsite.clarityWebsite];
exports.conversionTracking = conversionTracking;

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uetTags = void 0;

var _shared = __webpack_require__(1327);

const scope = [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup];
const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup];
const uetTags = {
  id: 'uet-tag',
  name: _TL_('UET tag'),
  oldUIScope: [_shared.Scope.Customer, _shared.Scope.Account],
  scope,
  scopeV2,
  route: 'uettag',
  children: [{
    id: 'uet-tag',
    name: _TL_('UET tag'),
    route: 'uettag',
    showTag: _TL_('New'),
    scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup]
  }, {
    id: 'uet-tag-test',
    name: _TL_('Test your tag'),
    route: 'uettagtest',
    scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup],
    available: permissions => permissions.dynamic.UETDashboardPhase2,
    checkPermission: permissions => permissions.dynamic.UETDashboardPhase2
  }, {
    id: 'uet-tag-insights',
    name: _TL_('Insights'),
    route: 'uettaginsights',
    scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
    scopeV2: [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup],
    available: permissions => permissions.dynamic.UETTagInsights,
    checkPermission: permissions => permissions.dynamic.UETTagInsights
  }]
};
exports.uetTags = uetTags;

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversionGoals = void 0;

var _shared = __webpack_require__(1327);

const conversionGoals = {
  id: 'conversion-goals',
  name: _TL_('Conversion goals'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'conversion-goals',
    name: _TL_('Conversion goals'),
    route: 'conversiongoals'
  }, {
    id: 'conversion-value-rules',
    name: _TL_('Conversion value rules'),
    route: 'conversionvaluerules',
    checkPermission: permissions => permissions.dynamic.ConvValueRules
  }]
};
exports.conversionGoals = conversionGoals;

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offlineConversions = exports.offlineConversionItem = void 0;

var _shared = __webpack_require__(1327);

const offlineConversionItem = {
  id: 'offline-conversions',
  name: _TL_('Offline conversions'),
  route: 'offlineconversions',
  scope: [_shared.Scope.Account]
};
exports.offlineConversionItem = offlineConversionItem;
const offlineConversions = {
  id: 'offline-conversions',
  name: _TL_('Offline conversions'),
  oldUIScope: [_shared.Scope.Account],
  scope: [_shared.Scope.Account],
  children: [offlineConversionItem, {
    id: 'offline-conversions-schedule',
    name: _TL_('Offline conversion schedules'),
    route: 'offlineconversionsschedule',
    scope: [_shared.Scope.Account],
    checkPermission: permissions => permissions.IsScheduledOfflineConversionUploadAllowed
  }]
};
exports.offlineConversions = offlineConversions;

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clarityWebsite = void 0;
const clarityWebsite = {
  id: 'clarity-website',
  name: _TL_('Microsoft Clarity'),
  children: [{
    id: 'clarity-website',
    name: _TL_('Microsoft Clarity'),
    route: 'claritywebsite',
    externalLink: 'https://clarity.microsoft.com'
  }]
};
exports.clarityWebsite = clarityWebsite;

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = void 0;

var _accountsBilling = __webpack_require__(1389);

var _accountAccess = __webpack_require__(1390);

var _accountsSummary = __webpack_require__(1391);

var _accountMap = __webpack_require__(1392);

var _attributedTransactions = __webpack_require__(1393);

var _billingPayments = __webpack_require__(1394);

var _businessData = __webpack_require__(1395);

var _budgetCenter = __webpack_require__(1396);

var _campaignBudgetTool = __webpack_require__(1397);

var _hotelCenter = __webpack_require__(1398);

var _hotelCenterV = __webpack_require__(1408);

var _merchantCenter = __webpack_require__(1416);

var _settings = __webpack_require__(1425);

var _unifiedProduct = __webpack_require__(1426);

const setup = [_accountsSummary.accountsSummary, _accountsBilling.accountsBilling, _businessData.businessData, _billingPayments.billingPayments, _unifiedProduct.upChangeHistory, _accountAccess.accountAccess, _accountMap.accountMap, _settings.settings, _merchantCenter.merchantCenter, _hotelCenter.hotelCenter, _hotelCenterV.hotelCenterV2, _attributedTransactions.attributedTransactions, _unifiedProduct.socialNetworks, _unifiedProduct.upConversionTracking, _unifiedProduct.upClarity, _unifiedProduct.upMobileApp, _unifiedProduct.upPrivacyCookies, _unifiedProduct.upTermCondition, _campaignBudgetTool.campaignBudgetTool, _budgetCenter.budgetCenter];
exports.setup = setup;

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsBilling = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const accountsBilling = {
  id: 'billing-payments',
  name: _TL_('Accounts & Billing'),
  oldUIScope: [_shared.Scope.Account],
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'billing-payments',
    name: _TL_('Accounts & Billing'),
    route: 'billing-payments',
    checkPermission: permission => !permission.IsManagementDashboardEnabled && !(0, _shared.isSmartPageStandalone)(permission)
  })]
};
exports.accountsBilling = accountsBilling;

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountAccess = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const accountAccess = {
  id: 'account-access',
  name: _TL_('Account access'),
  oldUIScope: [_shared.Scope.Account],
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'account-access',
    name: _TL_('Account access'),
    route: 'Users',
    checkPermission: permission => permission.IsManagementDashboardEnabled
  })]
};
exports.accountAccess = accountAccess;

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsSummary = void 0;

var _shared = __webpack_require__(1327);

const accountsSummary = {
  id: 'setup-accounts',
  name: _TL_('Accounts'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'setup-accounts',
    name: _TL_('Accounts'),
    route: 'accounts',
    scope: [_shared.Scope.Customer],
    checkPermission: permission => permission.IsManagementDashboardEnabled && !(0, _shared.isUnifiedProductSubscriptionEnabled)(permission)
  }]
};
exports.accountsSummary = accountsSummary;

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountMap = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const accountMap = {
  id: 'account-map',
  name: _TL_('Account map'),
  oldUIScope: [_shared.Scope.Account],
  description: _TL_('View manager account and account structure in a visual map'),
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'account-map',
    name: _TL_('Account map'),
    route: 'AccountMap',
    checkPermission: permission => permission.dynamic.CCUIAccountMap && !(0, _shared.isUnifiedProductSubscriptionEnabled)(permission)
  })]
};
exports.accountMap = accountMap;

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributedTransactions = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const attributedTransactions = {
  id: 'attributed-transactions',
  name: _TL_('Attributed transactions'),
  oldUIScope: [_shared.Scope.Account],
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'attributed-transactions',
    name: _TL_('Attributed transactions'),
    route: 'Billing/CashbackApproval',
    scope: [_shared.Scope.Account],
    checkPermission: permissions => permissions.dynamic.PersonalizedOffers || permissions.dynamic.PersonalizedOffersV2 || permissions.dynamic.PersonalizedOffersV3
  })]
};
exports.attributedTransactions = attributedTransactions;

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingPayments = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const billingPayments = {
  id: 'billing-payments',
  name: _TL_('Billing & Payments'),
  oldUIScope: [_shared.Scope.Account],
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'billing-payments',
    name: _TL_('Billing & Payments'),
    route: 'billing',
    checkPermission: permission => permission.IsManagementDashboardEnabled
  })]
};
exports.billingPayments = billingPayments;

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessData = exports.businessDataPages = void 0;

var _shared = __webpack_require__(1327);

const businessDataPages = [{
  id: 'ad-customizer-feeds',
  name: _TL_('Ad customizer feeds'),
  route: 'feeds/adcustomizer',
  checkPermission: permission => !permission.IsSmartMode && !permission.IsUnifiedSmartMode,
  children: [{
    id: 'ad-customizer-feeds',
    name: _TL_('Ad customizer feeds'),
    route: 'feeds/adcustomizer',
    checkPermission: permission => !permission.IsSmartMode && !permission.IsUnifiedSmartMode
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    route: 'feeds/adcustomizer/uploadhistory'
  }]
}, {
  id: 'dynamic-data-feeds',
  name: _TL_('Dynamic data feeds'),
  route: 'feeds/dynamicdata',
  checkPermission: permissions => permissions.dynamic.DynamicData || permissions.IsEnabledForDynamicFeedCampaign,
  children: [{
    id: 'dynamic-data-feeds',
    name: _TL_('Dynamic data feeds'),
    route: 'feeds/dynamicdata'
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    route: 'feeds/dynamicdata/uploadhistory'
  }]
}, {
  id: 'page-feeds',
  name: _TL_('Page feeds'),
  route: 'feeds/page',
  checkPermission: permissions => permissions.dynamic.DynamicSearchAdsV1,
  children: [{
    id: 'page-feeds',
    name: _TL_('Page feeds'),
    route: 'feeds/page'
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    route: 'feeds/page/uploadhistory'
  }]
}, {
  id: 'customizer-attributes',
  name: _TL_('Ad customizer attributes'),
  route: 'feeds/attribute',
  children: [{
    id: 'customizer-attributes',
    name: _TL_('Ad customizer attributes'),
    route: 'feeds/attribute'
  }, {
    id: 'customizer-attributes-history',
    name: _TL_('Upload history'),
    route: 'feeds/attribute/uploadhistory'
  }, {
    id: 'customizer-attributes-schedules',
    name: _TL_('Schedules'),
    route: 'feeds/attribute/schedules'
  }]
}];
exports.businessDataPages = businessDataPages;
const businessData = {
  id: 'business-data',
  name: _TL_('Business Data'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'business-data',
    name: _TL_('Business data'),
    route: 'feeds/attribute',
    checkPermission: permission => !permission.IsSmartMode && !permission.IsUnifiedSmartMode && !(0, _shared.isSmartPageStandalone)(permission),
    children: businessDataPages
  }]
};
exports.businessData = businessData;

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.budgetCenter = void 0;

var _shared = __webpack_require__(1327);

const budgetCenter = {
  id: 'budget-center',
  name: _TL_('Budget center'),
  scope: [_shared.Scope.Account, _shared.Scope.Campaign],
  children: [{
    id: 'budget-center',
    name: _TL_('Budget center'),
    route: 'budgetcenter',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign],
    showTag: {
      text: _TL_('New'),
      expDate: new Date('2023/12/31')
    },
    checkPermission: permissions => permissions.dynamic.BudgetCenter && !(0, _shared.isSmartPageStandalone)(permissions) && !permissions.IsUnifiedSmartMode && !permissions.IsSmartMode
  }]
};
exports.budgetCenter = budgetCenter;

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignBudgetTool = void 0;

var _shared = __webpack_require__(1327);

const campaignBudgetTool = {
  id: 'campaign-budget-tool',
  name: _TL_('Campaign budget tool'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'campaign-budget-tool',
    name: _TL_('Campaign budget tool'),
    route: 'campaignbudgettool',
    scope: [_shared.Scope.Customer],
    showTag: {
      text: _TL_('New'),
      expDate: new Date('2023/12/31')
    },
    checkPermission: permissions => permissions.dynamic.CampaignBudgetTool && !permissions.dynamic.BudgetCenter
  }]
};
exports.campaignBudgetTool = campaignBudgetTool;

/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hotelCenter = exports.hotelCenterPages = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

var _intelligence = __webpack_require__(1399);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hotelCenterPages = [{
  id: 'hotel-center-overview',
  name: _TL_('Overview'),
  route: 'hotelcenter/overview',
  checkPermission: permissions => permissions.dynamic.HotelAds && !permissions.dynamic.HotelCenterV2,
  children: [{
    id: 'hotel-center-overview',
    name: _TL_('Subacount'),
    route: 'hotelcenter',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center',
    name: _TL_('Subacount'),
    route: 'hotelcenter/overview',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelsubaccountgrid',
    name: _TL_('Subacount'),
    route: 'hotelcenter/overview/hotelsubaccountgrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelidgrid',
    name: _TL_('Hotel'),
    route: 'hotelcenter/overview/hotelidgrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelgroupgrid',
    name: _TL_('Hotel group'),
    route: 'hotelcenter/overview/hotelgroupgrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-advancedbookinggrid',
    name: _TL_('Advanced booking window'),
    route: 'hotelcenter/overview/advancedbookinggrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-checkindaygrid',
    name: _TL_('Check in day'),
    route: 'hotelcenter/overview/checkindaygrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hoteldategrid',
    name: _TL_('Date'),
    route: 'hotelcenter/overview/hoteldategrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-datetypegrid',
    name: _TL_('Date type'),
    route: 'hotelcenter/overview/datetypegrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hoteldevicetypegrid',
    name: _TL_('Device type'),
    route: 'hotelcenter/overview/hoteldevicetypegrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelcountrygrid',
    name: _TL_('Hotel country/region'),
    route: 'hotelcenter/overview/hotelcountrygrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotellengthofstaygrid',
    name: _TL_('Length of stay'),
    route: 'hotelcenter/overview/hotellengthofstaygrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-sitetypegrid',
    name: _TL_('Site type'),
    route: 'hotelcenter/overview/sitetypegrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelslottypegrid',
    name: _TL_('Slot type'),
    route: 'hotelcenter/overview/hotelslottypegrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }, {
    id: 'hotel-center-overview-hotelusercountrygrid',
    name: _TL_('User country/region'),
    route: 'hotelcenter/overview/hotelusercountrygrid',
    checkPermission: permissions => permissions.dynamic.HotelAds
  }]
}, {
  id: 'hotel-center-assignment',
  name: _TL_('Assignment'),
  route: 'hotelcenter/assignment',
  checkPermission: permissions => permissions.dynamic.HotelAds && !permissions.dynamic.HotelCenterV2
}, _intelligence.intelligencePages, {
  id: 'hotel-center-setup',
  name: _TL_('Setup'),
  route: 'hotelcenter/setup',
  checkPermission: permissions => permissions.dynamic.HotelAds && !permissions.dynamic.HotelCenterV2
}];
exports.hotelCenterPages = hotelCenterPages;
const hotelCenterScope = {
  scope: _shared.defaultScopes
};

function addScope(items) {
  _underscore.default.each(items, item => {
    _underscore.default.defaults(item, hotelCenterScope);

    if (item.children) {
      addScope(item.children);
    }
  });
}

addScope(hotelCenterPages);
const hotelCenter = {
  id: 'hotel-center',
  name: _TL_('Hotel Center'),
  route: 'hotelcenter/overview',
  scope: _shared.defaultScopes,
  checkPermission: permissions => permissions.dynamic.HotelAds,
  children: [{
    id: 'hotel-center',
    name: _TL_('Hotel center'),
    route: 'hotelcenter/overview',
    children: hotelCenterPages,
    checkPermission: permissions => permissions.dynamic.HotelAds && !permissions.dynamic.HotelCenterV2
  }]
};
exports.hotelCenter = hotelCenter;

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intelligencePages = void 0;

var _adExtension = __webpack_require__(1400);

var _bookingReport = __webpack_require__(1401);

var _feedStatus = __webpack_require__(1402);

var _feedUpload = __webpack_require__(1403);

var _shareOfVoice = __webpack_require__(1404);

var _matchReport = __webpack_require__(1405);

var _uploadedReconReports = __webpack_require__(1406);

var _processedReconReports = __webpack_require__(1407);

const reportPages = [_matchReport.matchReportPage, _feedStatus.feedStatusPage, _shareOfVoice.shareOfVoicePage, _bookingReport.bookingReportPage];
const reconcilliationReportPages = [_uploadedReconReports.UploadedReconReportsPage, _processedReconReports.ProcessedReconReportsPage];
const intelligencePages = {
  id: 'hotel-center-intelligence',
  name: _TL_('Intelligence'),
  route: 'hotelcenter/feedupload',
  checkPermission: permissions => permissions.dynamic.HotelAds,
  children: [_feedUpload.feedUploadPage, {
    id: 'report',
    name: _TL_('Reports'),
    route: 'hotelcenter/matchreport',
    checkPermission: permissions => permissions.dynamic.HotelAds,
    children: reportPages
  }, _adExtension.adExtensionPage, {
    id: 'reconciliationreport',
    name: _TL_('Reconciliation Report'),
    route: 'hotelcenter/reconciliationreport',
    checkPermission:
    /* istanbul ignore next */
    permissions => {
      const _permissions$dynamic = permissions.dynamic,
            ReconciliationReport = _permissions$dynamic.ReconciliationReport,
            PayPerStay = _permissions$dynamic.PayPerStay;
      return ReconciliationReport && PayPerStay;
    },
    children: reconcilliationReportPages
  }]
};
exports.intelligencePages = intelligencePages;

/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adExtensionPage = void 0;
const adExtensionPage = {
  id: 'adExtensions',
  name: _TL_('Ad Extensions'),
  route: 'hotelcenter/calloutextensions',
  checkPermission: permissions => permissions.dynamic.HotelAds
};
exports.adExtensionPage = adExtensionPage;

/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingReportPage = void 0;
const bookingReportPage = {
  id: 'bookingreport',
  name: _TL_('Bookings'),
  route: 'hotelcenter/bookingreport',
  checkPermission: permissions => permissions.dynamic.HotelAds && permissions.dynamic.HotelAdsConversion
};
exports.bookingReportPage = bookingReportPage;

/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedStatusPage = void 0;
const feedStatusPage = {
  id: 'feedstatus',
  name: _TL_('Price feed status'),
  route: 'hotelcenter/feedstatus',
  checkPermission: permissions => permissions.dynamic.HotelAds
};
exports.feedStatusPage = feedStatusPage;

/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedUploadPage = void 0;
const feedUploadPage = {
  id: 'feedupload',
  name: _TL_('Feeds'),
  route: 'hotelcenter/feedupload',
  checkPermission: permissions => permissions.dynamic.HotelAds
};
exports.feedUploadPage = feedUploadPage;

/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareOfVoicePage = void 0;
const shareOfVoicePage = {
  id: 'sharedofvoice',
  name: _TL_('Share of Voice'),
  route: 'hotelcenter/sharedofvoice',
  checkPermission: permissions => permissions.dynamic.HotelAds
};
exports.shareOfVoicePage = shareOfVoicePage;

/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchReportPage = void 0;
const matchReportPage = {
  id: 'matchreport',
  name: _TL_('Matching'),
  route: 'hotelcenter/matchreport',
  checkPermission: permissions => permissions.dynamic.HotelAds
};
exports.matchReportPage = matchReportPage;

/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadedReconReportsPage = void 0;

/* istanbul ignore file */
const UploadedReconReportsPage = {
  id: 'uploadedreconreports',
  name: _TL_('Uploaded Reconciliation Reports'),
  route: 'hotelcenter/uploadedreconreports',
  checkPermission:
  /* istanbul ignore next */
  permissions => {
    const _permissions$dynamic = permissions.dynamic,
          ReconciliationReport = _permissions$dynamic.ReconciliationReport,
          PayPerStay = _permissions$dynamic.PayPerStay;
    return ReconciliationReport && PayPerStay;
  }
};
exports.UploadedReconReportsPage = UploadedReconReportsPage;

/***/ }),

/***/ 1407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessedReconReportsPage = void 0;

/* istanbul ignore file */
const ProcessedReconReportsPage = {
  id: 'processedreconreports',
  name: _TL_('Processed Reconciliation Reports'),
  route: 'hotelcenter/processedreconreports',
  checkPermission:
  /* istanbul ignore next */
  permissions => {
    const _permissions$dynamic = permissions.dynamic,
          ReconciliationReport = _permissions$dynamic.ReconciliationReport,
          PayPerStay = _permissions$dynamic.PayPerStay;
    return ReconciliationReport && PayPerStay;
  }
};
exports.ProcessedReconReportsPage = ProcessedReconReportsPage;

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hotelCenterV2 = exports.hotelCenterV2Pages = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _shared = __webpack_require__(1327);

var _feeds = __webpack_require__(1409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hotelCenterV2Pages = [{
  id: 'hotel-center-v2-overview',
  name: _TL_('Overview'),
  route: 'hotelcenter-v2/overview'
}, _feeds.feedsPages, {
  id: 'hotel-center-v2-matching',
  name: _TL_('Matching'),
  route: 'hotelcenter-v2/matching'
}, {
  id: 'hotel-center-v2-logos',
  name: _TL_('Logos'),
  route: 'hotelcenter-v2/logos'
}, {
  id: 'hotel-center-v2-setup',
  name: _TL_('Setup'),
  route: 'hotelcenter-v2/setup'
}];
exports.hotelCenterV2Pages = hotelCenterV2Pages;
const hotelCenterScope = {
  scope: _shared.defaultScopes,
  checkPermission: permissions => permissions.dynamic.HotelAds && permissions.dynamic.HotelCenterV2
};

function addScopeAndPermission(items) {
  _underscore.default.each(items, item => {
    _underscore.default.defaults(item, hotelCenterScope);

    if (item.children) {
      addScopeAndPermission(item.children);
    }
  });
}

addScopeAndPermission(hotelCenterV2Pages);
const hotelCenterV2 = {
  id: 'hotel-center-v2',
  name: _TL_('Hotel Center'),
  route: 'hotelcenter-v2/overview',
  scope: _shared.defaultScopes,
  checkPermission: permissions => permissions.dynamic.HotelAds && permissions.dynamic.HotelCenterV2,
  children: [{
    id: 'hotel-center-v2',
    name: _TL_('Hotel center'),
    route: 'hotelcenter-v2/overview',
    children: hotelCenterV2Pages,
    checkPermission: permissions => permissions.dynamic.HotelAds && permissions.dynamic.HotelCenterV2
  }]
};
exports.hotelCenterV2 = hotelCenterV2;

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedsPages = void 0;

var _landingpage = __webpack_require__(1410);

var _landingpageDetail = __webpack_require__(1411);

var _properties = __webpack_require__(1412);

var _property = __webpack_require__(1413);

var _pricingStatus = __webpack_require__(1414);

var _pricingSettings = __webpack_require__(1415);

const propertiesPages = [_properties.propertiesPage, _property.propertyPage];
const pricingPages = [_pricingStatus.pricingStatusPage, _pricingSettings.pricingSettingPage];
const landingPages = [_landingpage.landingPage, _landingpageDetail.landingPageDetail];
const feedsPages = {
  id: 'hotel-center-v2-feeds',
  name: _TL_('Feeds'),
  route: 'hotelcenter-v2/feeds',
  children: [{
    id: 'hotel-center-v2-properties',
    name: _TL_('Properties'),
    route: 'hotelcenter-v2/properties',
    children: propertiesPages
  }, {
    id: 'hotel-center-v2-landing',
    name: _TL_('Landing Page'),
    route: 'hotelcenter-v2/landingpage',
    children: landingPages
  }, {
    id: 'hotel-center-v2-pricing',
    name: _TL_('Pricing'),
    route: 'hotelcenter-v2/pricing-status',
    children: pricingPages
  }]
};
exports.feedsPages = feedsPages;

/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.landingPage = void 0;
const landingPage = {
  id: 'hotel-center-v2-landingpage',
  name: _TL_('Landing Page'),
  route: 'hotelcenter-v2/landingpage'
};
exports.landingPage = landingPage;

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.landingPageDetail = void 0;
const landingPageDetail = {
  id: 'hotel-center-v2-landingpage-detail',
  name: _TL_('Landing page'),
  route: 'hotelcenter-v2/landingpage-detail'
};
exports.landingPageDetail = landingPageDetail;

/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertiesPage = void 0;
const propertiesPage = {
  id: 'hotel-center-v2-properties-list',
  name: _TL_('Properties'),
  route: 'hotelcenter-v2/properties'
};
exports.propertiesPage = propertiesPage;

/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyPage = void 0;
const propertyPage = {
  id: 'hotel-center-v2-properties-detail',
  name: _TL_('Property'),
  route: 'hotelcenter-v2/property'
};
exports.propertyPage = propertyPage;

/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pricingStatusPage = void 0;
const pricingStatusPage = {
  id: 'hotel-center-v2-pricing-status',
  name: _TL_('Status'),
  route: 'hotelcenter-v2/pricing-status'
};
exports.pricingStatusPage = pricingStatusPage;

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pricingSettingPage = void 0;
const pricingSettingPage = {
  id: 'hotel-center-v2-pricing-setting',
  name: _TL_('Settings'),
  route: 'hotelcenter-v2/pricing-setting'
};
exports.pricingSettingPage = pricingSettingPage;

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchantCenter = exports.merchantCenterPages = void 0;

var _merchantShared = __webpack_require__(1417);

var _merchantCenter = __webpack_require__(1418);

var _feeds = __webpack_require__(1419);

var _import = __webpack_require__(1420);

var _promotions = __webpack_require__(1421);

var _settings = __webpack_require__(1422);

var _stores = __webpack_require__(1423);

var _summary = __webpack_require__(1424);

const merchantCenterPages = [_merchantCenter.homePage, _stores.stores, _summary.storeSummary, _feeds.feeds, _import.importFeed, _promotions.promotions, _settings.settings];
exports.merchantCenterPages = merchantCenterPages;
const merchantCenter = {
  id: 'merchant-center',
  name: _TL_('Merchant Center'),
  scope: _merchantShared.defaultScope,
  scopeV2: _merchantShared.defaultScopeV2,
  children: merchantCenterPages
};
exports.merchantCenter = merchantCenter;

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultScopeV2 = exports.defaultScope = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('Store', 'storeId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('MerchantFeed', 'feedId', _shared.ScopeV2.Store);

const defaultScope = [_shared.Scope.Account, _shared.Scope.Store, _shared.Scope.MerchantFeed];
exports.defaultScope = defaultScope;
const defaultScopeV2 = [_shared.ScopeV2.Account, _shared.ScopeV2.Store, _shared.ScopeV2.MerchantFeed];
exports.defaultScopeV2 = defaultScopeV2;

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homePage = void 0;

var _shared = __webpack_require__(1327);

const homePage = {
  id: 'mmc-home',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Account],
  children: [{
    id: 'mmc-home',
    name: _TL_('Merchant Center'),
    route: 'merchantcenter',
    scope: [_shared.Scope.Account],
    checkPermission: permission => !(0, _shared.isSmartPageStandalone)(permission) && !permission.IsUnifiedSmartMode && !permission.IsSmartMode
  }]
};
exports.homePage = homePage;

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feeds = void 0;

var _shared = __webpack_require__(1327);

const feeds = {
  id: 'mmc-feeds',
  name: _TL_('Merchant center'),
  oldUIScope: [_shared.Scope.Account],
  scope: [_shared.Scope.Store, _shared.Scope.MerchantFeed],
  scopeV2: [_shared.ScopeV2.Store, _shared.ScopeV2.MerchantFeed],
  children: [{
    id: 'mmc-feeds',
    name: _TL_('Feeds'),
    route: 'merchantcenter/feeds',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }, {
    id: 'mmc-feed-details',
    name: _TL_('Feed details'),
    route: 'merchantcenter/feed-details',
    scope: [_shared.Scope.MerchantFeed],
    scopeV2: [_shared.ScopeV2.MerchantFeed],
    searchable: false
  }]
};
exports.feeds = feeds;

/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importFeed = void 0;

var _shared = __webpack_require__(1327);

const importFeed = {
  id: 'mmc-import',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Store],
  scopeV2: [_shared.ScopeV2.Store],
  children: [{
    id: 'mmc-import',
    name: _TL_('Import'),
    route: 'merchantcenter/import',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false,
    children: [{
      id: 'mmc-import',
      name: _TL_('Import'),
      route: 'merchantcenter/import',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-import-feed-label',
      name: _TL_('Feed label management'),
      route: 'merchantcenter/import-feed-label',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false,
      checkPermission: permissions => permissions.dynamic.FeedLabel
    }]
  }, {
    id: 'mmc-import-steps',
    name: _TL_('Import steps'),
    route: 'merchantcenter/import-steps',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }, {
    id: 'mmc-import-result',
    name: _TL_('Import result'),
    route: 'merchantcenter/import-result',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }]
};
exports.importFeed = importFeed;

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotions = void 0;

var _shared = __webpack_require__(1327);

const promotions = {
  id: 'mmc-promotions',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Store],
  scopeV2: [_shared.ScopeV2.Store],
  children: [{
    id: 'mmc-promotions',
    name: _TL_('Promotions'),
    route: 'merchantcenter/promotions',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }]
};
exports.promotions = promotions;

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;

var _shared = __webpack_require__(1327);

const settings = {
  id: 'mmc-settings',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Store],
  scopeV2: [_shared.ScopeV2.Store],
  children: [{
    id: 'mmc-settings',
    name: _TL_('Settings'),
    route: 'merchantcenter/settings',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false,
    children: [{
      id: 'mmc-ftp',
      name: _TL_('FTP/SFTP'),
      route: 'merchantcenter/settings/ftp',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-shipping',
      name: _TL_('Shipping (US only)'),
      route: 'merchantcenter/settings/shipping',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-automatic-item-updates',
      name: _TL_('Automatic updates'),
      route: 'merchantcenter/settings/autoupdates',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-linked-manager-accounts',
      name: _TL_('Linked manager accounts'),
      route: 'merchantcenter/settings/linkedaccounts',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-product-listings',
      name: _TL_('Product listings'),
      route: 'merchantcenter/settings/productlistings',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false,
      checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled
    }, {
      id: 'mmc-aggregators',
      name: _TL_('Aggregators'),
      route: 'merchantcenter/settings/aggregators',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false,
      checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled
    }]
  }]
};
exports.settings = settings;

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stores = void 0;

var _shared = __webpack_require__(1327);

const stores = {
  id: 'mmc-stores',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Account],
  children: [{
    id: 'mmc-stores',
    name: _TL_('Stores'),
    route: 'merchantcenter/stores',
    scope: [_shared.Scope.Account],
    exact: false
  }, {
    id: 'mmc-create-store',
    name: _TL_('Create store'),
    route: 'merchantcenter/create-store',
    scope: [_shared.Scope.Account],
    searchable: false
  }, {
    id: 'mmc_placeholder_stores',
    name: _TL_('Placeholder Stores'),
    route: 'merchantcenter/placeholderStores',
    scope: [_shared.Scope.Account],
    exact: false
  }]
};
exports.stores = stores;

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeSummary = void 0;

var _shared = __webpack_require__(1327);

const storeSummary = {
  id: 'mmc-store-summary',
  name: _TL_('Merchant center'),
  scope: [_shared.Scope.Store],
  scopeV2: [_shared.ScopeV2.Store],
  children: [{
    id: 'mmc-store-summary',
    name: _TL_('Summary'),
    searchAlias: _TL_('Store summary'),
    route: 'merchantcenter/store-summary',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false,
    children: [{
      id: 'mmc-store-summary-productissues',
      name: _TL_('Product issues'),
      route: 'merchantcenter/store-summary/productissues',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-store-summary-feedissues',
      name: _TL_('Feed issues'),
      route: 'merchantcenter/store-summary/feedissues',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-store-summary-storeissues',
      name: _TL_('Store issues'),
      route: 'merchantcenter/store-summary/storeissues',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }, {
      id: 'mmc-store-summary-productperf',
      name: _TL_('Product performance'),
      route: 'merchantcenter/store-summary/productperf',
      scope: [_shared.Scope.Store],
      scopeV2: [_shared.ScopeV2.Store],
      searchable: false
    }]
  }, {
    id: 'mmc-store-summary-productissuedetails',
    name: _TL_('Product issue details'),
    searchAlias: _TL_('Product issue details'),
    route: 'merchantcenter/store-summary/productissuedetails',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }, {
    id: 'mmc-store-summary-policyviolationdetails',
    name: _TL_('Policy violation details'),
    searchAlias: _TL_('Policy violation details'),
    route: 'merchantcenter/store-summary/policyviolationdetails',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }, {
    id: 'mmc-store-summary-reviewrejections',
    name: _TL_('Review rejections'),
    searchAlias: _TL_('Review rejections'),
    route: 'merchantcenter/store-summary/reviewrejections',
    scope: [_shared.Scope.Store],
    scopeV2: [_shared.ScopeV2.Store],
    searchable: false
  }]
};
exports.storeSummary = storeSummary;

/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const settings = {
  id: 'my-settings',
  name: _TL_('Preferences'),
  oldUIScope: [_shared.Scope.Account],
  campaignTypes: [_shared.CampaignType.None],
  children: [_objectSpread({}, _shared.defaultCCItemProperties, {
    id: 'my-settings',
    name: _TL_('Preferences'),
    route: 'Settings',
    checkPermission: permission => permission.IsManagementDashboardEnabled,
    campaignTypes: [_shared.CampaignType.None]
  })]
};
exports.settings = settings;

/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "socialNetworks", {
  enumerable: true,
  get: function get() {
    return _socialNetworks.socialNetworks;
  }
});
Object.defineProperty(exports, "upTermCondition", {
  enumerable: true,
  get: function get() {
    return _termCondition.upTermCondition;
  }
});
Object.defineProperty(exports, "upPrivacyCookies", {
  enumerable: true,
  get: function get() {
    return _privacyCookies.upPrivacyCookies;
  }
});
Object.defineProperty(exports, "upConversionTracking", {
  enumerable: true,
  get: function get() {
    return _conversionTracking.upConversionTracking;
  }
});
Object.defineProperty(exports, "upClarity", {
  enumerable: true,
  get: function get() {
    return _clarity.upClarity;
  }
});
Object.defineProperty(exports, "upChangeHistory", {
  enumerable: true,
  get: function get() {
    return _changeHistory.upChangeHistory;
  }
});
Object.defineProperty(exports, "upMobileApp", {
  enumerable: true,
  get: function get() {
    return _mobileApp.upMobileApp;
  }
});

var _socialNetworks = __webpack_require__(1427);

var _termCondition = __webpack_require__(1428);

var _privacyCookies = __webpack_require__(1429);

var _conversionTracking = __webpack_require__(1430);

var _clarity = __webpack_require__(1431);

var _changeHistory = __webpack_require__(1432);

var _mobileApp = __webpack_require__(1433);

/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialNetworks = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const socialNetworks = {
  id: 'up-social-networks',
  name: _TL_('Social networks'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-social-networks',
    name: _TL_('Social networks'),
    route: 'settings/social-networks',
    isUnifiedProductPage: true,
    // Currently Smart Page signup user have UP pilots flag, which makes this link display
    // so combines with smart page flag to hide it.
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) && !(0, _shared.isSmartPageStandalone)(p) && !p.dynamic.SCv2
  })]
};
exports.socialNetworks = socialNetworks;

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upTermCondition = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const upTermsAndConditionLink = 'https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement';
const upTermCondition = {
  id: 'up-term-condition',
  name: _TL_('Terms and conditions'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-term-condition',
    name: _TL_('Terms and conditions'),
    externalLink: upTermsAndConditionLink,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) || (0, _shared.isSmartPageStandalone)(p)
  })]
};
exports.upTermCondition = upTermCondition;

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upPrivacyCookies = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const privacyAndCookiesLink = 'https://privacy.microsoft.com/en-us/PrivacyStatement';
const upPrivacyCookies = {
  id: 'up-privacy-cookies',
  name: _TL_('Privacy and cookies'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-privacy-cookies',
    name: _TL_('Privacy and cookies'),
    externalLink: privacyAndCookiesLink,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) || (0, _shared.isSmartPageStandalone)(p)
  })]
};
exports.upPrivacyCookies = upPrivacyCookies;

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upConversionTracking = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const upConversionTracking = {
  id: 'up-conversion-goals',
  name: _TL_('Conversion tracking'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-conversion-goals',
    name: _TL_('Conversion tracking'),
    route: 'ads/conversion-goals',
    isUnifiedProductPage: true,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) && !(0, _shared.isSmartPageStandalone)(p) && !p.dynamic.SCv2
  })]
};
exports.upConversionTracking = upConversionTracking;

/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upClarity = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const upClarity = {
  id: 'up-clarity',
  name: _TL_('Microsoft Clarity'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-clarity',
    name: _TL_('Microsoft Clarity'),
    externalLink: 'https://clarity.microsoft.com',
    isUnifiedProductPage: true,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) && !(0, _shared.isSmartPageStandalone)(p) && !p.dynamic.SCv2 && p.IsESCClarityEnabled
  })]
};
exports.upClarity = upClarity;

/***/ }),

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upChangeHistory = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const upChangeHistory = {
  id: 'esc-change-history',
  name: _TL_('Change history'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'esc-change-history',
    name: _TL_('Change history'),
    route: 'ads/change-history',
    isUnifiedProductPage: true,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) && p.dynamic.IsESCChangeHistoryEnabled && p.IsInternalUser
  })]
};
exports.upChangeHistory = upChangeHistory;

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upMobileApp = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const mobileAppLink = 'https://go.microsoft.com/fwlink/?linkid=2173918';
const upMobileApp = {
  id: 'up-mobile-app',
  name: _TL_('Microsoft Advertising mobile app'),
  children: [_objectSpread({}, _shared.defaultUpItemProperties, {
    id: 'up-mobile-app',
    name: _TL_('Microsoft Advertising mobile app'),
    externalLink: mobileAppLink,
    checkPermission: p => (0, _shared.isUnifiedProductEnabled)(p) && !(0, _shared.isSmartPageStandalone)(p) && !(0, _shared.isUnifiedProductSubscriptionEnabled)(p)
  })]
};
exports.upMobileApp = upMobileApp;

/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileApp = void 0;

var _shared = __webpack_require__(1327);

const mobileApp = {
  id: 'app',
  name: _TL_('App'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'mobile-app',
    name: _TL_('Microsoft Advertising mobile app'),
    route: 'advertisingmobile',
    externalLink: 'https://go.microsoft.com/fwlink/?linkid=2173918'
  }]
};
exports.mobileApp = mobileApp;

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsV4Pages = exports.buildReportsPage = exports.myReportsPage = exports.defaultReportsPage = void 0;

var _shared = __webpack_require__(1327);

var _defaultReports = __webpack_require__(1436);

var _customize = __webpack_require__(1448);

var _share = __webpack_require__(1449);

const defaultReportsPage = {
  id: 'reports-v4-default-reports',
  name: _TL_('Default reports'),
  route: 'reports-v4/default-reports',
  fixedRoute: 'reports-v4/default-reports',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  children: _defaultReports.defaultReports
};
exports.defaultReportsPage = defaultReportsPage;
const myReportsPage = {
  id: 'reports-v4-my-reports',
  name: _TL_('Saved customized reports'),
  title: _TL_('View reports that you have customized and saved'),
  fixedRoute: 'reports-v4/my-reports',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  children: [_customize.customized, _share.shared]
};
exports.myReportsPage = myReportsPage;
const buildReportsPage = {
  id: 'reports-v4-build-custom-report',
  name: _TL_('Build your own report'),
  title: _TL_('Build your own report'),
  route: 'reports-v4/build-custom-report',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  available: permissions => permissions.dynamic.CustomReportBuilder
};
exports.buildReportsPage = buildReportsPage;
const reportsV4Pages = [{
  id: 'reports-v4',
  name: _TL_('Reports'),
  route: 'reports-v4',
  fixedRoute: 'reports-v4',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'reports-v4-all-reports',
    name: _TL_('All Reports'),
    scope: _shared.allScopes,
    searchable: false
  }, defaultReportsPage, myReportsPage, {
    id: 'reports-v4-edit-report',
    name: _TL_('Edit report'),
    title: _TL_('View and edit a report'),
    route: 'reports-v4/edit/:TaskItemId',
    scope: _shared.allScopes,
    apexViewName: 'reports-v4_edit',
    campaignTypes: _shared.alwaysDisplayed,
    searchable: false
  }, buildReportsPage]
}];
exports.reportsV4Pages = reportsV4Pages;

/***/ }),

/***/ 1436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultReports = void 0;

var _performance = __webpack_require__(1437);

var _extensions = __webpack_require__(1439);

var _productAds = __webpack_require__(1440);

var _changeHistory = __webpack_require__(1441);

var _targeting = __webpack_require__(1442);

var _billingAndBudget = __webpack_require__(1443);

var _advancedInsights = __webpack_require__(1444);

var _dynamicSearch = __webpack_require__(1445);

var _labels = __webpack_require__(1446);

var _hotel = __webpack_require__(1447);

const defaultReports = [_performance.performance, _extensions.extensions, _productAds.productAds, _changeHistory.changeHistory, _targeting.targeting, _billingAndBudget.billingAndBudget, _advancedInsights.advancedInsights, _dynamicSearch.dynamicSearch, _hotel.hotel, _hotel.property, _labels.labels];
exports.defaultReports = defaultReports;

/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performance = void 0;

var _common = __webpack_require__(1438);

const performance = {
  id: 'reports-v4-category-performance',
  name: _TL_('Performance'),
  title: _TL_('Performance reports give you a closer look at how your campaigns are performing, including details like CTR and impressions.'),
  fixedRoute: 'reports-v4/category/performance',
  route: 'reports-v4/category/performance',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-accountreport',
    name: _TL_('Account'),
    title: _TL_('Understand account performance and identify trends.'),
    fixedRoute: 'reports-v4/create/accountreport',
    route: 'reports-v4/create/accountreport',
    searchAlias: _TL_('Account report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AccountPerformanceReport',
    description: _TL_('To observe long-term account performance and trends.')
  }, {
    id: 'reports-v4-campaignreport',
    name: _TL_('Campaign'),
    title: _TL_('See a snapshot of your account, and if there\'s anything to flag.'),
    fixedRoute: 'reports-v4/create/campaignreport',
    route: 'reports-v4/create/campaignreport',
    searchAlias: _TL_('Campaign report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'CampaignPerformanceReport',
    description: _TL_('To view high-level performance statistics and quality attributes for each campaign or account. This is also a quick way to flag any major campaign or account problems.')
  }, {
    id: 'reports-v4-adgroupreport',
    name: _TL_('Ad group'),
    title: _TL_('See if your ad group is meeting your preset goals.'),
    fixedRoute: 'reports-v4/create/adgroupreport',
    route: 'reports-v4/create/adgroupreport',
    searchAlias: _TL_('Ad group report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdGroupPerformanceReport',
    description: _TL_('To more broadly compare delivery performance statistics by ad group, campaign, or account attributes rather than at the keyword level.')
  }, {
    id: 'reports-v4-adreport',
    name: _TL_('Ad'),
    title: _TL_('See which ads are leading to clicks and conversions.'),
    fixedRoute: 'reports-v4/create/adreport',
    route: 'reports-v4/create/adreport',
    searchAlias: _TL_('Ad report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdPerformanceReport',
    description: _TL_('To help you determine which ads lead to clicks and conversions, and which are not performing. Having underperforming ads in your account can pull down the quality of your campaigns.')
  }, {
    id: 'reports-v4-keywordreport',
    name: _TL_('Keyword'),
    title: _TL_('See which keywords are leading to clicks.'),
    fixedRoute: 'reports-v4/create/keywordreport',
    route: 'reports-v4/create/keywordreport',
    searchAlias: _TL_('Keyword report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'KeywordPerformanceReport',
    description: _TL_('To find out which keywords are triggering your ads and getting clicks. You can also identify keywords that aren\'t performing well to determine if you want to delete them.')
  }, {
    id: 'reports-v4-negativekeywordconflictreport',
    name: _TL_('Negative keyword conflicts'),
    title: _TL_('See a set of keyword and negative keyword pairs that are blocking your bids from participating in the auction.'),
    fixedRoute: 'reports-v4/create/negativekeywordconflictreport',
    route: 'reports-v4/create/negativekeywordconflictreport',
    searchAlias: _TL_('Negative keyword conflicts report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'NegativeKeywordConflictReport',
    description: _TL_('This report tells you which keywords and negative keywords are in conflict, and whether the conflict is at the campaign or ad group level. Use this list to figure out which negative keywords to delete.')
  }, {
    id: 'reports-v4-searchtermreport',
    name: _TL_('Search term'),
    // Duplicate
    title: _TL_('See which search terms are causing your ads to display.'),
    fixedRoute: 'reports-v4/create/searchtermreport',
    route: 'reports-v4/create/searchtermreport',
    searchAlias: _TL_('Search term report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'SearchQueryPerformanceReport',
    description: _TL_('To see what your audience is searching for when your ads are shown. You can use this information to make informed additions, removals, or edits to both your keyword and negative keyword lists.')
  }, {
    id: 'reports-v4-shareofvoicereport',
    name: _TL_('Share of voice'),
    title: _TL_('See estimated impressions you might be losing.'),
    fixedRoute: 'reports-v4/create/shareofvoicereport',
    route: 'reports-v4/create/shareofvoicereport',
    searchAlias: _TL_('Share of voice report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'ShareOfVoiceReport',
    description: _TL_('To view the percentage of impression share (%)  you have in the marketplace, find out if you are missing opportunities based on your current campaign settings, and make changes to improve impression share. ')
  }, {
    id: 'reports-v4-desturlreport',
    name: _TL_('Destination URL'),
    title: _TL_('See how your landing pages are performing.'),
    fixedRoute: 'reports-v4/create/desturlreport',
    route: 'reports-v4/create/desturlreport',
    searchAlias: _TL_('Destination URL report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'DestinationURLPerformanceReport',
    description: _TL_('To identify landing pages that met audience expectations, resulting in high click or conversion ratios.')
  }, {
    id: 'reports-v4-weburlreport',
    name: _TL_('Website URL (publisher)'),
    // Duplicate
    title: _TL_('See performance data for both search and content websites where your ads appear.'),
    fixedRoute: 'reports-v4/create/weburlreport',
    route: 'reports-v4/create/weburlreport',
    searchAlias: _TL_('Website URL (publisher) report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'PublisherUsagePerformanceReport',
    description: _TL_('To see if any website URLs aren\'t performing well enough for your campaign or ad group target settings. For example, if ad impressions at those URLs yield a low click-through-rate, then you might decide to exclude those websites from your campaign.')
  }, {
    id: 'reports-v4-addynamictextreport',
    name: _TL_('Ad dynamic text'),
    title: _TL_('See which ad text strings are doing well.'),
    fixedRoute: 'reports-v4/create/addynamictextreport',
    route: 'reports-v4/create/addynamictextreport',
    searchAlias: _TL_('Ad dynamic text report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdDynamicTextPerformanceReport',
    description: _TL_('To identify which dynamic text strings are performing well and which strings you should consider changing.')
  }, {
    id: 'reports-v4-audiencesreport',
    name: _TL_('Audiences'),
    title: _TL_('See how the ad groups that are associated with remarketing lists are performing.'),
    fixedRoute: 'reports-v4/create/audiencesreport',
    route: 'reports-v4/create/audiencesreport',
    searchAlias: _TL_('Audiences report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AudiencePerformanceReport',
    description: _TL_('To evaluate performance of remarketing campaigns.')
  }, {
    id: 'reports-v4-goalsreport',
    name: _TL_('Goals'),
    title: _TL_('See data on how people behave on your website.'),
    fixedRoute: 'reports-v4/create/goalsreport',
    route: 'reports-v4/create/goalsreport',
    searchAlias: _TL_('Goals report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'GoalsAndFunnelsReport',
    description: _TL_('To understand which campaigns and keywords are leading users to complete a specific type of conversion action. Note: these reports only show data for text ads and do not include shopping, dynamic search ads and audience campaigns conversion data.')
  }, {
    id: 'reports-v4-conversionsreport',
    name: _TL_('Conversions'),
    title: _TL_('See conversion data for your campaigns during a specific time period.'),
    fixedRoute: 'reports-v4/create/conversionsreport',
    route: 'reports-v4/create/conversionsreport',
    searchAlias: _TL_('Conversions report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'ConversionPerformanceReport',
    description: _TL_('To understand which campaigns and keywords are leading customers to complete conversion actions. Note: these reports only show data for text ads and do not include shopping, dynamic search ads and audience campaigns conversion data.')
  }, {
    id: 'reports-v4-feeditemreport',
    name: _TL_('Feed item'),
    title: _TL_('See performance on feed item level.'),
    fixedRoute: 'reports-v4/create/feeditemreport',
    route: 'reports-v4/create/feeditemreport',
    searchAlias: _TL_('Feed item report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'FeedItemPerformanceReport',
    description: _TL_('To view detailed performance statistics for each individual item from the vertical ads inventory including the deleted and inactive Dynamic Data Feed items.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.ReportingUpliftFeedItemReport
  }, {
    id: 'reports-v4-conversionmodelcomparereport',
    name: _TL_('Conversion model compare'),
    title: _TL_('See influence of conversion attribution models.'),
    fixedRoute: 'reports-v4/create/conversionmodelcomparereport',
    route: 'reports-v4/create/conversionmodelcomparereport',
    searchAlias: _TL_('Conversion model compare report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'ConversionModelCompareReport',
    description: _TL_('To discover how different conversion attribution models impact the valuation of your campaigns.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.IsDataDrivenAttributionReportEnabled
  }, {
    id: 'reports-v4-msxaccountperformancereport',
    name: _TL_('MSX account performance'),
    title: _TL_('Access and review daily revenue trends.'),
    fixedRoute: 'reports-v4/create/msxaccountperformancereport',
    route: 'reports-v4/create/msxaccountperformancereport',
    searchAlias: _TL_('MSX account performance report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'MSXAccountPerformanceReport',
    description: _TL_('To access and review daily revenue trends.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.IsMSXAccountPerformanceReportEnabled
  }]
};
exports.performance = performance;

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scope = exports.available = void 0;

var _shared = __webpack_require__(1327);

const available = true;
exports.available = available;
const scope = _shared.allScopes;
exports.scope = scope;

/***/ }),

/***/ 1439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extensions = void 0;

var _common = __webpack_require__(1438);

const extensions = {
  id: 'reports-v4-category-extensions',
  name: _TL_('Ad extensions'),
  title: _TL_('Ad extension reports give you a closer look at how each ad extension is performing based on click type for ads and keywords and ad extension properties for ad groups.'),
  fixedRoute: 'reports-v4/category/extensions',
  route: 'reports-v4/category/extensions',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-extensionkeywordreport',
    name: _TL_('Ad extension by keyword'),
    title: _TL_('See how your extensions perform for your keywords.'),
    fixedRoute: 'reports-v4/create/extensionkeywordreport',
    route: 'reports-v4/create/extensionkeywordreport',
    searchAlias: _TL_('Ad extension by keyword report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdExtensionByKeywordReport',
    description: _TL_('To understand how different click types are performing for each keyword when different ad extensions are shown in the ad.')
  }, {
    id: 'reports-v4-extensionadreport',
    name: _TL_('Ad extension by ad'),
    title: _TL_('See how your extensions perform for your ads.'),
    fixedRoute: 'reports-v4/create/extensionadreport',
    route: 'reports-v4/create/extensionadreport',
    searchAlias: _TL_('Ad extension by ad report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdExtensionByAdReport',
    description: _TL_('To understand how different click types are performing for each ad when the ad is served with different ad extensions.')
  }, {
    id: 'reports-v4-adextensiondetailreport',
    name: _TL_('Ad extension details'),
    title: _TL_('See how engaging your ad extension items are.'),
    fixedRoute: 'reports-v4/create/adextensiondetailreport',
    route: 'reports-v4/create/adextensiondetailreport',
    searchAlias: _TL_('Ad extension details report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'AdExtensionDetailReport',
    description: _TL_('To understand how different ad extension properties are performing when different ad extensions are shown in the ad.')
  }, {
    title: _TL_('See duration and phone spend details for each forwarded call.'),
    id: 'reports-v4-callforwarddetailreport',
    // Duplicate
    name: _TL_('Call forwarding detail'),
    fixedRoute: 'reports-v4/create/callforwarddetailreport',
    route: 'reports-v4/create/callforwarddetailreport',
    searchAlias: _TL_('Call forwarding detail report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'CallDetailReport',
    description: _TL_('To understand how the accounts, campaigns, or ad groups are performing with call extensions.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.dynamic.CallMetering
  }]
};
exports.extensions = extensions;

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productAds = void 0;

var _common = __webpack_require__(1438);

const productAds = {
  id: 'reports-v4-category-productads',
  name: _TL_('Product ads'),
  title: _TL_('Product ad reports give you a closer look at how your Bing Shopping Campaigns are performing based on product partition and product offer data.'),
  fixedRoute: 'reports-v4/category/productads',
  route: 'reports-v4/category/productads',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-productpartitionreport',
    name: _TL_('Product partition'),
    title: _TL_('See the performance of your Product Groups in Shopping Campaigns '),
    fixedRoute: 'reports-v4/create/productpartitionreport',
    route: 'reports-v4/create/productpartitionreport',
    searchAlias: _TL_('Product partition report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProductPartitionPerformanceReport',
    description: _TL_('To see the performance data for the product groups in your shopping campaigns and to optimize your campaigns accordingly .')
  }, {
    id: 'reports-v4-productpartitionunitreport',
    name: _TL_('Product partition unit'),
    title: _TL_('See product partition unit data of your Product Groups in Shopping Campaigns'),
    fixedRoute: 'reports-v4/create/productpartitionunitreport',
    route: 'reports-v4/create/productpartitionunitreport',
    searchAlias: _TL_('Product partition unit report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProductPartitionUnitPerformanceReport',
    description: _TL_('To see product partition unit data of your Product Groups in Shopping Campaigns.')
  }, {
    id: 'reports-v4-productdimensionreport',
    name: _TL_('Product dimension'),
    title: _TL_('See the performance of your Products in Shopping Campaigns '),
    fixedRoute: 'reports-v4/create/productdimensionreport',
    route: 'reports-v4/create/productdimensionreport',
    searchAlias: _TL_('Product dimension report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProductDimensionPerformanceReport',
    description: _TL_('To figure out which of your products are triggering ads and getting most clicks and optimize the ones not performing so well. ')
  }, {
    id: 'reports-v4-productsearchtermreport',
    name: _TL_('Product search term'),
    title: _TL_('See which search terms are causing your ads to display.'),
    fixedRoute: 'reports-v4/create/productsearchtermreport',
    route: 'reports-v4/create/productsearchtermreport',
    searchAlias: _TL_('Product search term report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProductSearchQueryPerformanceReport',
    description: _TL_('To see what your audience is searching for when your Product ads are shown.')
  }, {
    id: 'reports-v4-productmatchcountreport',
    name: _TL_('Product match count'),
    title: _TL_('See how products are distributed acrocss given product tree.'),
    fixedRoute: 'reports-v4/create/productmatchcountreport',
    route: 'reports-v4/create/productmatchcountreport',
    searchAlias: _TL_('Product match count report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProductMatchCountReport',
    description: _TL_('To see if you are covering and bidding across your Microsoft shopping campaigns inventory. Note that this only provides the matched data for your current product group within active campaigns, and you cannot obtain historical views.')
  }, {
    id: 'reports-v4-productnegativekeywordreport',
    name: _TL_('Product negative keyword conflicts'),
    title: _TL_('See a set of negative keyword pairs that are blocking your products from participating in the auction.'),
    fixedRoute: 'reports-v4/create/productnegativekeywordreport',
    route: 'reports-v4/create/productnegativekeywordreport',
    searchAlias: _TL_('Product negative keyword conflicts report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'ProductNegativeKeywordConflictReport',
    description: _TL_('This report tells you which products and negative keywords are in conflict, and whether the conflict is at the campaign or ad group level. Use this list to figure out which negative keywords to delete.')
  }]
};
exports.productAds = productAds;

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeHistory = void 0;

var _common = __webpack_require__(1438);

const changeHistory = {
  id: 'reports-v4-category-changehistory',
  name: _TL_('Change history'),
  title: _TL_('See the changes that have been made to your campaigns and users within an account, over a period you specify.'),
  fixedRoute: 'reports-v4/category/changehistory',
  route: 'reports-v4/category/changehistory',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-changehistoryreport',
    name: _TL_('Change history'),
    title: _TL_('See a list of changes that have been made to your campaigns.'),
    fixedRoute: 'reports-v4/create/changehistoryreport',
    route: 'reports-v4/create/changehistoryreport',
    searchAlias: _TL_('Change history report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'SearchCampaignChangeHistoryReport',
    description: _TL_('To discover when changes to an account were made, as well as which user made the changes.')
  }, {
    id: 'reports-v4-userrolechangehistoryreport',
    name: _TL_('User role change history'),
    title: _TL_('See what changes have been made to individual user profiles in your accounts.'),
    fixedRoute: 'reports-v4/create/userrolechangehistoryreport',
    route: 'reports-v4/create/userrolechangehistoryreport',
    searchAlias: _TL_('User role change history report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'UserRoleChangeHistoryReport',
    description: _TL_('See what changes have been made to individual user profiles in your accounts.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }, {
    id: 'reports-v4-fraudchangehistoryreport',
    name: _TL_('Fraud change history by user'),
    title: _TL_('See a list of changes, filtered by user, that shows potentially fraudulent activity.'),
    fixedRoute: 'reports-v4/create/fraudchangehistoryreport',
    route: 'reports-v4/create/fraudchangehistoryreport',
    searchAlias: _TL_('Fraud change history by user report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'FraudChangeHistoryReport',
    description: _TL_('See a list of changes, filtered by user, that shows potentially fraudulent activity.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }]
};
exports.changeHistory = changeHistory;

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targeting = void 0;

var _common = __webpack_require__(1438);

var _shared = __webpack_require__(1327);

const accountLevelScopes = _common.scope.filter(_scope => _scope !== _shared.Scope.Customer);

const targeting = {
  id: 'reports-v4-category-targeting',
  name: _TL_('Targeting'),
  title: _TL_('See how your campaigns are doing among the people and places who are seeing your ads.'),
  fixedRoute: 'reports-v4/category/targeting',
  route: 'reports-v4/category/targeting',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-ageandgenderreport',
    name: _TL_('Age and gender'),
    // Duplicate
    title: _TL_('See total impressions and clicks for each campaign or ad group, organized by gender and age group.'),
    fixedRoute: 'reports-v4/create/ageandgenderreport',
    route: 'reports-v4/create/ageandgenderreport',
    searchAlias: _TL_('Age and gender report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'AgeGenderAudienceReport',
    description: _TL_('To discover how your campaigns and ad groups are resonating with different age groups and genders.')
  }, {
    id: 'reports-v4-genrereport',
    name: _TL_('Genre'),
    // Duplicate
    title: _TL_('Genre.'),
    fixedRoute: 'reports-v4/create/dealgenrereport',
    route: 'reports-v4/create/dealgenrereport',
    searchAlias: _TL_('Genre report'),
    scope: accountLevelScopes,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'GenrePerformanceReport',
    description: _TL_('To find out which genre targets have the best ad performance. You can then validate whether your genre targeting is successful and identify opportunities for improvements.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.AIMCampaign && permissions.dynamic.XandrVideoCampaigns && permissions.dynamic.GenreTargets
  }, {
    id: 'reports-v4-professionaldemographicsreport',
    name: _TL_('Professional demographics'),
    title: _TL_('See total impressions and clicks for each campaign or ad group, organized by company, industry, and job function.'),
    fixedRoute: 'reports-v4/create/professionaldemographicsreport',
    route: 'reports-v4/create/professionaldemographicsreport',
    searchAlias: _TL_('Professional demographics report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'ProfessionalDemographicsAudienceReport',
    description: _TL_('To discover how your campaigns and ad groups are resonating with different companies, industries, and job functions.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.dynamic.LinkedInTargeting || !!permissions.dynamic.AIMCampaign
  }, {
    id: 'reports-v4-userlocationreport',
    name: _TL_('User location'),
    // Duplicate
    title: _TL_('See total impressions and clicks for each ad group, organized by the locations where your ads were shown.'),
    fixedRoute: 'reports-v4/create/userlocationreport',
    route: 'reports-v4/create/userlocationreport',
    searchAlias: _TL_('User location report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'UserLocationPerformanceReport',
    description: _TL_('To see where your traffic is coming from broken out by the physical location and the location people are searching for. You can then validate whether your location targeting strategy is successful, and identify opportunities to improve.')
  }, {
    id: 'reports-v4-geographicreport',
    name: _TL_('Geographic'),
    // Duplicate
    title: _TL_('See total impressions and clicks for each ad group, organized by the locations where your ads were shown.'),
    fixedRoute: 'reports-v4/create/geographicreport',
    route: 'reports-v4/create/geographicreport',
    searchAlias: _TL_('Geographic report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'GeographicPerformanceReport',
    description: _TL_('To see where your traffic is coming from: the physical location of the people searching for your ad or the locations people are searching for. You can then validate whether your location targeting strategy is successful and identify opportunities to improve.')
  }]
};
exports.targeting = targeting;

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingAndBudget = void 0;

var _common = __webpack_require__(1438);

const billingAndBudget = {
  id: 'reports-v4-category-billingandbudget',
  name: _TL_('Billing and budget'),
  title: _TL_('See how you are spending your budget, and your most recent billing statement.'),
  fixedRoute: 'reports-v4/category/billingandbudget',
  route: 'reports-v4/category/billingandbudget',
  scope: _common.scope,
  available: _common.available,
  children: [{
    id: 'reports-v4-budgetreport',
    name: _TL_('Budget'),
    title: _TL_('See how you’ve spent your budget over a specific date range.'),
    fixedRoute: 'reports-v4/create/budgetreport',
    route: 'reports-v4/create/budgetreport',
    searchAlias: _TL_('Budget report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'BudgetSummaryReport',
    description: _TL_('To help control and manage your advertising spend for a particular month.')
  }, {
    id: 'reports-v4-customerinvoicereport',
    name: _TL_('Manager account invoice billing'),
    title: _TL_('See your detailed billing history.'),
    fixedRoute: 'reports-v4/create/customerinvoicereport',
    route: 'reports-v4/create/customerinvoicereport',
    searchAlias: _TL_('Manager account invoice billing report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'CustomerInvoiceReport',
    description: _TL_('See your detailed billing history.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }, {
    id: 'reports-v4-billingstatementreport',
    name: _TL_('Billing statement'),
    title: _TL_('See your most recent billing statement.'),
    fixedRoute: 'reports-v4/create/billingstatementreport',
    route: 'reports-v4/create/billingstatementreport',
    searchAlias: _TL_('Billing statement report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'BillingStatementReport',
    description: _TL_('To view an overall summary of your billing information.')
  }]
};
exports.billingAndBudget = billingAndBudget;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advancedInsights = void 0;

var _common = __webpack_require__(1438);

const advancedInsights = {
  id: 'reports-v4-category-advancedinsights',
  name: _TL_('Advanced insights'),
  title: _TL_('Find advanced insights into how your advertisers are performing'),
  fixedRoute: 'reports-v4/category/advancedinsights',
  route: 'reports-v4/category/advancedinsights',
  scope: _common.scope,
  available: _common.available,
  checkPermission:
  /* istanbul ignore next */
  permissions => !!permissions.IsInternalUser,
  children: [{
    id: 'reports-v4-sixweekaccountactivityreport',
    name: _TL_('Account - 6 weeks'),
    title: _TL_('See how individual accounts are performing with excel charts and graphs'),
    fixedRoute: 'reports-v4/create/sixweekaccountactivityreport',
    route: 'reports-v4/create/sixweekaccountactivityreport',
    searchAlias: _TL_('Account - 6 weeks report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'AccountPerformanceReport-SixWeeks',
    description: _TL_('See how individual accounts are performing with excel charts and graphs'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }, {
    id: 'reports-v4-twomonthaccountactivityreport',
    name: _TL_('Account - 2 months (MoM)'),
    title: _TL_('See how individual accounts are performing with excel charts and graphs'),
    fixedRoute: 'reports-v4/create/twomonthaccountactivityreport',
    route: 'reports-v4/create/twomonthaccountactivityreport',
    searchAlias: _TL_('Account - 2 months (MoM) report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'AccountPerformanceReport-TwoMonths',
    description: _TL_('See how individual accounts are performing with excel charts and graphs'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }, {
    id: 'reports-v4-twoyearaccountactivityreport',
    name: _TL_('Account - 2 years (YoY)'),
    title: _TL_('See how individual accounts are performing with excel charts and graphs'),
    fixedRoute: 'reports-v4/create/twoyearaccountactivityreport',
    route: 'reports-v4/create/twoyearaccountactivityreport',
    searchAlias: _TL_('Account - 2 years (YoY) report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'AccountPerformanceReport-TwoYears',
    description: _TL_('See how individual accounts are performing with excel charts and graphs'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }, {
    id: 'reports-v4-advancedinsightsshareofvoicereport',
    name: _TL_('Account - Share of voice'),
    title: _TL_('See estimated impressions you might be losing.'),
    fixedRoute: 'reports-v4/create/advancedinsightsshareofvoicereport',
    route: 'reports-v4/create/advancedinsightsshareofvoicereport',
    searchAlias: _TL_('Account - Share of voice report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'AccountPerformanceReport-ShareOfVoice',
    description: _TL_('To view impression share (%) of successful bids for each keyword, and identify opportunities to increase impression share.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.IsInternalUser
  }]
};
exports.advancedInsights = advancedInsights;

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicSearch = void 0;

var _common = __webpack_require__(1438);

const dynamicSearch = {
  id: 'reports-v4-category-dynamicsearch',
  name: _TL_('Dynamic search ads'),
  title: _TL_('Dynamic search ads reports allow you to see a holistic view of your campaigns’ dynamic ad target, category, and search term performance.'),
  fixedRoute: 'reports-v4/category/dynamicsearch',
  route: 'reports-v4/category/dynamicsearch',
  scope: _common.scope,
  available: _common.available,
  checkPermission:
  /* istanbul ignore next */
  permissions => !!permissions.dynamic.DynamicSearchAdsV1,
  children: [{
    id: 'reports-v4-dsadautotargetreport',
    name: _TL_('Dynamic search ad auto target'),
    title: _TL_('See the clicks, impressions, and other performance metrics of each of your dynamic ad targets.'),
    fixedRoute: 'reports-v4/create/dsadautotargetreport',
    route: 'reports-v4/create/dsadautotargetreport',
    searchAlias: _TL_('Dynamic search ad auto target'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'DSAAutoTargetPerformanceReport',
    description: _TL_('To understand how your dynamic ad targets are performing and where bid adjustments may be useful.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.dynamic.DynamicSearchAdsV1
  }, {
    id: 'reports-v4-dsadcategoryreport',
    name: _TL_('Dynamic search ad category'),
    title: _TL_('See the clicks, impressions, and other performance generated from your website.'),
    fixedRoute: 'reports-v4/create/dsadcategoryreport',
    route: 'reports-v4/create/dsadcategoryreport',
    searchAlias: _TL_('Dynamic search ad category report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'DSACategoryPerformanceReport',
    description: _TL_('To check the performance of your existing category targets or to find new categories worth targeting. '),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.dynamic.DynamicSearchAdsV1
  }, {
    id: 'reports-v4-dsadsearchtermreport',
    name: _TL_('Dynamic search ad search term'),
    title: _TL_('See search terms that triggered your dynamic search ads and their corresponding headlines, final URLs, and associated performance metrics.'),
    fixedRoute: 'reports-v4/create/dsadsearchtermreport',
    route: 'reports-v4/create/dsadsearchtermreport',
    searchAlias: _TL_('Dynamic search ad search term report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'DSASearchQueryPerformanceReport',
    description: _TL_("To see how your ads perform against search terms. The data can help you find negative keywords (so that you're not spending money targeting the wrong customer), as well as the right keywords that create conversions. "),
    checkPermission:
    /* istanbul ignore next */
    permissions => !!permissions.dynamic.DynamicSearchAdsV1
  }]
};
exports.dynamicSearch = dynamicSearch;

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;

var _shared = __webpack_require__(1327);

const accountLevelScopes = _shared.allScopes.filter(scope => scope !== _shared.Scope.Customer);

const labels = {
  id: 'reports-v4-labels',
  name: _TL_('Labels'),
  dropdown: 'right',
  scope: _shared.allScopes,
  route: 'reports-v4/category/labels',
  children: [{
    id: 'reports-v4-report-labels-keyword',
    name: _TL_('Labels - Keyword'),
    searchAlias: _TL_('Labels - Keyword report'),
    route: 'reports-v4/create/labelskeywordreport',
    scope: accountLevelScopes,
    apiKey: 'LabelKeywordReport',
    description: _TL_('See performance data based on keyword labels and see if there are any patterns of performance based on labels.')
  }, {
    id: 'reports-v4-report-labels-ad',
    name: _TL_('Labels - Ad'),
    searchAlias: _TL_('Labels - Ad report'),
    route: 'reports-v4/create/labelsadreport',
    scope: accountLevelScopes,
    apiKey: 'LabelAdReport',
    description: _TL_('See performance data based on ad labels and see if there are any patterns of performance based on labels.')
  }, {
    id: 'reports-v4-report-labels-ad-group',
    name: _TL_('Labels - Ad group'),
    searchAlias: _TL_('Labels - Ad group report'),
    route: 'reports-v4/create/labelsadgroupreport',
    scope: accountLevelScopes,
    apiKey: 'LabelAdGroupReport',
    description: _TL_('See performance data based on ad group labels and see if there are any patterns of performance based on labels.')
  }, {
    id: 'reports-v4-report-labels-campaign',
    name: _TL_('Labels - Campaign'),
    searchAlias: _TL_('Labels - Campaign report'),
    route: 'reports-v4/create/labelscampaignreport',
    scope: accountLevelScopes,
    apiKey: 'LabelCampaignReport',
    description: _TL_('See performance data based on campaign labels and see if there are any patterns of performance based on labels.')
  }, {
    id: 'report-v4-labels-account',
    name: _TL_('Labels - Account'),
    searchAlias: _TL_('Labels - Account report'),
    route: 'reports-v4/create/labelsaccountreport',
    scope: [_shared.Scope.Customer],
    apiKey: 'LabelAccountReport',
    description: _TL_('See performance data based on account labels and see if there are any patterns of performance based on labels.')
  }]
};
exports.labels = labels;

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.property = exports.hotel = void 0;

var _common = __webpack_require__(1438);

const hotel = {
  id: 'reports-v4-category-hotel',
  name: _TL_('Hotel'),
  title: _TL_('Hotel'),
  fixedRoute: 'reports-v4/category/hotel',
  route: 'reports-v4/category/hotel',
  scope: _common.scope,
  available: _common.available,
  checkPermission:
  /* istanbul ignore next */
  permissions => permissions.dynamic.HotelCampaign && !permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'reports-v4-hoteldimensionreport',
    name: _TL_('Hotel dimension'),
    title: _TL_('Hotel dimension'),
    fixedRoute: 'reports-v4/create/hoteldimensionreport',
    route: 'reports-v4/create/hoteldimensionreport',
    searchAlias: _TL_('Hotel dimension report'),
    scope: _common.scope,
    available: _common.available,
    apiKey: 'HotelDimensionPerformanceReport',
    description: _TL_('To figure out which of your hotels are triggering ads and getting most clicks and optimize the ones not performing so well.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign
  }, {
    id: 'reports-v4-hotelgroupreport',
    name: _TL_('Hotel group'),
    title: _TL_('Hotel group'),
    fixedRoute: 'reports-v4/create/hotelgroupperformancereport',
    route: 'reports-v4/create/hotelgroupperformancereport',
    searchAlias: _TL_('Hotel group report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'HotelGroupPerformanceReport',
    description: _TL_('To figure out which of your hotels are triggering ads and getting most clicks and optimize the ones not performing so well.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign
  }, {
    id: 'reports-v4-matchingreport',
    name: _TL_('Matching'),
    title: _TL_('Matching'),
    fixedRoute: 'reports-v4/create/matchingreport',
    route: 'reports-v4/create/matchingreport',
    searchAlias: _TL_('Matching report'),
    scope: _common.scope,
    scopeFilterLevel: ['Account', 'Campaign'],
    available: _common.available,
    apiKey: 'UIMatchingReport',
    description: _TL_('To see issues which may be preventing your hotels from serving. '),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign
  }, {
    id: 'reports-v4-pricefeedstatusreport',
    name: _TL_('Price feed status'),
    title: _TL_('Price feed status'),
    fixedRoute: 'reports-v4/create/pricefeedstatusreport',
    route: 'reports-v4/create/pricefeedstatusreport',
    searchAlias: _TL_('Price feed status report'),
    scope: _common.scope,
    scopeFilterLevel: ['Account', 'Campaign'],
    available: _common.available,
    apiKey: 'UIPriceFeedStatusReport',
    description: _TL_('To track the status of your pricing updates (transactions).'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign
  }]
};
exports.hotel = hotel;
const property = {
  id: 'reports-v4-category-property',
  name: _TL_('Property'),
  title: _TL_('Property'),
  fixedRoute: 'reports-v4/category/property',
  route: 'reports-v4/category/property',
  scope: _common.scope,
  available: _common.available,
  checkPermission:
  /* istanbul ignore next */
  permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled,
  children: [{
    id: 'reports-v4-propertydimensionreport',
    name: _TL_('Property dimension'),
    title: _TL_('Property dimension'),
    fixedRoute: 'reports-v4/create/propertydimensionreport',
    route: 'reports-v4/create/propertydimensionreport',
    searchAlias: _TL_('Property dimension report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'HotelDimensionPerformanceReport',
    description: _TL_('To figure out which of your properties are triggering ads and getting most clicks and optimize the ones not performing so well.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled
  }, {
    id: 'reports-v4-propertygroupreport',
    name: _TL_('Property group'),
    title: _TL_('Property group'),
    fixedRoute: 'reports-v4/create/propertygroupperformancereport',
    route: 'reports-v4/create/propertygroupperformancereport',
    searchAlias: _TL_('Property group report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    available: _common.available,
    apiKey: 'HotelGroupPerformanceReport',
    description: _TL_('To figure out which of your properties are triggering ads and getting most clicks and optimize the ones not performing so well.'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled
  }, {
    id: 'reports-v4-matchingreport',
    name: _TL_('Matching'),
    title: _TL_('Matching'),
    fixedRoute: 'reports-v4/create/matchingreport',
    route: 'reports-v4/create/matchingreport',
    searchAlias: _TL_('Matching report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    scopeFilterLevel: ['Account', 'Campaign'],
    available: _common.available,
    apiKey: 'UIMatchingReport',
    description: _TL_('To see issues which may be preventing your hotels from serving. '),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled
  }, {
    id: 'reports-v4-pricefeedstatusreport',
    name: _TL_('Price feed status'),
    title: _TL_('Price feed status'),
    fixedRoute: 'reports-v4/create/pricefeedstatusreport',
    route: 'reports-v4/create/pricefeedstatusreport',
    searchAlias: _TL_('Price feed status report'),
    scope: _common.scope,
    apexViewName: 'reports-v4_create',
    scopeFilterLevel: ['Account', 'Campaign'],
    available: _common.available,
    apiKey: 'UIPriceFeedStatusReport',
    description: _TL_('To track the status of your pricing updates (transactions).'),
    checkPermission:
    /* istanbul ignore next */
    permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled
  }]
};
exports.property = property;

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customized = void 0;

var _shared = __webpack_require__(1327);

const customized = {
  id: 'reports-v4-my-reports-customized',
  name: _TL_('Saved customized reports'),
  title: _TL_('View reports that you have customized and saved'),
  route: 'reports-v4/my-reports/customized',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed
};
exports.customized = customized;

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shared = void 0;

var _shared = __webpack_require__(1327);

const shared = {
  id: 'reports-v4-my-reports-shared',
  name: _TL_('Reports shared with me'),
  title: _TL_('View reports that shared with me'),
  route: 'reports-v4/my-reports/shared',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed
};
exports.shared = shared;

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "importPages", {
  enumerable: true,
  get: function get() {
    return _imports.importPages;
  }
});
Object.defineProperty(exports, "flatSmartImportPages", {
  enumerable: true,
  get: function get() {
    return _imports.flatSmartImportPages;
  }
});

var _imports = __webpack_require__(1451);

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatSmartImportPages = exports.importPages = exports.importSchedule = exports.fileImport = exports.pinterestImport = exports.amazonImport = exports.facebookImport = exports.googleImport = void 0;

var _shared = __webpack_require__(1327);

var _importCenter = __webpack_require__(1452);

_shared.ScopeV2.add('TaskItemId', 'taskItemId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('TaskItemId', 'taskItemId', _shared.ScopeV2.Customer);

_shared.ScopeV2.add('ImportId', 'importId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('ImportId', 'importId', _shared.ScopeV2.Customer);

_shared.ScopeV2.add('ImportStep', 'importStep', _shared.ScopeV2.TaskItemId);

_shared.ScopeV2.add('OpportunityId', 'opportunityId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('OpportunityId', 'opportunityId', _shared.ScopeV2.Customer);

_shared.ScopeV2.add('OpportunityType', 'opportunityType', _shared.ScopeV2.OpportunityId);

_shared.ScopeV2.add('Source', 'source', _shared.ScopeV2.OpportunityType);

_shared.ScopeV2.add('ImportType', 'importType', _shared.ScopeV2.Account);

_shared.ScopeV2.add('ImportScheduleRecSrc', 'recsrc', _shared.ScopeV2.ImportType);

_shared.ScopeV2.add('DidSwitchToExpertFromImport', 'didSwitchToExpertFromImport', _shared.ScopeV2.Account);

const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.TaskItemId, _shared.ScopeV2.ImportId, _shared.ScopeV2.ImportStep, _shared.ScopeV2.DidSwitchToExpertFromImport];
const importScheduleScopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.ImportType, _shared.ScopeV2.ImportScheduleRecSrc];
const googleImport = {
  id: 'import-google',
  name: _TL_('Import from Google Ads'),
  checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled,
  route: 'googleimport',
  scope: _shared.allScopes,
  scopeV2
};
exports.googleImport = googleImport;
const facebookImport = {
  id: 'import-facebook',
  name: _TL_('Import from Facebook Ads'),
  checkPermission: permissions => permissions.dynamic.FacebookImport && !permissions.IsDomesticSimplifiedChineseEnabled,
  route: 'facebookimport',
  campaignTypes: _shared.alwaysDisplayed,
  scope: _shared.defaultScopes,
  scopeV2
};
exports.facebookImport = facebookImport;
const amazonImport = {
  id: 'import-amazon',
  name: _TL_('Import from Amazon Ads'),
  checkPermission: permissions => (permissions.IsAmazonImportEnabled || permissions.dynamic.AmazonImport) && !permissions.IsDomesticSimplifiedChineseEnabled,
  route: 'amazonimport',
  campaignTypes: _shared.alwaysDisplayed,
  scope: _shared.defaultScopes,
  scopeV2,
  showTag: {
    text: 'New',
    expDate: new Date('2024/12/31')
  }
};
exports.amazonImport = amazonImport;
const pinterestImport = {
  id: 'import-pinterest',
  name: _TL_('Import from Pinterest Ads'),
  checkPermission: permissions => (permissions.IsPinterestImportEnabled || permissions.dynamic.PinterestImport) && !permissions.IsDomesticSimplifiedChineseEnabled,
  route: 'pinterestimport',
  campaignTypes: _shared.alwaysDisplayed,
  scope: _shared.defaultScopes,
  scopeV2,
  showTag: {
    text: 'New',
    expDate: new Date('2023/12/31')
  }
};
exports.pinterestImport = pinterestImport;
const fileImport = {
  id: 'import-file',
  name: _TL_('Import from file'),
  route: 'fileimport',
  scope: _shared.defaultScopes,
  scopeV2
};
exports.fileImport = fileImport;
const importSchedule = {
  id: 'import-schedule',
  name: _TL_('Import schedule & history'),
  route: 'importschedule',
  campaignTypes: _shared.alwaysDisplayed,
  scope: _shared.allScopes,
  scopeV2: importScheduleScopeV2
};
exports.importSchedule = importSchedule;
const importPages = [googleImport, facebookImport, amazonImport, pinterestImport, fileImport, importSchedule, _importCenter.importCenter];
exports.importPages = importPages;
const flatSmartImportPages = [googleImport, importSchedule, _importCenter.importCenter];
exports.flatSmartImportPages = flatSmartImportPages;

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importCenter = void 0;

var _shared = __webpack_require__(1327);

const importCenter = {
  id: 'import-center',
  name: _TL_('Import Management'),
  scope: _shared.allScopes,
  smartAccountEnabled: true,
  children: [{
    id: 'import-center',
    name: _TL_('Import Management'),
    route: 'importcenter/all',
    scope: _shared.allScopes,
    smartAccountEnabled: true,
    checkPermission: permissions => permissions.dynamic.ImportCenterPrototype,
    children: [{
      id: 'all-imports',
      name: _TL_('All Imports'),
      route: 'importcenter/all',
      scope: _shared.allScopes,
      smartAccountEnabled: true,
      children: [{
        id: 'dashboard',
        name: _TL_('Dashboard'),
        route: 'importcenter/all/dashboard',
        smartAccountEnabled: true,
        scope: _shared.allScopes
      }, {
        id: 'recommendations',
        name: _TL_('Recommendations'),
        route: 'importcenter/all/recommendations',
        smartAccountEnabled: true,
        scope: _shared.allScopes
      }]
    }, {
      id: 'google-imports',
      name: _TL_('Google Imports'),
      route: 'importcenter/google/import',
      checkPermission: permissions => !permissions.IsDomesticSimplifiedChineseEnabled,
      scope: _shared.allScopes,
      smartAccountEnabled: true,
      children: [{
        id: 'google-import',
        name: _TL_('Import'),
        route: 'importcenter/google/import',
        smartAccountEnabled: true,
        scope: _shared.allScopes
      }, {
        id: 'google-schedule',
        name: _TL_('Schedule'),
        route: 'importcenter/google/schedule',
        smartAccountEnabled: true,
        scope: _shared.allScopes
      }, {
        id: 'google-History',
        name: _TL_('History'),
        route: 'importcenter/google/history',
        smartAccountEnabled: true,
        scope: _shared.allScopes
      }]
    }, {
      id: 'facebook-imports',
      name: _TL_('Facebook Imports'),
      route: 'importcenter/facebook/import',
      checkPermission: permissions => permissions.dynamic.FacebookImport && !permissions.IsDomesticSimplifiedChineseEnabled,
      scope: _shared.defaultScopes,
      smartAccountEnabled: false,
      children: [{
        id: 'facebook-import',
        name: _TL_('Import'),
        route: 'importcenter/facebook/import',
        scope: _shared.defaultScopes
      }, {
        id: 'facebook-schedule',
        name: _TL_('Schedule'),
        route: 'importcenter/facebook/schedule',
        scope: _shared.defaultScopes
      }, {
        id: 'facebook-History',
        name: _TL_('History'),
        route: 'importcenter/facebook/history',
        scope: _shared.defaultScopes
      }]
    }, {
      id: 'amazon-imports',
      name: _TL_('Amazon Imports'),
      route: 'importcenter/amazon/import',
      checkPermission: permissions => (permissions.IsAmazonImportEnabled || permissions.dynamic.AmazonImport) && !permissions.IsDomesticSimplifiedChineseEnabled,
      scope: _shared.defaultScopes,
      smartAccountEnabled: false,
      children: [{
        id: 'amazon-import',
        name: _TL_('Import'),
        route: 'importcenter/amazon/import',
        scope: _shared.defaultScopes
      }, {
        id: 'amazon-schedule',
        name: _TL_('Schedule'),
        route: 'importcenter/amazon/schedule',
        scope: _shared.defaultScopes
      }, {
        id: 'amazon-History',
        name: _TL_('History'),
        route: 'importcenter/amazon/history',
        scope: _shared.defaultScopes
      }]
    }, {
      id: 'pinterest-imports',
      name: _TL_('Pinterest Imports'),
      route: 'importcenter/pinterest/import',
      checkPermission: permissions => (permissions.IsPinterestImportEnabled || permissions.dynamic.PinterestImport) && !permissions.IsDomesticSimplifiedChineseEnabled,
      scope: _shared.defaultScopes,
      smartAccountEnabled: false,
      children: [{
        id: 'pinterest-import',
        name: _TL_('Import'),
        route: 'importcenter/pinterest/import',
        scope: _shared.defaultScopes
      }, {
        id: 'pinterest-schedule',
        name: _TL_('Schedule'),
        route: 'importcenter/pinterest/schedule',
        scope: _shared.defaultScopes
      }, {
        id: 'pinterest-History',
        name: _TL_('History'),
        route: 'importcenter/pinterest/history',
        scope: _shared.defaultScopes
      }]
    }, {
      id: 'file-imports',
      name: _TL_('File Imports'),
      route: 'importcenter/file/import',
      scope: _shared.defaultScopes,
      smartAccountEnabled: false,
      children: [{
        id: 'file-import',
        name: _TL_('Import'),
        route: 'importcenter/file/import',
        scope: _shared.defaultScopes
      }, {
        id: 'file-History',
        name: _TL_('History'),
        route: 'importcenter/file/history',
        scope: _shared.defaultScopes
      }]
    }]
  }]
};
exports.importCenter = importCenter;

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartCampaignPages = void 0;

var _shared = __webpack_require__(1327);

const smartCampaignPages = [{
  id: 'smart-campaigns',
  name: _TL_('Smart Campaigns'),
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'smart-campaigns',
    name: _TL_('Smart Campaigns'),
    route: '',
    campaignTypes: _shared.alwaysDisplayed
  }]
}];
exports.smartCampaignPages = smartCampaignPages;

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adInsightPages = exports.adPreview = void 0;

var _shared = __webpack_require__(1327);

const keywordPlanner = {
  id: 'adinsight-keyword-planner',
  name: _TL_('Keyword planner'),
  route: 'keywordplanner'
};
const adPreview = {
  id: 'adinsight-ad-preview',
  name: _TL_('Ad preview & diagnostics'),
  route: 'adpreview',
  scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup]
};
exports.adPreview = adPreview;
const adInsightPages = [{
  id: 'adinsight',
  name: _TL_('Planning'),
  campaignTypes: _shared.alwaysDisplayed,
  children: [keywordPlanner, adPreview]
}];
exports.adInsightPages = adInsightPages;

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standalonePages = void 0;

var _adgroupCreate = __webpack_require__(1456);

var _campaignCreate = __webpack_require__(1457);

var _associationCreate = __webpack_require__(1458);

var _audienceCreate = __webpack_require__(1459);

var _accountCreate = __webpack_require__(1460);

var _accountLinking = __webpack_require__(1461);

var _accountsTransfer = __webpack_require__(1462);

var _accountsUnlinking = __webpack_require__(1463);

var _pendingTransferRequest = __webpack_require__(1464);

var _performanceTargetsCreate = __webpack_require__(1465);

var _performanceTargetsOverview = __webpack_require__(1466);

var _sharedBudgetEdit = __webpack_require__(1467);

var _portfolioBidStrategyDetails = __webpack_require__(1468);

var _conversionGoalsCreate = __webpack_require__(1469);

var _conversionValueRulesCreate = __webpack_require__(1470);

var _uetTagsCreate = __webpack_require__(1471);

var _adCustomizerFeedsItems = __webpack_require__(1472);

var _dynamicDataFeedsItems = __webpack_require__(1473);

var _pageFeedsItems = __webpack_require__(1474);

var _ruleDetail = __webpack_require__(1475);

var _bulkEditDetail = __webpack_require__(1476);

var _scripts = __webpack_require__(1477);

var _negativeKeywordsListsDetails = __webpack_require__(1478);

var _merchantCenterStoreCreate = __webpack_require__(1479);

var _recommendationHistory = __webpack_require__(1480);

var _recommendationRsaAsset = __webpack_require__(1481);

var _bulkUploadsBuildSpreadsheet = __webpack_require__(1482);

var _optOutMinors = __webpack_require__(1483);

var _recommendationAutoApplySettings = __webpack_require__(1484);

var _recommendationAutoApplyBulkUpload = __webpack_require__(1485);

var _importCredentialId = __webpack_require__(1486);

var _queryInsights = __webpack_require__(1487);

var _recommendationImageAsset = __webpack_require__(1488);

var _pmaxDetails = __webpack_require__(1489);

var _budgetCenterCampaignBudgetTool = __webpack_require__(1490);

const standalonePages = [_campaignCreate.campaignCreate, _adgroupCreate.adgroupCreate, _associationCreate.associationCreate, _audienceCreate.audienceCreate, _performanceTargetsCreate.performanceTargetsCreate, _performanceTargetsOverview.performanceTargetsOverview, _sharedBudgetEdit.sharedBudgetsEditPage, _portfolioBidStrategyDetails.portfolioBidStrategyDetails, _audienceCreate.audienceEdit, _accountCreate.accountCreate, _accountLinking.accountLinking, _accountsUnlinking.accountsUnlinking, _accountsTransfer.accountsTransfer, _pendingTransferRequest.pendingTransferRequest, _conversionGoalsCreate.conversionGoalsCreate, _conversionGoalsCreate.conversionGoalsEdit, _uetTagsCreate.uetTagsCreate, _uetTagsCreate.uetTagsEdit, _conversionValueRulesCreate.conversionValueRulesCreate, _conversionValueRulesCreate.conversionValueRulesEdit, _adCustomizerFeedsItems.adCustomizerFeedsItems, _pageFeedsItems.pageFeedsItems, _dynamicDataFeedsItems.dynamicDataFeedsItems, _ruleDetail.ruleDetail, _bulkEditDetail.bulkEditDetail, _scripts.scriptsDetail, _negativeKeywordsListsDetails.negativeKeywordsListsDetail, _merchantCenterStoreCreate.merchanteCenterStoreCreate, _recommendationHistory.recommendationHistory, _recommendationRsaAsset.recommendationRSAAsset, _bulkUploadsBuildSpreadsheet.bulkUploadsBuildSpreadsheet, _optOutMinors.optOutForMinors, _recommendationAutoApplySettings.recommendationAutoApplySettings, _recommendationAutoApplyBulkUpload.recommendationAutoApplyBulkUpload, _importCredentialId.importCredentialIdPages, _queryInsights.queryInsights, _recommendationImageAsset.recommendationImageAsset, _pmaxDetails.pmaxDetails, _pmaxDetails.assetGroupCreate, _pmaxDetails.assetGroupEdit, _budgetCenterCampaignBudgetTool.budgetCenterCampaignBudgetTool];
exports.standalonePages = standalonePages;

/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adgroupCreate = void 0;
const adgroupCreate = {
  id: 'adgroup-create',
  name: _TL_('New ad group'),
  children: [{
    id: 'adgroup-create',
    name: _TL_('Create an ad group'),
    route: 'createadgroup'
  }]
};
exports.adgroupCreate = adgroupCreate;

/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignCreate = void 0;

var _shared = __webpack_require__(1327);

const campaignCreate = {
  id: 'campaign-create',
  name: _TL_('New campaign'),
  route: 'createcampaign/objective',
  scope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'campaign-create-objective',
    name: _TL_('New campaign'),
    route: 'createcampaign/objective',
    campaignTypes: _shared.alwaysDisplayed,
    searchable: true
  }, {
    id: 'campaign-create-search',
    name: _TL_('New campaign'),
    route: 'createcampaign/search',
    campaignTypes: _shared.alwaysDisplayed
  }, {
    id: 'campaign-create-audience',
    name: _TL_('New campaign'),
    route: 'createcampaign/audience',
    campaignTypes: _shared.alwaysDisplayed
  }, {
    id: 'campaign-create-audience-simplified',
    name: _TL_('New campaign'),
    route: 'createcampaign/newaudience',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsNewStaticAudienceCampaignCreationEnabled
  }, {
    id: 'campaign-create-shopping',
    name: _TL_('New campaign'),
    route: 'createcampaign/searchshopping',
    campaignTypes: _shared.alwaysDisplayed
  }, {
    id: 'campaign-create-shoppingaudience',
    name: _TL_('New campaign'),
    route: 'createcampaign/audienceshopping',
    campaignTypes: _shared.alwaysDisplayed
  }, {
    id: 'campaign-create-videoaudience',
    name: _TL_('New campaign'),
    route: 'createcampaign/audiencevideo',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsVideoAdsForCampaignEnabled && !permissions.dynamic.XandrVideoCampaigns
  }, {
    id: 'campaign-create-xandr-video',
    name: _TL_('New campaign'),
    route: 'createcampaign/awareness',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.XandrVideoCampaigns
  }, {
    id: 'campaign-create-xandr-display-ads',
    name: _TL_('New campaign'),
    route: 'createcampaign/displayads',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.XandrDisplayAdsCampaigns
  }, {
    id: 'campaign-create-xandr-mediapackage',
    name: _TL_('New campaign'),
    route: 'createcampaign/mediapackage',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsDealEnabledForMsAds
  }, {
    id: 'campaign-create-xandr-mediadeal',
    name: _TL_('New campaign'),
    route: 'createcampaign/awarenessmediadeal',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsDealEnabledForMsAds
  }, {
    id: 'campaign-create-display-plus',
    name: _TL_('New campaign'),
    route: 'createcampaign/displayplus',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.DisplayPlusCampaigns
  }, {
    id: 'campaign-create-smart-shopping',
    name: _TL_('New Campaign'),
    route: 'createcampaign/smartshopping',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.SmartShoppingCampaign || permissions.IsSmartShoppingCampaignEnabled
  }, {
    id: 'campaign-create-hotel',
    name: _TL_('New campaign'),
    route: 'createcampaign/hotel',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.HotelCampaign && !permissions.dynamic.IsRenameHotelToLodgingEnabled
  }, {
    id: 'campaign-create-lodging',
    name: _TL_('New campaign'),
    route: 'createcampaign/lodging',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.HotelCampaign && permissions.dynamic.IsRenameHotelToLodgingEnabled
  }, {
    id: 'campaign-create-pmax',
    name: _TL_('New campaign'),
    route: 'createcampaign/performancemax',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }, {
    id: 'campaign-create-ms-store-ads',
    name: _TL_('New campaign'),
    route: 'createcampaign/msstoreads',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.dynamic.MSStoreAdsGA && permissions.dynamic.WindowsStoreAds && (!permissions.IsDomesticSimplifiedChineseEnabled || permissions.dynamic.WindowsStoreAdsCNExpansion)
  }, {
    id: 'campaign-create-shopping-spa',
    name: _TL_('New campaign'),
    route: 'createcampaign/mran',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsSPAv2Enabled && permissions.IsSPAAndSPBSimplificationEnabled
  }, {
    id: 'campaign-create-shopping-spb',
    name: _TL_('New campaign'),
    route: 'createcampaign/sponsoredpromotion',
    campaignTypes: _shared.alwaysDisplayed,
    checkPermission: permissions => permissions.IsSPAv2Enabled && permissions.dynamic.SponsoredPromotionsByBrands && permissions.IsSPAAndSPBSimplificationEnabled
  }]
};
exports.campaignCreate = campaignCreate;

/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associationCreate = void 0;
const associationCreate = {
  id: 'association-create',
  name: _TL_('Create association'),
  children: [{
    id: 'association-create',
    name: _TL_('Create association'),
    route: 'createassociation'
  }]
};
exports.associationCreate = associationCreate;

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audienceEdit = exports.audienceCreate = void 0;

var _shared = __webpack_require__(1327);

const scope = [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup];
const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup];
const audienceCreate = {
  id: 'audience-create',
  name: _TL_('Create audience'),
  scope,
  scopeV2,
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'audience-create',
    name: _TL_('Create audience'),
    route: 'audience/create'
  }]
};
exports.audienceCreate = audienceCreate;
const audienceEdit = {
  id: 'audience-edit',
  name: _TL_('Edit audience'),
  scope,
  scopeV2,
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'audience-edit',
    name: _TL_('Edit audience'),
    route: 'audience/edit'
  }]
};
exports.audienceEdit = audienceEdit;

/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountCreate = void 0;

var _shared = __webpack_require__(1327);

const accountCreate = {
  id: 'account-create',
  name: _TL_('New account'),
  scope: [_shared.Scope.Customer],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'account-create',
    name: _TL_('Create a new account'),
    route: 'accounts/create',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }]
};
exports.accountCreate = accountCreate;

/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountLinking = void 0;

var _shared = __webpack_require__(1327);

const accountLinking = {
  id: 'account-linking',
  name: _TL_('Account linking'),
  scope: [_shared.Scope.Customer],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'account-linking',
    name: _TL_('Link to an existing account'),
    route: 'accounts/sendlinkrequest',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'account-linking-resend',
    name: _TL_('Link to an existing account'),
    route: 'accounts/resendlinkrequest',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }]
};
exports.accountLinking = accountLinking;

/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsTransfer = void 0;

var _shared = __webpack_require__(1327);

const accountsTransfer = {
  id: 'accounts-transfer',
  name: _TL_('Accounts Transfer'),
  scope: [_shared.Scope.Customer],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'accounts-transfer',
    name: _TL_('Transfer accounts'),
    route: 'accounts/bulktransferaccounts',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }]
};
exports.accountsTransfer = accountsTransfer;

/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountsUnlinking = void 0;

var _shared = __webpack_require__(1327);

const accountsUnlinking = {
  id: 'accounts-unlinking',
  name: _TL_('Account unlinking'),
  scope: [_shared.Scope.Customer],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'accounts-unlinking',
    name: _TL_('Bulk unlink accounts'),
    route: 'accounts/bulkunlinkaccounts',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }]
};
exports.accountsUnlinking = accountsUnlinking;

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pendingTransferRequest = void 0;

var _shared = __webpack_require__(1327);

const pendingTransferRequest = {
  id: 'pending-transfer-request',
  name: _TL_('View pending transfer request'),
  scope: [_shared.Scope.Customer],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'pending-transfer-request',
    name: _TL_('View pending transfer request'),
    route: 'accounts/pendingtransferrequest',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer]
  }]
};
exports.pendingTransferRequest = pendingTransferRequest;

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTargetsCreate = void 0;

var _shared = __webpack_require__(1327);

const performanceTargetsCreate = {
  id: 'performance-targets-create',
  name: _TL_('Create Performance Targets'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'performance-targets-create',
    name: _TL_('Create Performance Targets'),
    route: 'performancetargets/create'
  }]
};
exports.performanceTargetsCreate = performanceTargetsCreate;

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTargetsOverview = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('PerformanceTarget', 'ptId', _shared.ScopeV2.Account);

const performanceTargetsOverview = {
  id: 'performance-targets-overview',
  name: _TL_('Performance Targets Overview'),
  scope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
  scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.PerformanceTarget],
  children: [{
    id: 'performance-targets-overview',
    name: _TL_('Target details'),
    scope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.PerformanceTarget],
    oldUIScope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    route: 'performancetargets/overview'
  }, {
    id: 'performance-targets-history',
    name: _TL_('Target history'),
    scope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.PerformanceTarget],
    oldUIScope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    route: 'performancetargets/history'
  }, {
    id: 'performance-targets-edit',
    name: _TL_('Settings'),
    scope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.PerformanceTarget],
    oldUIScope: [_shared.Scope.Account, _shared.Scope.PerformanceTarget],
    route: 'performancetargets/edit'
  }]
};
exports.performanceTargetsOverview = performanceTargetsOverview;

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedBudgetsEditPage = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('Budget', 'budgetId', _shared.ScopeV2.Account);

const sharedBudgetsEditPage = {
  id: 'shared-budgets-edit',
  name: _TL_('Edit shared budget'),
  scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.Budget],
  oldUIScope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'shared-budgets-edit',
    name: _TL_('Edit shared budget'),
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.Budget],
    route: 'sharedbudgets/edit',
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.sharedBudgetsEditPage = sharedBudgetsEditPage;

/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portfolioBidStrategyDetails = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('PortfolioBidStrategy', 'portfolioId', _shared.ScopeV2.Account);

const portfolioBidStrategyDetails = {
  id: 'portfolio-bid-strategy-details',
  name: _TL_('Portfolio bid strategy details'),
  scopeV2: [_shared.ScopeV2.PortfolioBidStrategy],
  children: [{
    id: 'portfolio-bid-strategy-performance',
    name: _TL_('Performance'),
    route: 'portfoliobidstrategy/performance',
    checkPermission: permissions => permissions.dynamic.PortfolioBidStrategy,
    scopeV2: [_shared.ScopeV2.PortfolioBidStrategy]
  }, {
    id: 'portfolio-bid-strategy-settings',
    name: _TL_('Settings'),
    route: 'portfoliobidstrategy/settings',
    checkPermission: permissions => permissions.dynamic.PortfolioBidStrategy,
    scopeV2: [_shared.ScopeV2.PortfolioBidStrategy]
  }]
};
exports.portfolioBidStrategyDetails = portfolioBidStrategyDetails;

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversionGoalsEdit = exports.conversionGoalsCreate = void 0;

var _shared = __webpack_require__(1327);

const conversionGoalsCreate = {
  id: 'conversion-goals-create',
  name: _TL_('Conversion goals create'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'conversion-goals-create',
    name: _TL_('Conversion goals create'),
    route: 'conversiongoals/create'
  }]
};
exports.conversionGoalsCreate = conversionGoalsCreate;

_shared.ScopeV2.add('Goal', 'goalId', _shared.ScopeV2.Account);

const conversionGoalsEdit = {
  id: 'conversion-goals-edit',
  name: _TL_('Conversion goals edit'),
  scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.Goal],
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'conversion-goals-edit',
    name: _TL_('Conversion goals edit'),
    route: 'conversiongoals/edit'
  }]
};
exports.conversionGoalsEdit = conversionGoalsEdit;

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversionValueRulesEdit = exports.conversionValueRulesCreate = void 0;

var _shared = __webpack_require__(1327);

const conversionValueRulesCreate = {
  id: 'conversion-value-rules-create',
  name: _TL_('Conversion value rules create'),
  oldUIScope: [_shared.Scope.Customer],
  children: [{
    id: 'conversion-value-rules-create',
    name: _TL_('Conversion value rules create'),
    route: 'conversionvaluerules/create',
    checkPermission: permissions => permissions.dynamic.ConvValueRules
  }]
};
exports.conversionValueRulesCreate = conversionValueRulesCreate;

_shared.ScopeV2.add('CVRL', 'cvrlId', _shared.ScopeV2.Customer);

const conversionValueRulesEdit = {
  id: 'conversion-value-rules-edit',
  name: _TL_('Conversion value rules edit'),
  scopeV2: [_shared.Scope.Customer, _shared.Scope.CVRL],
  oldUIScope: [_shared.Scope.Customer],
  children: [{
    id: 'conversion-value-rules-edit',
    name: _TL_('Conversion value rules edit'),
    route: 'conversionvaluerules/edit',
    checkPermission: permissions => permissions.dynamic.ConvValueRules
  }]
};
exports.conversionValueRulesEdit = conversionValueRulesEdit;

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uetTagsEdit = exports.uetTagsCreate = void 0;

var _shared = __webpack_require__(1327);

const scope = [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup];
const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.Campaign, _shared.ScopeV2.AdGroup];
const uetTagsCreate = {
  id: 'uet-tags-create',
  name: _TL_('Uet tags create'),
  scope,
  scopeV2,
  children: [{
    id: 'uet-tags-create',
    name: _TL_('Uet tags create'),
    route: 'uettags/create'
  }]
};
exports.uetTagsCreate = uetTagsCreate;

_shared.ScopeV2.add('UetTag', 'uetTagId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('UetTag', 'uetTagId', _shared.ScopeV2.Customer);

const uetTagsEdit = {
  id: 'uet-tags-edit',
  name: _TL_('Uet tags edit'),
  scope,
  scopeV2: scopeV2.concat(_shared.ScopeV2.UetTag),
  children: [{
    id: 'uet-tags-edit',
    name: _TL_('Uet tags edit'),
    route: 'uettags/edit'
  }]
};
exports.uetTagsEdit = uetTagsEdit;

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adCustomizerFeedsItems = void 0;

var _shared = __webpack_require__(1327);

const adCustomizerFeedsItems = {
  id: 'ad-customizer-feeds-items',
  name: _TL_('Ad customizer feed items'),
  scopeV2: [_shared.ScopeV2.Feed],
  children: [{
    id: 'ad-customizer-feeds-items',
    name: _TL_('Ad customizer feed items'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/adcustomizeritems'
  }, {
    id: 'schedules',
    name: _TL_('Schedules'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/adcustomizeritems/schedules'
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/adcustomizeritems/uploadhistory'
  }]
};
exports.adCustomizerFeedsItems = adCustomizerFeedsItems;

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicDataFeedsItems = void 0;

var _shared = __webpack_require__(1327);

const dynamicDataFeedsItems = {
  id: 'dynamic-data-feeds-items',
  name: _TL_('Dynamic data feed items'),
  scopeV2: [_shared.ScopeV2.Feed],
  children: [{
    id: 'dynamic-data-feeds-items',
    name: _TL_('Dynamic data feed items'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/dynamicdataitems',
    checkPermission: permissions => permissions.dynamic.DynamicData || permissions.IsEnabledForDynamicFeedCampaign
  }, {
    id: 'schedules',
    name: _TL_('Schedules'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/dynamicdataitems/schedules',
    checkPermission: permissions => permissions.dynamic.DynamicData || permissions.IsEnabledForDynamicFeedCampaign
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/dynamicdataitems/uploadhistory',
    checkPermission: permissions => permissions.dynamic.DynamicData || permissions.IsEnabledForDynamicFeedCampaign
  }]
};
exports.dynamicDataFeedsItems = dynamicDataFeedsItems;

/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageFeedsItems = void 0;

var _shared = __webpack_require__(1327);

const pageFeedsItems = {
  id: 'page-feed-item',
  name: _TL_('Page feed items'),
  scopeV2: [_shared.ScopeV2.Feed],
  children: [{
    id: 'page-feeds-items',
    name: _TL_('Page feed items'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/pageitems',
    checkPermission: permissions => permissions.dynamic.DynamicSearchAdsV1
  }, {
    id: 'schedules',
    name: _TL_('Schedules'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/pageitems/schedules',
    checkPermission: permissions => permissions.dynamic.DynamicSearchAdsV1
  }, {
    id: 'upload-history',
    name: _TL_('Upload history'),
    scopeV2: [_shared.ScopeV2.Feed],
    route: 'feeds/pageitems/uploadhistory',
    checkPermission: permissions => permissions.dynamic.DynamicSearchAdsV1
  }]
};
exports.pageFeedsItems = pageFeedsItems;

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleDetail = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('RuleDetail', 'executionId', _shared.ScopeV2.Account);

const ruleDetail = {
  id: 'rule-detail',
  name: _TL_('Details'),
  scope: [_shared.Scope.Account],
  scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.RuleDetail],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'rule-detail',
    name: _TL_('Details'),
    route: 'automatedruledetail',
    scope: [_shared.Scope.Account],
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.RuleDetail],
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.ruleDetail = ruleDetail;

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkEditDetail = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('BulkEditDetail', 'bulkEditSessionId', _shared.ScopeV2.Account);

const bulkEditDetail = {
  id: 'bulk-edits-detail',
  name: _TL_('Create association'),
  scope: [_shared.Scope.Account],
  scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.BulkEditDetail],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'bulk-edits-detail-page',
    name: _TL_('Detail'),
    route: 'bulkeditdetail',
    scope: [_shared.Scope.Account],
    scopeV2: [_shared.ScopeV2.Account, _shared.ScopeV2.BulkEditDetail],
    campaignTypes: _shared.alwaysDisplayed
  }]
};
exports.bulkEditDetail = bulkEditDetail;

/***/ }),

/***/ 1477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scriptsDetail = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('MccScript', 'scriptId', _shared.ScopeV2.Customer);

_shared.ScopeV2.add('Script', 'scriptId', _shared.ScopeV2.Account);

_shared.ScopeV2.add('MccScriptLog', 'logId', _shared.ScopeV2.Customer);

_shared.ScopeV2.add('ScriptLog', 'logId', _shared.ScopeV2.Account);

const scriptsDetail = {
  id: 'scripts-detail',
  name: '',
  campaignTypes: _shared.alwaysDisplayed,
  scope: [_shared.Scope.Customer, _shared.Scope.Account],
  children: [{
    id: 'scripts-create',
    name: _TL_('Create script'),
    route: 'scriptscreate',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer, _shared.Scope.Account]
  }, {
    id: 'scripts-edit',
    name: _TL_('Edit script'),
    route: 'scriptsedit',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer, _shared.Scope.Account],
    scopeV2: [_shared.Scope.Customer, _shared.ScopeV2.MccScript, _shared.ScopeV2.Account, _shared.ScopeV2.Script]
  }, {
    id: 'scripts-logs',
    name: _TL_('Logs Details'),
    route: 'scriptslogs',
    campaignTypes: _shared.alwaysDisplayed,
    scope: [_shared.Scope.Customer, _shared.Scope.Account],
    scopeV2: [_shared.Scope.Customer, _shared.ScopeV2.MccScriptLog, _shared.ScopeV2.Account, _shared.ScopeV2.ScriptLog]
  }]
};
exports.scriptsDetail = scriptsDetail;

/***/ }),

/***/ 1478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.negativeKeywordsListsDetail = void 0;
const negativeKeywordsListsDetail = {
  id: 'negative-keywords-lists-detail',
  name: _TL_('Negative Keywords Lists Detail'),
  children: [{
    id: 'negative-keywords-lists-negative-keywords',
    name: _TL_('Negative Keywords'),
    route: 'negativekeywordslistsdetails/negativekeywords'
  }, {
    id: 'negative-keywords-lists-details-campaigns',
    name: _TL_('Campaigns in this list'),
    route: 'negativekeywordslistsdetails/campaignassociation'
  }]
};
exports.negativeKeywordsListsDetail = negativeKeywordsListsDetail;

/***/ }),

/***/ 1479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchanteCenterStoreCreate = void 0;

var _shared = __webpack_require__(1327);

const merchanteCenterStoreCreate = {
  id: 'mmc-create-store',
  name: _TL_('Create store'),
  scope: [_shared.Scope.Account],
  campaignTypes: _shared.alwaysDisplayed,
  children: [{
    id: 'mmc-create-store',
    name: _TL_('Create store'),
    route: 'merchantcenter/create-store',
    scope: [_shared.Scope.Account]
  }]
};
exports.merchanteCenterStoreCreate = merchanteCenterStoreCreate;

/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendationHistory = void 0;

var _shared = __webpack_require__(1327);

const recommendationHistory = {
  id: 'recommendation-history',
  name: _TL_('Bulk Apply History'),
  scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  children: [{
    id: 'baa-recommendation-history',
    name: _TL_('My applied recommendations history'),
    route: 'recommendations/history',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup]
  }, {
    id: 'mcc-recommendation-history',
    name: _TL_('My applied recommendations history'),
    route: 'accounts/recommendations/history',
    scope: [_shared.Scope.Customer]
  }]
};
exports.recommendationHistory = recommendationHistory;

/***/ }),

/***/ 1481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendationRSAAsset = void 0;

var _shared = __webpack_require__(1327);

const recommendationRSAAsset = {
  id: 'recommendation-rsa-asset',
  name: _TL_('RSA Asset'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'RSAAsset',
    name: _TL_('RSA Asset'),
    route: 'recommendations/RSAAsset',
    checkPermission: permissions => permissions.IsRecommendationRSAAssetEnabled
  }]
};
exports.recommendationRSAAsset = recommendationRSAAsset;

/***/ }),

/***/ 1482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkUploadsBuildSpreadsheet = void 0;

var _shared = __webpack_require__(1327);

const bulkUploadsBuildSpreadsheet = {
  id: 'bulk-uploads-build-spreadsheet',
  name: '',
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'build-spreadsheet',
    name: _TL_('Build spreadsheet'),
    route: 'bulkuploads/buildspreadsheet',
    checkPermission: permissions => permissions.IsCampaignBAMEnabled,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'build-spreadsheet-account-numbers',
    name: '',
    // Not to display this item
    route: 'bulkuploads/buildspreadsheet/:account_numbers',
    checkPermission: permissions => permissions.IsCampaignBAMEnabled,
    scope: [_shared.Scope.Customer]
  }]
};
exports.bulkUploadsBuildSpreadsheet = bulkUploadsBuildSpreadsheet;

/***/ }),

/***/ 1483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optOutForMinors = void 0;

var _shared = __webpack_require__(1327);

const optOutForMinors = {
  id: 'optout-for-minors',
  name: _TL_('Opt out for minors'),
  scope: [_shared.Scope.Account],
  children: [{
    id: 'optout-for-minors',
    name: _TL_('Opt out for minors'),
    route: 'optoutforminors',
    scope: [_shared.Scope.Account],
    searchable: false
  }]
};
exports.optOutForMinors = optOutForMinors;

/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendationAutoApplySettings = void 0;

var _shared = __webpack_require__(1327);

const recommendationAutoApplySettings = {
  id: 'recommendation-auto-apply-settings',
  name: _TL_('Auto Apply Settings'),
  scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  children: [{
    id: 'recommendation-auto-apply-settings',
    name: _TL_('Auto Apply Settings'),
    route: 'recommendations/AutoApplySettings',
    scope: [_shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup]
  }]
};
exports.recommendationAutoApplySettings = recommendationAutoApplySettings;

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendationAutoApplyBulkUpload = void 0;

var _shared = __webpack_require__(1327);

const recommendationAutoApplyBulkUpload = {
  id: 'recommendation-auto-apply-bulk-upload',
  name: _TL_('AAR Bulk Update Tool'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'recommendation-auto-apply-bulk-upload',
    name: _TL_('AAR Bulk Update Tool'),
    route: 'accounts/recommendations/AutoApplyBulkUpload',
    scope: [_shared.Scope.Customer]
  }]
};
exports.recommendationAutoApplyBulkUpload = recommendationAutoApplyBulkUpload;

/***/ }),

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importCredentialIdPages = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('ShareWithUserIds', 'shareWithUserIds', _shared.ScopeV2.Account);

const scopeV2 = [_shared.ScopeV2.Customer, _shared.ScopeV2.Account, _shared.ScopeV2.ShareWithUserIds];
const importCredentialIdPages = {
  id: 'import-credential-id',
  name: _TL_('Import credential ID'),
  checkPermission: permissions => permissions.dynamic.GoogleImportAsService,
  route: 'importcredentialid',
  campaignTypes: _shared.alwaysDisplayed,
  scope: _shared.defaultScopes,
  searchable: true,
  scopeV2
};
exports.importCredentialIdPages = importCredentialIdPages;

/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryInsights = void 0;

var _shared = __webpack_require__(1327);

const queryInsights = {
  id: 'query-insights-details',
  name: _TL_('Search insights details'),
  children: [{
    id: 'account-optimization-details',
    name: _TL_('Account optimization details'),
    route: 'accountoptimization/details',
    searchable: false,
    checkPermission: permissions => permissions.IsQueryInsightsEnabled,
    scope: [_shared.Scope.Account]
  }, {
    id: 'new-opportunities-details',
    name: _TL_('New opportunities details'),
    route: 'newopportunities/details',
    searchable: false,
    checkPermission: permissions => permissions.IsQueryInsightsEnabled,
    scope: [_shared.Scope.Account]
  }]
};
exports.queryInsights = queryInsights;

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendationImageAsset = void 0;

var _shared = __webpack_require__(1327);

const recommendationImageAsset = {
  id: 'recommendation-image-asset',
  name: _TL_('Image Asset'),
  scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
  children: [{
    id: 'recommendation-image-asset',
    name: _TL_('Image Asset'),
    route: 'recommendations/ImageAsset',
    scope: [_shared.Scope.Customer, _shared.Scope.Account, _shared.Scope.Campaign, _shared.Scope.AdGroup],
    available: permissions => permissions.IsRecommendationImageAssetEnabled
  }]
};
exports.recommendationImageAsset = recommendationImageAsset;

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetGroupEdit = exports.assetGroupCreate = exports.pmaxDetails = void 0;

var _shared = __webpack_require__(1327);

_shared.ScopeV2.add('AssetGroup', 'assetGroupId', _shared.ScopeV2.Campaign);

const pmaxDetails = {
  id: 'pmax-asset-details',
  name: _TL_('Asset details'),
  scope: [_shared.Scope.Campaign],
  scopeV2: [_shared.ScopeV2.AssetGroup],
  campaignTypes: [_shared.CampaignType.PerformanceMax],
  children: [{
    id: 'pmax-assets',
    name: _TL_('Assets'),
    scope: [_shared.Scope.Campaign],
    scopeV2: [_shared.ScopeV2.AssetGroup],
    campaignTypes: [_shared.CampaignType.PerformanceMax],
    route: 'assetgroups/assets',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }, {
    id: 'pmax-combinations',
    name: _TL_('Combinations'),
    scope: [_shared.Scope.Campaign],
    scopeV2: [_shared.ScopeV2.AssetGroup],
    campaignTypes: [_shared.CampaignType.PerformanceMax],
    route: 'assetgroups/combinations',
    searchable: false,
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }]
};
exports.pmaxDetails = pmaxDetails;
const assetGroupCreate = {
  id: 'asset-group-create',
  name: _TL_('Create asset group'),
  scope: [_shared.Scope.Campaign],
  scopeV2: [_shared.ScopeV2.Campaign],
  campaignTypes: [_shared.CampaignType.PerformanceMax],
  children: [{
    id: 'asset-group-create',
    name: _TL_('Create asset group'),
    route: 'assetgroups/create',
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }]
};
exports.assetGroupCreate = assetGroupCreate;
const assetGroupEdit = {
  id: 'asset-group-edit',
  name: _TL_('Edit asset group'),
  scope: [_shared.Scope.Campaign],
  scopeV2: [_shared.ScopeV2.AssetGroup],
  campaignTypes: [_shared.CampaignType.PerformanceMax],
  children: [{
    id: 'asset-group-edit',
    name: _TL_('Edit asset group'),
    route: 'assetgroups/edit',
    checkPermission: permissions => permissions.dynamic.PerformanceMaxCampaigns
  }]
};
exports.assetGroupEdit = assetGroupEdit;

/***/ }),

/***/ 1490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.budgetCenterCampaignBudgetTool = void 0;

var _shared = __webpack_require__(1327);

const budgetCenterCampaignBudgetTool = {
  id: 'budget-center-campaign-budget-tool',
  name: _TL_('Campaign budget tool'),
  scope: [_shared.Scope.Customer],
  children: [{
    id: 'budget-center-campaign-budget-tool',
    name: _TL_('Campaign budget tool'),
    route: 'campaignbudgettool',
    scope: [_shared.Scope.Customer],
    checkPermission: permissions => permissions.dynamic.BudgetCenter && !(0, _shared.isSmartPageStandalone)(permissions) && !permissions.IsUnifiedSmartMode && !permissions.IsSmartMode
  }]
};
exports.budgetCenterCampaignBudgetTool = budgetCenterCampaignBudgetTool;

/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientCenterStandalonePages = exports.clientCenterPages = void 0;

var _billingPayments = __webpack_require__(1492);

var _settings = __webpack_require__(1493);

var _accountAccess = __webpack_require__(1494);

var _billingPaymentsStandalone = __webpack_require__(1495);

var _settingsStandalone = __webpack_require__(1496);

var _accountMapStandalone = __webpack_require__(1497);

var _accountIdentityVerificationStandalone = __webpack_require__(1498);

var _mandateAgreementRequiredStandalone = __webpack_require__(1499);

var _ukFcaVerificationStandalone = __webpack_require__(1500);

var _channelPartnerStandalone = __webpack_require__(1501);

var _billingGroupCreationStandalone = __webpack_require__(1502);

var _fraudAppealStandalone = __webpack_require__(1503);

const clientCenterPages = [_billingPayments.billingPayments, _settings.settings, _accountAccess.accountAccess];
exports.clientCenterPages = clientCenterPages;
const clientCenterStandalonePages = [_billingPaymentsStandalone.account, _billingPaymentsStandalone.billing, _billingPaymentsStandalone.insertionOrder, _billingPaymentsStandalone.payment, _billingPaymentsStandalone.rebill, _settingsStandalone.accountSettings, _settingsStandalone.managerAccountSettings, _settingsStandalone.advancedSettings, _accountMapStandalone.accountMap, _accountIdentityVerificationStandalone.accountIdentityVerification, _mandateAgreementRequiredStandalone.mandateAgreementRequired, _ukFcaVerificationStandalone.UKFCAVerification, _channelPartnerStandalone.channelPartner, _billingGroupCreationStandalone.billingGroupCreation, _fraudAppealStandalone.fraudAppeal];
exports.clientCenterStandalonePages = clientCenterStandalonePages;

/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingPayments = exports.couponDetails = exports.billingSettings = exports.insertionOrders = exports.balance = exports.adjustments = exports.paymentMethods = exports.transactions = exports.billingSummary = void 0;

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const billingSummary = {
  id: 'billing',
  name: _TL_('Billing summary'),
  route: 'billing'
};
exports.billingSummary = billingSummary;
const transactions = {
  id: 'transactions',
  name: _TL_('Transactions'),
  route: 'Transactions/BillingDocuments',
  children: [{
    id: 'transactionBillingDocuments',
    name: _TL_('Billing documents'),
    route: 'Transactions/BillingDocuments'
  }, {
    id: 'transactionHistory',
    name: _TL_('Transaction history'),
    route: 'Transactions/TransactionHistory',
    scope: [_shared.Scope.Account]
  }]
};
exports.transactions = transactions;
const paymentMethods = {
  id: 'paymentMethods',
  name: _TL_('Payment methods'),
  route: 'PaymentMethods'
};
exports.paymentMethods = paymentMethods;
const adjustments = {
  id: 'adjustments',
  name: _TL_('Adjustments'),
  route: 'Adjustments',
  scope: [_shared.Scope.Account],
  checkPermission: permissions => !!permissions.IsInternalUser
};
exports.adjustments = adjustments;
const balance = {
  id: 'balance',
  name: _TL_('Balance'),
  route: 'Balance',
  scope: [_shared.Scope.Account],
  checkPermission: permissions => !!permissions.IsInternalUser
};
exports.balance = balance;
const insertionOrders = {
  id: 'insertionOrder',
  name: _TL_('Insertion orders'),
  route: 'InsertionOrder'
};
exports.insertionOrders = insertionOrders;
const billingSettings = {
  id: 'billingSettings',
  name: _TL_('Billing settings'),
  route: 'BillingSettings',
  children: [{
    id: 'billingSettings',
    name: _TL_('Billing settings'),
    route: 'BillingSettings'
  }, {
    id: 'consolidatedBilling',
    name: _TL_('Consolidated billing'),
    route: 'BillingSettings/ConsolidatedBilling',
    checkPermission: permissions => permissions.dynamic.ConsolidatedBillingV2
  }, {
    id: 'sapIdInformation',
    name: _TL_('SAP ID information'),
    route: 'BillingSettings/SapIdInformation',
    checkPermission: permissions => permissions.dynamic.ConsolidatedBillingV2
  }]
};
exports.billingSettings = billingSettings;

const couponDetails = _objectSpread({}, _shared.defaultCCItemProperties, {
  id: 'coupon',
  name: _TL_('Coupon'),
  route: 'Billing/CouponDetails',
  scope: [_shared.Scope.Account]
});

exports.couponDetails = couponDetails;
const billingPayments = {
  id: 'billingHistory',
  name: _TL_('Billing & Payments'),
  route: 'Billing/History',
  fixedRoute: 'Billing/History',
  children: [billingSummary, paymentMethods, insertionOrders, billingSettings, adjustments, balance, transactions]
};
exports.billingPayments = billingPayments;

/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = exports.viewDefaults = exports.verificationHub = exports.advancedSettings = exports.mySettings = exports.managerAccountSettings = exports.emailSettings = exports.accountSettings = void 0;

var _shared = __webpack_require__(1327);

const accountSettings = {
  id: 'accountSettings',
  name: _TL_('Account settings'),
  route: 'Settings/Account',
  scope: [_shared.Scope.Account]
};
exports.accountSettings = accountSettings;
const emailSettings = {
  id: 'emailSettings',
  name: _TL_('Email preferences'),
  route: 'Settings/EmailPreferences'
};
exports.emailSettings = emailSettings;
const managerAccountSettings = {
  id: 'managerAccountSettings',
  name: _TL_('Manager account settings'),
  route: 'Settings/ManagerAccount'
};
exports.managerAccountSettings = managerAccountSettings;
const mySettings = {
  id: 'mySettings',
  name: _TL_('My settings'),
  route: 'Settings/MySettings'
};
exports.mySettings = mySettings;
const advancedSettings = {
  id: 'advancedSettings',
  name: _TL_('Advanced settings'),
  route: 'Settings/AdvancedSettings',
  searchable: false,
  onlyShowToYahoo: true
};
exports.advancedSettings = advancedSettings;
const verificationHub = {
  id: 'verificationHub',
  name: _TL_('Account verifications'),
  route: 'Settings/VerificationHub',
  checkPermission: permissions => permissions.dynamic.VerificationHub
};
exports.verificationHub = verificationHub;
const viewDefaults = {
  id: 'viewDefaults',
  name: _TL_('View defaults'),
  route: 'Settings/ViewDefaults',
  checkPermission: permissions => permissions.dynamic.NavigationRefresh
};
exports.viewDefaults = viewDefaults;
const settings = {
  id: 'defaultSettings',
  name: _TL_('Preferences'),
  route: 'Settings',
  fixedRoute: 'Settings',
  children: [accountSettings, emailSettings, managerAccountSettings, mySettings, advancedSettings, verificationHub, viewDefaults]
};
exports.settings = settings;

/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountAccess = exports.directManager = exports.userManagement = void 0;
const userManagement = {
  id: 'users',
  name: _TL_('User Management'),
  route: 'Users'
};
exports.userManagement = userManagement;
const directManager = {
  id: 'managers',
  name: _TL_('Direct managers'),
  route: 'Managers'
};
exports.directManager = directManager;
const accountAccess = {
  id: 'accountAccess',
  name: _TL_('Account access'),
  route: 'Users',
  fixedRoute: 'Users',
  children: [directManager, userManagement]
};
exports.accountAccess = accountAccess;

/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rebill = exports.payment = exports.insertionOrder = exports.billing = exports.account = void 0;

var _shared = __webpack_require__(1327);

const account = {
  id: 'accountStandalone',
  name: _TL_('Account'),
  children: [{
    id: 'linkAccounts',
    name: _TL_('Link Accounts'),
    route: 'Agency/SendInvite',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'pendingBillingChange',
    name: _TL_('Pending Billing Change'),
    route: 'Account/PendingBillingChange'
  }, {
    id: 'switchPaymentSetting',
    name: _TL_('Change How You Pay'),
    route: 'Account/SwitchPaymentSetting'
  }, {
    id: 'takeOverBilling',
    name: _TL_('Change Who Pays'),
    route: 'Account/TakeOverBilling'
  }]
};
exports.account = account;
const billing = {
  id: 'billingStandalone',
  name: _TL_('Billing'),
  children: [{
    id: 'coupon',
    name: _TL_('Coupon'),
    route: 'Billing/CouponDetails'
  }, {
    id: 'payNow',
    name: _TL_('Pay Now'),
    route: 'Billing/PayNow'
  }, {
    id: 'cashbackApproval',
    name: _TL_('Cashback Approval'),
    route: 'Billing/CashbackApproval',
    scope: [_shared.Scope.Account]
  }]
};
exports.billing = billing;
const insertionOrder = {
  id: 'insertionOrderStandalone',
  name: _TL_('Insertion orders'),
  children: [{
    id: 'ioImport',
    name: _TL_('Bulk import insertions orders'),
    route: 'InsertionOrder/BulkImport',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'ioImportHistory',
    name: _TL_('Import history insertions orders'),
    route: 'InsertionOrder/IOImportHistoryList',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'ioPreApprove',
    name: _TL_('Pre-approve insertions orders'),
    route: 'InsertionOrder/PreApprove',
    scope: [_shared.Scope.Customer]
  }, {
    id: 'ioViewHistory',
    name: _TL_('View history insertions orders'),
    route: 'InsertionOrder/ViewChangeHistory'
  }]
};
exports.insertionOrder = insertionOrder;
const payment = {
  id: 'paymentStandalone',
  name: _TL_('Payment'),
  children: [{
    id: 'addFunds',
    name: _TL_('Add funds'),
    route: 'Payment/Prepay'
  }, {
    id: 'autoRecharge',
    name: _TL_('Auto recharge'),
    route: 'Payment/AutoPayment'
  }, {
    id: 'paymentSlipRegisteredBoleto',
    name: _TL_('Payment Slip Registered Boleto'),
    route: 'Boleto/PaymentSlipRegisteredBoleto'
  }, {
    id: 'sapOnboarding',
    name: _TL_('SAP Onboarding'),
    route: 'SAPOnboarding',
    scope: [_shared.Scope.Customer]
  }]
};
exports.payment = payment;
const rebill = {
  id: 'rebillStandalone',
  name: _TL_('Rebill'),
  scope: [_shared.Scope.Account],
  children: [{
    id: 'rebill',
    name: _TL_('Rebill'),
    route: 'Rebill',
    checkPermission: permissions => !!permissions.IsInternalUser,
    scope: [_shared.Scope.Account]
  }, {
    id: 'rebillDetails',
    name: _TL_('Rebill details'),
    route: 'Rebill/Details',
    checkPermission: permissions => !!permissions.IsInternalUser,
    scope: [_shared.Scope.Account]
  }]
};
exports.rebill = rebill;

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advancedSettings = exports.managerAccountSettings = exports.accountSettings = void 0;

var _shared = __webpack_require__(1327);

const accountSettings = {
  id: 'accountSettingsStandalone',
  name: _TL_('Preferences'),
  children: [{
    id: 'accountSettingsEdit',
    name: _TL_('Account settings edit'),
    route: 'Settings/Account/Edit',
    scope: [_shared.Scope.Account]
  }]
};
exports.accountSettings = accountSettings;
const managerAccountSettings = {
  id: 'managerAccountSettingsStandalone',
  name: _TL_('Preferences'),
  children: [{
    id: 'managerAccountSettingsEdit',
    name: _TL_('Manager account settings edit'),
    route: 'Settings/ManagerAccount/Edit'
  }]
};
exports.managerAccountSettings = managerAccountSettings;
const advancedSettings = {
  id: 'advancedSettingsStandalone',
  name: _TL_('Preferences'),
  onlyShowToYahoo: true,
  children: [{
    id: 'advancedSettingsEdit',
    name: _TL_('Advanced settings edit'),
    route: 'Settings/AdvancedSettings/Edit'
  }, {
    id: 'accountAdvancedSettings',
    name: _TL_('Advanced settings'),
    route: 'Account/AdvancedSettings'
  }]
};
exports.advancedSettings = advancedSettings;

/***/ }),

/***/ 1497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountMap = void 0;
const accountMap = {
  id: 'accountMap',
  name: _TL_('Account map'),
  route: 'AccountMap'
};
exports.accountMap = accountMap;

/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountIdentityVerification = void 0;

var _shared = __webpack_require__(1327);

const accountIdentityVerification = {
  id: 'accountIdentityVerification',
  name: _TL_('Advertiser identity verification'),
  route: 'account/IdentityVerification',
  checkPermission: permissions => permissions.dynamic.AccountIdentityVerification,
  scope: [_shared.Scope.Account]
};
exports.accountIdentityVerification = accountIdentityVerification;

/***/ }),

/***/ 1499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mandateAgreementRequired = void 0;

var _shared = __webpack_require__(1327);

const mandateAgreementRequired = {
  id: 'mandateAgreementRequired',
  name: _TL_('Mandate Agreement Required'),
  route: 'MandateAgreementRequired',
  checkPermission: permissions => permissions.dynamic.MandateAgreementRequired,
  scope: [_shared.Scope.Customer]
};
exports.mandateAgreementRequired = mandateAgreementRequired;

/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UKFCAVerification = void 0;

var _shared = __webpack_require__(1327);

const UKFCAVerification = {
  id: 'UKFCAVerification',
  name: _TL_('UK FCA verification'),
  children: [{
    id: 'UKFCAWorkflow',
    name: _TL_('UK FCA verification workflow'),
    route: 'UKFCA/Workflow',
    scope: [_shared.Scope.Account],
    checkPermission: permissions => permissions.dynamic.VerificationHub
  }, {
    id: 'UKFCAUpdateDomains',
    name: _TL_('UK FCA verification update domains'),
    route: 'UKFCA/UpdateDomains',
    scope: [_shared.Scope.Account],
    checkPermission: permissions => permissions.dynamic.VerificationHub
  }]
};
exports.UKFCAVerification = UKFCAVerification;

/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelPartner = void 0;

var _shared = __webpack_require__(1327);

const channelPartner = {
  id: 'channelPartnerStandalone',
  name: _TL_('Channel Partner'),
  children: [{
    id: 'channelPartnerAddPayment',
    name: _TL_('Channel partner add payment'),
    route: 'channelPartner/AddPayment',
    scope: [_shared.Scope.Account],
    checkPermission: permissions => permissions.dynamic.ChannelPartnerAddPI
  }]
};
exports.channelPartner = channelPartner;

/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingGroupCreation = void 0;

var _shared = __webpack_require__(1327);

const billingGroupCreation = {
  id: 'billingGroupCreationStandalone',
  name: _TL_('Billing group creation'),
  children: [{
    id: 'billingGroupCreation',
    name: _TL_('Billing group creation'),
    route: 'billingGroupCreation',
    scope: [_shared.Scope.Customer],
    checkPermission: permissions => permissions.dynamic.ConsolidatedBillingV2
  }]
};
exports.billingGroupCreation = billingGroupCreation;

/***/ }),

/***/ 1503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fraudAppeal = void 0;

var _shared = __webpack_require__(1327);

const fraudAppeal = {
  id: 'fraudAppealStandalone',
  name: _TL_('Fraud appeal'),
  children: [{
    id: 'fraudAppeal',
    name: _TL_('Fraud appeal'),
    route: 'FraudAppeal',
    checkPermission: permissions => permissions.dynamic.AIVRedBucket,
    scope: [_shared.Scope.Customer]
  }, {
    id: 'fraudAppealAIV',
    name: _TL_('Fraud appeal - Account verification'),
    route: 'FraudAppeal/AccountIdentityVerification',
    scope: [_shared.Scope.Account],
    checkPermission: permission => permission.dynamic.AIVRedBucket
  }]
};
exports.fraudAppeal = fraudAppeal;

/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unifiedSmartPages = void 0;

var _adsRoot = __webpack_require__(1505);

var _homeRoot = __webpack_require__(1506);

var _socialRoot = __webpack_require__(1507);

var _myWebsite = __webpack_require__(1508);

const unifiedSmartPages = [_adsRoot.adsRoot, _homeRoot.homeRoot, _socialRoot.socialRoot, _myWebsite.myWebsite];
exports.unifiedSmartPages = unifiedSmartPages;

/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adsRoot = void 0;

var _shared = __webpack_require__(1327);

const adsRoot = {
  id: 'ads-root',
  route: 'ads',
  default: true,
  scope: [_shared.Scope.Account],
  metadata: {
    title: _TL_('Ads')
  }
};
exports.adsRoot = adsRoot;

/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homeRoot = void 0;

var _shared = __webpack_require__(1327);

const homeRoot = {
  id: 'home-root',
  route: 'home',
  default: true,
  scope: [_shared.Scope.Account],
  metadata: {
    title: _TL_('Home')
  }
};
exports.homeRoot = homeRoot;

/***/ }),

/***/ 1507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialRoot = void 0;

var _shared = __webpack_require__(1327);

const socialRoot = {
  id: 'social-root',
  route: 'social/inbox',
  default: true,
  scope: [_shared.Scope.Account],
  metadata: {
    title: _TL_('Social')
  }
};
exports.socialRoot = socialRoot;

/***/ }),

/***/ 1508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.myWebsite = void 0;

var _shared = __webpack_require__(1327);

const myWebsite = {
  id: 'my-website',
  route: 'smartpage',
  default: true,
  isUnifiedProductPage: true,
  scope: [_shared.Scope.Account],
  name: _TL_('Smart Pages'),
  checkPermission: permissions => permissions.dynamic.SmartPageUPIntegration,
  metadata: {
    title: _TL_('Smart Pages')
  }
};
exports.myWebsite = myWebsite;

/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bidStrategiesPages = void 0;

var _advancedControls = __webpack_require__(1510);

var _portfolioBidStrategy = __webpack_require__(1511);

const bidStrategiesPages = [_advancedControls.advancedControlsPage, _portfolioBidStrategy.portfolioBidStrategyPage];
exports.bidStrategiesPages = bidStrategiesPages;

/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advancedControlsPage = void 0;

var _shared = __webpack_require__(1327);

const advancedControlsPage = {
  id: 'advanced-controls',
  name: _TL_('Advanced controls'),
  oldUIScope: [_shared.Scope.Account],
  children: [{
    id: 'seasonality-adjustment',
    name: _TL_('Seasonality adjustments'),
    route: 'bidstrategies/seasonalityadjustment',
    checkPermission: permissions => permissions.dynamic.SeasonalityAdjustment && (permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions)
  }, {
    id: 'data-exclusions',
    name: _TL_('Data exclusions'),
    route: 'bidstrategies/dataexclusions',
    checkPermission: permissions => permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions
  }]
};
exports.advancedControlsPage = advancedControlsPage;

/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portfolioBidStrategyPage = exports.bidStrategiesPortfolio = void 0;

var _shared = __webpack_require__(1327);

const bidStrategiesPortfolio = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'),
  route: 'bidstrategies/portfoliobidstrategy',
  checkPermission: permissions => permissions.dynamic.PortfolioBidStrategy && (permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions)
};
exports.bidStrategiesPortfolio = bidStrategiesPortfolio;
const portfolioBidStrategyPage = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'),
  oldUIScope: [_shared.Scope.Account],
  children: [bidStrategiesPortfolio]
};
exports.portfolioBidStrategyPage = portfolioBidStrategyPage;

/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processPermissions = processPermissions;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _hocWithPermissions = __webpack_require__(533);

var _primitiveUtilities = __webpack_require__(42);

var _siteMapPropType = __webpack_require__(1513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const getScope = (item, permissions) => _underscore.default.isFunction(item.scope) ? item.scope(permissions) : item.scope; // todo: [rayduan] merge scope with V2 when we finish migration


const getScopeV2 = (item, permissions) => _underscore.default.isFunction(item.scopeV2) ? item.scopeV2(permissions) : item.scopeV2;

const getTag = (item, permissions) => _underscore.default.isFunction(item.showTag) ? item.showTag(permissions) : item.showTag;

function filterByPermissions(siteMap, permissions) {
  return _underscore.default.reduce(siteMap, (result, item) => {
    if (item.checkPermission(permissions)) {
      if (!_underscore.default.isEmpty(item.children)) {
        const children = filterByPermissions(item.children, permissions);

        if (!_underscore.default.isEmpty(children)) {
          const route = item.route || _underscore.default.result(_underscore.default.first(children), 'route');

          const available = _underscore.default.some(children, child => child.available);

          const showTag = getTag(item, permissions);
          const scope = getScope(item, permissions);
          const scopeV2 = getScopeV2(item, permissions);
          result.push(_underscore.default.defaults({
            children,
            available,
            route,
            showTag,
            scope,
            scopeV2
          }, item));
        }
      } else {
        const available = _underscore.default.isFunction(item.available) ? item.available(permissions) === true : item.available;
        const showTag = getTag(item, permissions);
        const scope = getScope(item, permissions);
        const scopeV2 = getScopeV2(item, permissions);
        result.push(_underscore.default.defaults({
          available,
          showTag,
          scope,
          scopeV2
        }, item));
      }
    }

    return result;
  }, []);
}

const filterByPermissionsCached = (0, _primitiveUtilities.memoize)(filterByPermissions);

function processPermissions(Component, useCache = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const permissions = _underscore.default.defaults(props.permissions, {
      dynamic: {}
    });

    const processorFunc = useCache ? filterByPermissionsCached : filterByPermissions;
    const processedSiteMap = processorFunc(siteMap, permissions);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    permissions: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.bool), _propTypes.default.number])).isRequired
  };
  return (0, _hocWithPermissions.withPermissions)(Wrapper);
}

/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteMapPropType = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const itemPropType = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  route: _propTypes.default.string.isRequired,
  checkPermission: _propTypes.default.func.isRequired,
  scope: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.number), _propTypes.default.func]),
  campaignTypes: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.number), _propTypes.default.func]),
  available: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  selected: _propTypes.default.bool,
  showTag: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  tagClass: _propTypes.default.string
});

const siteMapPropType = _propTypes.default.arrayOf(itemPropType);

exports.siteMapPropType = siteMapPropType;
itemPropType.children = _propTypes.default.arrayOf(siteMapPropType);

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processScope = processScope;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _scopeService = __webpack_require__(110);

var _hocWithPermissions = __webpack_require__(533);

var _primitiveUtilities = __webpack_require__(42);

var _processorHelpers = __webpack_require__(1515);

var _filterMapItem = __webpack_require__(1516);

var _siteMapPropType = __webpack_require__(1513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const processSitemapWithScope = (siteMap, scope, permissions) => {
  const scopeFilter = item => _underscore.default.isFunction(item.scope) ? _underscore.default.contains(item.scope(permissions), scope) : _underscore.default.contains(item.scope, scope);

  return (0, _filterMapItem.filterMapItem)(siteMap, scopeFilter);
};

const processSitemapWithScopeCached = (0, _primitiveUtilities.memoize)(processSitemapWithScope);

function processScope(Component, scope = null, useCache = false, skipRoot = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const _props$scope$values = props.scope.values,
          aid = _props$scope$values.aid,
          campaignId = _props$scope$values.campaignId,
          adGroupId = _props$scope$values.adGroupId,
          storeId = _props$scope$values.storeId,
          feedId = _props$scope$values.feedId,
          permissions = props.permissions;
    const currentScope = (0, _processorHelpers.getCurrentScope)(campaignId, adGroupId, aid, storeId, feedId);

    const permissionsWithDynamic = _underscore.default.defaults(permissions, {
      dynamic: {}
    });

    const scopeToCheck = scope === null ? currentScope : scope;
    const processorFunc = useCache ? processSitemapWithScopeCached : processSitemapWithScope;
    let processedSiteMap;

    if (skipRoot) {
      processedSiteMap = _underscore.default.map(siteMap, item => item.processChildScope ? _objectSpread({}, item, {
        children: processorFunc(item.children, scopeToCheck, permissionsWithDynamic)
      }) : item);
    } else {
      processedSiteMap = processorFunc(siteMap, scopeToCheck, permissionsWithDynamic);
    }

    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    scope: _propTypes.default.instanceOf(_scopeService.QueryParam).isRequired,
    permissions: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.bool), _propTypes.default.number])).isRequired
  };
  return (0, _hocWithPermissions.withPermissions)((0, _scopeService.withScope)(Wrapper));
}

/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimScope = trimScope;
exports.getCurrentScope = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _urijs = _interopRequireDefault(__webpack_require__(327));

var _shared = __webpack_require__(1327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore file */
const getCurrentScope = (currentCampaignId, currentAdGroupId, currentAccountId, currentStoreId, currentFeedId) => {
  if (currentStoreId && currentFeedId) {
    return _shared.Scope.MerchantFeed;
  }

  if (currentStoreId) {
    return _shared.Scope.Store;
  }

  if (currentAdGroupId) {
    return _shared.Scope.AdGroup;
  }

  if (currentCampaignId) {
    return _shared.Scope.Campaign;
  }

  if (currentAccountId) {
    return _shared.Scope.Account;
  }

  return _shared.Scope.Customer;
}; // todo: [rayduan] refactor below methods so that they are not coupled to features


exports.getCurrentScope = getCurrentScope;
const SCOPE_TO_KEY = {
  [_shared.Scope.Account]: 'aid',
  [_shared.Scope.Campaign]: 'campaignId',
  [_shared.Scope.AdGroup]: 'adGroupId',
  [_shared.Scope.Store]: 'storeId',
  [_shared.Scope.MerchantFeed]: 'feedId'
};

function trimScopeInternal({
  urlQuery,
  currentScope,
  leastSupportedScope
}) {
  // i.e. currentScope = 1 = account scope
  // leastSupportedScope = 0 = customer scope
  if (currentScope > leastSupportedScope) {
    const queryToRemove = _underscore.default.range(leastSupportedScope + 1, currentScope + 1).map(scopeNumber => SCOPE_TO_KEY[scopeNumber]);

    return (0, _urijs.default)(urlQuery).removeQuery(queryToRemove).toString();
  } // No need to trim scope, return url query as it is


  return urlQuery;
}

function trimScope(supportedScopes, scopeService, siteMapId) {
  /* eslint-disable object-curly-newline */
  const history = scopeService.history,
        _scopeService$values = scopeService.values,
        uid = _scopeService$values.uid,
        cid = _scopeService$values.cid,
        aid = _scopeService$values.aid,
        campaignId = _scopeService$values.campaignId,
        adGroupId = _scopeService$values.adGroupId,
        storeId = _scopeService$values.storeId,
        feedId = _scopeService$values.feedId;

  if (siteMapId === 'import-google' || siteMapId === 'import-file') {
    return scopeService.stringify(_underscore.default.omit({
      uid,
      cid,
      aid
    }, value => !value));
  }

  const currentScope = getCurrentScope(campaignId, adGroupId, aid, storeId, feedId);
  const leastSupportedScope = _underscore.default.isEmpty(supportedScopes) ? _shared.Scope.Account : _underscore.default.max(supportedScopes);
  return trimScopeInternal({
    urlQuery: history.location.search,
    currentScope,
    leastSupportedScope
  });
}

/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterMapItem = filterMapItem;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterMapItem(siteMap, predicate) {
  return _underscore.default.reduce(siteMap, (result, item) => {
    if (predicate(item)) {
      const children = filterMapItem(item.children, predicate);
      result.push(_underscore.default.defaults({
        children
      }, item));
    }

    return result;
  }, []);
}

/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processScopeV2 = processScopeV2;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _scopeService = __webpack_require__(110);

var _hocWithPermissions = __webpack_require__(533);

var _primitiveUtilities = __webpack_require__(42);

var _filterMapItem = __webpack_require__(1516);

var _siteMapPropType = __webpack_require__(1513);

var _scope = __webpack_require__(1328);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const processSitemapWithScope = (siteMap, scope, permissions) => {
  const scopeFilter = item => _underscore.default.isFunction(item.scopeV2) ? _underscore.default.contains(item.scopeV2(permissions), scope) : _underscore.default.contains(item.scopeV2, scope);

  return (0, _filterMapItem.filterMapItem)(siteMap, scopeFilter);
};

const processSitemapWithScopeCached = (0, _primitiveUtilities.memoize)(processSitemapWithScope);

function processScopeV2(Component, scope = null, useCache = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const values = props.scope.values,
          permissions = props.permissions;

    const currentScope = _scope.Scope.getCurrentScope(values);

    const permissionsWithDynamic = _underscore.default.defaults(permissions, {
      dynamic: {}
    });

    const scopeToCheck = scope === null ? currentScope : scope;
    const processorFunc = useCache ? processSitemapWithScopeCached : processSitemapWithScope;
    const processedSiteMap = processorFunc(siteMap, scopeToCheck, permissionsWithDynamic);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    scope: _propTypes.default.instanceOf(_scopeService.QueryParam).isRequired,
    permissions: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.bool), _propTypes.default.number])).isRequired
  };
  return (0, _hocWithPermissions.withPermissions)((0, _scopeService.withScope)(Wrapper));
}

/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processPath = processPath;
exports.updateSitemapBaseHost = exports.updateSelected = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _urijs = _interopRequireDefault(__webpack_require__(327));

var _router = __webpack_require__(162);

var _settingsContext = __webpack_require__(574);

var _primitiveUtilities = __webpack_require__(42);

var _siteMapPropType = __webpack_require__(1513);

var _siteMapUtilities = __webpack_require__(1519);

var _pathUtilities = __webpack_require__(1520);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const updateSelected = (pathname, siteMap) => _underscore.default.map(siteMap, item => {
  const children = updateSelected(pathname, item.children);

  const exact = _underscore.default.result(item, 'exact', true);

  let route;

  if (item.fixedRoute) {
    route = item.fixedRoute;
  } else {
    route = _underscore.default.findWhere(children, {
      route: item.route
    }) ? item.route : _underscore.default.result(_underscore.default.first(children), 'route', item.route);
  }

  const selected = (0, _siteMapUtilities.isRouteMatch)(pathname, item.routePrefix, route, exact) || !!_underscore.default.findWhere(children, {
    selected: true
  });
  return _underscore.default.extend(item, {
    selected,
    children,
    route
  });
});

exports.updateSelected = updateSelected;

const updateSitemapBaseHost = (siteMap, pathname, settingsContext) => (0, _pathUtilities.updateBaseHost)(updateSelected(pathname, siteMap), new _urijs.default().normalize(), settingsContext);

exports.updateSitemapBaseHost = updateSitemapBaseHost;
const updateSitemapBaseHostCached = (0, _primitiveUtilities.memoize)(updateSitemapBaseHost);

function processPath(Component, useCache = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const pathname = props.location.pathname,
          settingsContext = props.settingsContext;
    const processorFunc = useCache ? updateSitemapBaseHostCached : updateSitemapBaseHost;
    const processedSiteMap = processorFunc(siteMap, pathname, settingsContext);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string
    }).isRequired,
    settingsContext: _propTypes.default.shape({
      Urls: _propTypes.default.object.isRequired
    })
  };
  Wrapper.defaultProps = {
    settingsContext: {
      Urls: {}
    }
  };
  return (0, _settingsContext.withSettingsConsumer)((0, _router.withRouter)(Wrapper));
}

/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRouteMatch = isRouteMatch;
exports.getRoutePathById = getRoutePathById;
exports.findSiteMap = findSiteMap;
exports.findAllSiteMap = findAllSiteMap;
exports.findDeepSiteMap = findDeepSiteMap;
exports.filterMapByRootIds = exports.findSelectedNode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _reactRouterDom = __webpack_require__(183);

var _urijs = _interopRequireDefault(__webpack_require__(327));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isRouteMatch(pathname, routePrefix, route, exact) {
  const extractPattern = new RegExp(`${routePrefix}(.+)$`, 'i');

  const currentLocation = _underscore.default.last(pathname.match(extractPattern));

  if (_underscore.default.isEmpty(currentLocation)) {
    return false;
  }

  return route ? !!(0, _reactRouterDom.matchPath)(currentLocation, {
    path: route,
    exact
  }) : false;
}

function getRoutePathById(siteMap, id, getAbsoluteIfExists = false) {
  if (_underscore.default.isEmpty(siteMap)) {
    return false;
  }

  const site = _underscore.default.findWhere(siteMap, {
    id
  });

  if (site) {
    if (getAbsoluteIfExists && site.absoluteRoute) {
      return site.absoluteRoute;
    }

    return new _urijs.default(site.route).is('absolute') ? site.route : `${site.routePrefix}${site.route}`;
  }

  return getRoutePathById(_underscore.default.chain(siteMap).pluck('children').flatten().value(), id, getAbsoluteIfExists);
}

function findSiteMap(siteMap, condition) {
  for (let i = 0; i < siteMap.length; i += 1) {
    const item = siteMap[i];
    const result = condition(item) ? item : findSiteMap(item.children, condition);

    if (!_underscore.default.isEmpty(result)) {
      return result;
    }
  }

  return null;
}

function findAllSiteMap(siteMap, condition) {
  let result = [];

  for (let i = 0; i < siteMap.length; i += 1) {
    const item = siteMap[i];

    if (condition(item)) {
      result.push(item);
    }

    if (item.children.length > 0) {
      result = result.concat(findAllSiteMap(item.children, condition));
    }
  }

  return _underscore.default.compact(result);
}
/**
 * findDeepSiteMap(map)
 * Will return deepest node who's parents and itself
 * satisfy the given condition
 * @param {map} map a site map
 * @param {function} condition  truth test
 * @returns {object} node || undefinded if not found
 */


function findDeepSiteMap(map, condition) {
  const currentNode = _underscore.default.find(map, condition);

  let selectedChild;

  if (currentNode && currentNode.children) {
    selectedChild = findDeepSiteMap(currentNode.children, condition);
  }

  return selectedChild || currentNode;
}
/**
 * findSelectedNode(map)
 * Will return deepest node who's parents and itself
 * have selected property set true
 * @param {map} map a site map
 * @param {function} condition  truth test
 * @returns {object} node || undefinded if not found
 */


const findSelectedNode = _underscore.default.partial(findDeepSiteMap, _underscore.default, node => _underscore.default.result(node, 'selected', false));

exports.findSelectedNode = findSelectedNode;

function filterMapByIdSegments(siteMap, segments) {
  const id = _underscore.default.last(segments);

  if (id === '*') {
    return siteMap;
  }

  for (let i = 0; i < siteMap.length; i += 1) {
    const item = siteMap[i];

    if (_underscore.default.result(item, 'id') === id) {
      segments.pop();
      return _underscore.default.isEmpty(segments) ? [item] : filterMapByIdSegments(item.children, segments);
    }

    const result = filterMapByIdSegments(item.children, segments);

    if (!_underscore.default.isEmpty(result)) {
      return result;
    }
  }

  return [];
}
/**
 * filterMapByRootIds(siteMap, rootIds)
 * Will return a new siteMap that unions all matching rootdIds
 * Refer to root-filter-processor-unit-test for more examples
 * @param {array} siteMap a site map
 * @param {array} rootIds ids to match child items, supports ['id', 'parent/child', 'parent/*']
 * @returns {array} new siteMap that unions all rootIds matches
 */


const filterMapByRootIds = (siteMap, rootIds = null) => {
  if (rootIds == null) {
    return siteMap;
  }

  const rootIdArray = _underscore.default.isArray(rootIds) ? rootIds : [rootIds];
  return _underscore.default.chain(rootIdArray).map(id => {
    const segments = id.split('/').reverse();
    return filterMapByIdSegments(siteMap, segments);
  }).flatten(true).compact().value();
};

exports.filterMapByRootIds = filterMapByRootIds;

/***/ }),

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBaseHost = exports.getRouteWithBaseHost = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _urijs = _interopRequireDefault(__webpack_require__(327));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getBaseHost = (item, settings = {}) => {
  const baseUrl = _underscore.default.result(settings.Urls, item.baseHost, null);

  return _underscore.default.isEmpty(baseUrl) ? null : new _urijs.default(baseUrl).normalize();
};

const isAbsoluteRouteRequired = (baseHost, currentUrl) => {
  if (_underscore.default.isEmpty(baseHost)) {
    return false;
  }

  if (currentUrl.host() !== baseHost.host()) {
    return true; // if host name is different, we need absolute route
  }

  const basePath = baseHost.path().toLowerCase();
  const currentPath = currentUrl.path().toLowerCase(); // if basePath is not a sub-path of current path, we need absolute route

  return _urijs.default.commonPath(basePath, currentPath) !== basePath;
};

const getRouteWithBaseHost = (route, baseHost, currentUrl, forceAbsolute = false) => (forceAbsolute || isAbsoluteRouteRequired(baseHost, currentUrl)) && !_underscore.default.isEmpty(baseHost) && !new _urijs.default(route).is('absolute') ? baseHost + route : route;

exports.getRouteWithBaseHost = getRouteWithBaseHost;

const updateBaseHost = (siteMap, currentUrl, settings) => _underscore.default.map(siteMap, item => _underscore.default.defaults({
  children: updateBaseHost(item.children, currentUrl, settings),
  route: getRouteWithBaseHost(item.route, getBaseHost(item, settings), currentUrl),
  absoluteRoute: getRouteWithBaseHost(item.route, getBaseHost(item, settings), currentUrl, true)
}, item));

exports.updateBaseHost = updateBaseHost;

/***/ }),

/***/ 1521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCustomMapper = processCustomMapper;
exports.customMapperStore = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _stateStore = __webpack_require__(870);

var _withStateStore = __webpack_require__(867);

var _siteMapPropType = __webpack_require__(1513);

var _filterMapItem = __webpack_require__(1516);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const customMapperStore = new _stateStore.StateStore({});
exports.customMapperStore = customMapperStore;

const cloneMap = _underscore.default.partial(_filterMapItem.filterMapItem, _underscore.default, () => true);

function processCustomMapper(Component) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        store = _ref.store,
        props = _objectWithoutProperties(_ref, ["siteMap", "store"]);

    const customProcessors = _underscore.default.isEmpty(store.state) ? _underscore.default.identity : _underscore.default.compose(..._underscore.default.toArray(store.state), cloneMap);
    const processedSiteMap = customProcessors(siteMap);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    store: _propTypes.default.instanceOf(_stateStore.StateStore).isRequired
  };
  return (0, _withStateStore.withStateStore)(Wrapper, customMapperStore);
}

/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processRootFilter = processRootFilter;

var _react = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(42);

var _siteMapUtilities = __webpack_require__(1519);

var _siteMapPropType = __webpack_require__(1513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const filterMapByRootIdsCached = (0, _primitiveUtilities.memoize)(_siteMapUtilities.filterMapByRootIds);

function processRootFilter(Component, rootIds = null, useCache = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const processorFunc = useCache ? filterMapByRootIdsCached : _siteMapUtilities.filterMapByRootIds;
    const processedSiteMap = processorFunc(siteMap, rootIds);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired
  };
  return Wrapper;
}

/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCampaignUIContext = processCampaignUIContext;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(42);

var _siteMapPropType = __webpack_require__(1513);

var _shared = __webpack_require__(1327);

var _filterMapItem = __webpack_require__(1516);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const filterMapItemBase = siteMap => {
  const filter = mapItem => {
    if (!_underscore.default.isEmpty(mapItem.campaignTypes) && !_underscore.default.contains(mapItem.campaignTypes, _shared.CampaignType.All) || _underscore.default.isFunction(mapItem.campaignTypes)) {
      return false;
    }

    if (_underscore.default.isFunction(mapItem.currentCampaign)) {
      return false;
    }

    if (!_underscore.default.isEmpty(mapItem.adGroupTypes)) {
      return false;
    }

    if (!_underscore.default.isEmpty(mapItem.hotelCampaignScope)) {
      return false;
    }

    return true;
  };

  return (0, _filterMapItem.filterMapItem)(siteMap, filter);
};

const filterMapItemCached = (0, _primitiveUtilities.memoize)(filterMapItemBase);

function processCampaignUIContext(Component) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        props = _objectWithoutProperties(_ref, ["siteMap"]);

    const processed = filterMapItemCached(siteMap);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processed
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired
  };
  return Wrapper;
}

/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processShowYahoo = processShowYahoo;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _userContext = __webpack_require__(559);

var _primitiveUtilities = __webpack_require__(42);

var _yahooHelpers = __webpack_require__(1525);

var _siteMapPropType = __webpack_require__(1513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const processSitemap = (siteMap, yahooModel) => _underscore.default.map(siteMap, item => {
  const retItem = item;

  if (item.baseHost === 'ClientCenterBaseUrl') {
    if (item.onlyShowToYahoo) {
      return yahooModel && yahooModel.canUserAccessYahooData ? item : null;
    }

    retItem.children = _underscore.default.map(item.children, child => {
      if (child.onlyShowToYahoo) {
        return yahooModel && yahooModel.canUserAccessYahooData ? child : null;
      }

      return child;
    }).filter(child => child !== null);
  }

  return retItem;
});

const processSitemapCached = (0, _primitiveUtilities.memoize)(processSitemap);

function processShowYahoo(Component, useCache = false) {
  const Wrapper = (_ref) => {
    let siteMap = _ref.siteMap,
        userContext = _ref.userContext,
        props = _objectWithoutProperties(_ref, ["siteMap", "userContext"]);

    const params = props.params;

    const permissions = _underscore.default.defaults(props.permissions, {
      dynamic: {}
    });

    const CurrentUser = userContext.CurrentUser,
          CurrentCustomer = userContext.CurrentCustomer;
    const yahooModel = (0, _yahooHelpers.useYahooModel)(params, permissions, CurrentUser, CurrentCustomer);
    const processorFunc = useCache ? processSitemapCached : processSitemap;
    const processedSiteMap = processorFunc(siteMap, yahooModel).filter(child => child !== null);
    return _react.default.createElement(Component, _extends({}, props, {
      siteMap: processedSiteMap
    }));
  };

  Wrapper.propTypes = {
    siteMap: _siteMapPropType.siteMapPropType.isRequired,
    permissions: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.bool), _propTypes.default.number])).isRequired,
    userContext: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number])), _propTypes.default.number])).isRequired,
    params: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.objectOf(_propTypes.default.bool), _propTypes.default.number])).isRequired
  };
  return (0, _userContext.withUserConsumer)(Wrapper);
}

/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useYahooModel = exports.isManagedByYahoo = exports.ManagedByType = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _yahooIframe = __webpack_require__(1526);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ManagedByType = Object.freeze({
  Microsoft: 0,
  Yahoo: 1,
  ChinaJV: 2
});
exports.ManagedByType = ManagedByType;

const isManagedByYahoo = customer => _underscore.default.result(customer, 'ManagedBy') === ManagedByType.Yahoo;

exports.isManagedByYahoo = isManagedByYahoo;

const useYahooModel = (defaultmsview, permissions, currentUser, currentCustomer) => currentUser && currentCustomer ? (0, _yahooIframe.getYahooModel)({
  isCustomerManagedByYahoo: isManagedByYahoo(currentCustomer),
  defaultMSView: defaultmsview,
  isInternalUser: currentUser.IsInternal,
  permissions: permissions.dynamic,
  allowYahooCustomerAccessMSView: false
}) : null;

exports.useYahooModel = useYahooModel;

/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1526__;

/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSiteMapWrapper = createSiteMapWrapper;
exports.defaultPropName = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _siteMapPropType = __webpack_require__(1513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const defaultPropName = 'siteMap';
exports.defaultPropName = defaultPropName;

function createSiteMapWrapper(Component, composedProcessor, newSiteMap, propName = defaultPropName) {
  if (propName === defaultPropName) {
    const WrappedComponent = composedProcessor(Component);
    return props => _react.default.createElement(WrappedComponent, _extends({}, props, {
      siteMap: newSiteMap
    }));
  }

  let siteMapBackup = null;

  const processPropName = WrappedComponent => {
    const Wrapper = (_ref) => {
      let siteMap = _ref.siteMap,
          props = _objectWithoutProperties(_ref, ["siteMap"]);

      const siteMapProp = {
        [propName]: siteMap
      };

      if (siteMapBackup) {
        siteMapProp.siteMap = siteMapBackup;
      }

      return _react.default.createElement(WrappedComponent, _extends({}, props, siteMapProp));
    };

    Wrapper.propTypes = {
      siteMap: _siteMapPropType.siteMapPropType.isRequired
    };
    return Wrapper;
  };

  const backupOriginalSiteMap = (_ref2) => {
    let siteMap = _ref2.siteMap,
        rest = _objectWithoutProperties(_ref2, ["siteMap"]);

    siteMapBackup = siteMap;
    return rest;
  };

  const WrappedComponent = composedProcessor(processPropName(Component));
  return props => _react.default.createElement(WrappedComponent, _extends({}, backupOriginalSiteMap(props), {
    siteMap: newSiteMap
  }));
}

/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navRefreshSiteMap = exports.navRefreshPageIds = exports.navRefreshPages = void 0;

var _shared = __webpack_require__(1327);

var _accountMap = __webpack_require__(1529);

var _advertise = __webpack_require__(1530);

var _allAccounts = __webpack_require__(1531);

var _assetLibrary = __webpack_require__(1532);

var _audiences = __webpack_require__(1533);

var _billing = __webpack_require__(1534);

var _brands = __webpack_require__(1535);

var _budgetBid = __webpack_require__(1536);

var _bulkActions = __webpack_require__(1537);

var _businessData = __webpack_require__(1538);

var _businessLocation = __webpack_require__(1539);

var _clarity = __webpack_require__(1540);

var _conversions = __webpack_require__(1541);

var _create = __webpack_require__(1542);

var _hotels = __webpack_require__(1543);

var _imports = __webpack_require__(1544);

var _keywords = __webpack_require__(1545);

var _labels = __webpack_require__(1546);

var _merchantCenter = __webpack_require__(1547);

var _microsoftStoreAds = __webpack_require__(1548);

var _performanceTargets = __webpack_require__(1549);

var _preview = __webpack_require__(1550);

var _productFeed = __webpack_require__(1551);

var _reports = __webpack_require__(1552);

var _setttings = __webpack_require__(1553);

var _smartPage = __webpack_require__(1554);

var _transactions = __webpack_require__(1555);

var _websiteExluctionList = __webpack_require__(1556);

const pages = {
  create: _create.create,
  advertise: _advertise.advertise,
  audiences: _audiences.audiences,
  conversions: _conversions.conversions,
  keywords: _keywords.keywords,
  assetLibrary: _assetLibrary.assetLibrary,
  imports: _imports.imports,
  businessData: _businessData.businessData,
  smartPage: _smartPage.smartPage,
  merchantCenter: _merchantCenter.merchantCenter,
  brands: _brands.brands,
  productFeed: _productFeed.productFeed,
  hotel: _hotels.hotel,
  businessLocation: _businessLocation.businessLocation,
  microsoftStoreAds: _microsoftStoreAds.microsoftStoreAds,
  transactions: _transactions.transactions,
  budgetAndBid: _budgetBid.budgetAndBid,
  bulkActions: _bulkActions.bulkActions,
  advertisingEditor: _bulkActions.advertisingEditor,
  advertisingMobile: _bulkActions.advertisingMobile,
  labels: _labels.labels,
  preview: _preview.preview,
  performanceTargets: _performanceTargets.performanceTargets,
  websiteExclusion: _websiteExluctionList.websiteExclusion,
  accountMap: _accountMap.accountMap,
  reports: _reports.reports,
  clarity: _clarity.clarity,
  allAccounts: _allAccounts.allAccounts,
  billing: _billing.billing,
  settings: _setttings.settings
};
const navRefreshPages = Object.values(pages);
exports.navRefreshPages = navRefreshPages;
const navRefreshPageIds = {};
exports.navRefreshPageIds = navRefreshPageIds;
Object.keys(pages).forEach(key => {
  navRefreshPageIds[key] = pages[key].id;
});
const navRefreshSiteMap = (0, _shared.buildTree)(navRefreshPages, _shared.alwaysDisplayedItem, true, undefined, true);
exports.navRefreshSiteMap = navRefreshSiteMap;

/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountMap = void 0;

var _accountMap = __webpack_require__(1392);

var _configs = __webpack_require__(1326);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const accountMap = _objectSpread({}, _configs.ccAlwaysDisplayedItem, _accountMap.accountMap, {
  description: _TL_('View a full visual picture of your account structure.'),
  route: 'AccountMap'
});

exports.accountMap = accountMap;

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advertise = void 0;

var _shared = __webpack_require__(1327);

var _overview = __webpack_require__(1336);

var _recommendations = __webpack_require__(1337);

var _campaigns = __webpack_require__(1338);

var _adgroups = __webpack_require__(1339);

var _products = __webpack_require__(1340);

var _adsAndExtensions = __webpack_require__(1341);

var _assets = __webpack_require__(1342);

var _landingPages = __webpack_require__(1343);

var _dynamicAdTargets = __webpack_require__(1344);

var _feedsItems = __webpack_require__(1345);

var _keywords = __webpack_require__(1346);

var _productGroups = __webpack_require__(1347);

var _hotelGroups = __webpack_require__(1348);

var _hotels = __webpack_require__(1349);

var _audiences = __webpack_require__(1350);

var _demographics = __webpack_require__(1351);

var _settings = __webpack_require__(1352);

var _locations = __webpack_require__(1353);

var _adSchedule = __webpack_require__(1354);

var _devices = __webpack_require__(1355);

var _changeHistory = __webpack_require__(1356);

var _competition = __webpack_require__(1357);

var _experiments = __webpack_require__(1358);

var _queryInsights = __webpack_require__(1360);

var _assetGroups = __webpack_require__(1361);

var _listingGroups = __webpack_require__(1362);

const advertise = {
  id: 'advertise',
  name: _TL_('Advertise'),
  description: _TL_('View performance, account information, recommendations, and more.'),
  scope: [_shared.Scope.Account, _shared.Scope.Campaign],
  campaignTypes: _shared.alwaysDisplayed,
  processChildScope: true,
  fixed: true,
  children: (0, _shared.buildTree)([_overview.overview, _recommendations.recommendations, _queryInsights.queryInsights, _campaigns.campaigns, _adgroups.adGroups, _assetGroups.assetGroups, _listingGroups.listingGroups, _products.products, _adsAndExtensions.adsAndExtensions, _assets.assets, _landingPages.landingPages, _keywords.keywords, _dynamicAdTargets.dynamicAdTargets, _feedsItems.feedsItems, _productGroups.productGroups, _hotelGroups.hotelGroups, _hotelGroups.propertyGroups, _hotels.hotels, _hotels.properties, _audiences.audiences, _demographics.demographics, _settings.settings, _locations.locations, _adSchedule.adSchedule, _devices.devices, _changeHistory.changeHistory, _competition.competition, _experiments.experiments], _shared.defaultItem, true, undefined, true)
};
exports.advertise = advertise;

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allAccounts = void 0;

var _accountsSummary = __webpack_require__(1331);

var _overview = __webpack_require__(1332);

var _recommendations = __webpack_require__(1333);

var _auctionInsights = __webpack_require__(1334);

var _shared = __webpack_require__(1327);

const allAccounts = {
  id: 'all-accounts',
  name: _TL_('All accounts'),
  description: _TL_('Manage your account-level settings.'),
  oldUIScope: [_shared.Scope.Customer],
  scope: [_shared.Scope.Customer],
  route: 'accounts',
  children: [_overview.overview, _accountsSummary.accountsSummary, _recommendations.recommendations, _auctionInsights.auctionInsights]
};
exports.allAccounts = allAccounts;

/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetLibrary = void 0;

var _creativeStudioAssetLibrary = __webpack_require__(1377);

var _shared = __webpack_require__(1327);

const assetLibrary = {
  id: 'asset-library',
  name: _TL_('Asset Library'),
  description: _TL_('Manage all of your creative assets in one place.'),
  oldUIScope: [_shared.Scope.Account],
  scope: [_shared.Scope.Account],
  route: 'assetlibrary',
  children: [_creativeStudioAssetLibrary.assetsPage, _creativeStudioAssetLibrary.performancePage]
};
exports.assetLibrary = assetLibrary;

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audiences = void 0;

var _planning = __webpack_require__(1364);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const audiences = _objectSpread({}, _planning.audiencePlanner, {
  id: 'audience-planner',
  name: _TL_('Audiences'),
  description: _TL_('Manage and plan audience targeting.')
});

exports.audiences = audiences;

/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billing = void 0;

var _shared = __webpack_require__(1327);

var _configs = __webpack_require__(1326);

var _billingPayments = __webpack_require__(1492);

const billing = {
  id: 'billing',
  name: _TL_('Billing'),
  description: _TL_('Manage your billing and payments.'),
  route: 'billing',
  fixed: true,
  processChildScope: true,
  children: [_billingPayments.billingSummary, _billingPayments.transactions, _billingPayments.paymentMethods, _billingPayments.adjustments, _billingPayments.balance, _billingPayments.insertionOrders, _billingPayments.billingSettings, _billingPayments.couponDetails]
};
const tree = (0, _shared.buildTree)([billing], _configs.ccAlwaysDisplayedItem, true, undefined, true)[0];
exports.billing = tree;

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brands = void 0;

var _productFeed = __webpack_require__(1368);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const brands = _objectSpread({}, _productFeed.SponsoredProductsPage, {
  description: _TL_('Partner with retailers selling your products.'),
  children: []
});

exports.brands = brands;

/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.budgetAndBid = void 0;

var _shared = __webpack_require__(1327);

var _advancedControls = __webpack_require__(1510);

var _portfolioBidStrategy = __webpack_require__(1511);

var _sharedBudgets = __webpack_require__(1374);

var _budgetCenter = __webpack_require__(1396);

var _campaignBudgetTool = __webpack_require__(1397);

var _portfolioBidStrategy2 = __webpack_require__(1375);

var _seasonalityAdjustment = __webpack_require__(1376);

const budgetAndBid = {
  id: 'budget-and-bid',
  name: _TL_('Bids & budgets'),
  description: _TL_('Optimize your campaigns with bids and budgets.'),
  oldUIScope: [_shared.Scope.Account],
  children: [_sharedBudgets.sharedBudgetsPage, _budgetCenter.budgetCenter, _campaignBudgetTool.campaignBudgetTool, _advancedControls.advancedControlsPage, _portfolioBidStrategy.bidStrategiesPortfolio, _portfolioBidStrategy2.portfolioBid, _seasonalityAdjustment.seasonalityAdjustment]
};
exports.budgetAndBid = budgetAndBid;

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "advertisingEditor", {
  enumerable: true,
  get: function get() {
    return _bulkActions.advertisingEditor;
  }
});
Object.defineProperty(exports, "advertisingMobile", {
  enumerable: true,
  get: function get() {
    return _bulkActions.advertisingMobile;
  }
});
exports.bulkActions = void 0;

var _bulkActions = __webpack_require__(1378);

var _shared = __webpack_require__(1327);

const bulkActions = {
  id: 'bulk-actions',
  name: _TL_('Bulk actions'),
  description: _TL_('Make bulk edits by using automated rules, bulk upload, and/or scripts.'),
  scope: [_shared.Scope.Customer, _shared.Scope.Account],
  children: _bulkActions.bulkActionsPages
};
exports.bulkActions = bulkActions;

/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessData = void 0;

var _businessData = __webpack_require__(1395);

const businessData = {
  id: 'business-data',
  name: _TL_('Business data'),
  description: _TL_('Upload and manage your business data feeds.'),
  route: 'feeds/attribute',
  children: _businessData.businessDataPages
};
exports.businessData = businessData;

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessLocation = void 0;

var _shared = __webpack_require__(1327);

var _businessLocationFeed = __webpack_require__(1367);

const businessLocation = {
  id: 'business-location',
  name: _TL_('Business locations'),
  description: _TL_('Sync location data from Google My Business or Bing Places.'),
  oldUIScope: [_shared.Scope.Account],
  children: _businessLocationFeed.businessLocationFeed
};
exports.businessLocation = businessLocation;

/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clarity = void 0;

var _clarityWebsite = __webpack_require__(1387);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const clarity = _objectSpread({}, _clarityWebsite.clarityWebsite, {
  description: _TL_('Set up Clarity to see how customers interact with your site.'),
  externalLink: 'https://clarity.microsoft.com'
});

exports.clarity = clarity;

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversions = void 0;

var _conversionTracking = __webpack_require__(1383);

const conversions = {
  id: 'conversions',
  name: _TL_('Conversions'),
  description: _TL_('Get behavioral insights for conversion tracking.'),
  children: [_conversionTracking.uetTags, _conversionTracking.conversionGoals, _conversionTracking.offlineConversions]
};
exports.conversions = conversions;

/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = void 0;

var _shared = __webpack_require__(1327);

const create = {
  id: 'create',
  name: _TL_('Create'),
  description: _TL_(''),
  route: 'createcampaign/objective',
  fixed: true,
  oldUIScope: [_shared.Scope.Account],
  scope: [_shared.Scope.Account]
};
exports.create = create;

/***/ }),

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hotel = void 0;

var _hotelCenter = __webpack_require__(1398);

var _hotelCenterV = __webpack_require__(1408);

var _shared = __webpack_require__(1327);

const hotel = {
  id: 'hotel-center',
  name: _TL_('Lodging Solutions'),
  description: _TL_('Manage ads and campaigns for your hotels and rental properties.'),
  scope: _shared.defaultScopes,
  children: [..._hotelCenter.hotelCenterPages, ..._hotelCenterV.hotelCenterV2Pages]
};
exports.hotel = hotel;

/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imports = void 0;

var _imports = __webpack_require__(1451);

const imports = {
  id: 'import',
  name: _TL_('Import'),
  description: _TL_('Import your campaigns and data from Google Ads, Facebook Ads, and/or Pinterest Ads.'),
  children: [_imports.importSchedule, _imports.googleImport, _imports.facebookImport, _imports.amazonImport, _imports.pinterestImport, _imports.fileImport]
};
exports.imports = imports;

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keywords = void 0;

var _shared = __webpack_require__(1327);

var _planning = __webpack_require__(1364);

var _negativeKeywordListsLibrary = __webpack_require__(1370);

const keywords = {
  id: 'keywords-planning',
  name: _TL_('Keywords'),
  description: _TL_('Manage keyword and negative keyword lists.'),
  children: [_planning.keywordPlanner, _negativeKeywordListsLibrary.negativeKeyword]
};
exports.keywords = keywords;

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;

var _shared = __webpack_require__(1327);

const labels = {
  id: 'labels',
  name: _TL_('Labels'),
  description: _TL_('Organize your campaigns, ad groups, and more with labels.'),
  route: 'labels',
  oldUIScope: [_shared.Scope.Account, _shared.Scope.Customer],
  scope: [_shared.Scope.Account, _shared.Scope.Customer],
  children: [{
    id: 'labels',
    name: _TL_('Labels'),
    route: 'labels'
  }]
};
exports.labels = labels;

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchantCenter = void 0;

var _merchantShared = __webpack_require__(1417);

var _feeds = __webpack_require__(1419);

var _import = __webpack_require__(1420);

var _promotions = __webpack_require__(1421);

var _settings = __webpack_require__(1422);

var _summary = __webpack_require__(1424);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const merchantCenter = {
  id: 'merchant-center',
  name: _TL_('Merchant Center'),
  description: _TL_('Manage your product catalogs to run shopping campaigns.'),
  scope: _merchantShared.defaultScope,
  scopeV2: _merchantShared.defaultScopeV2,
  route: 'merchantcenter',
  processChildScope: true,
  children: [_objectSpread({}, _summary.storeSummary, {
    name: _TL_('Summary')
  }), _objectSpread({}, _feeds.feeds, {
    name: _TL_('Feeds')
  }), _objectSpread({}, _import.importFeed, {
    name: _TL_('Import')
  }), _objectSpread({}, _promotions.promotions, {
    name: _TL_('Promotions')
  }), _objectSpread({}, _settings.settings, {
    name: _TL_('Settings')
  })]
};
exports.merchantCenter = merchantCenter;

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.microsoftStoreAds = void 0;

var _productFeed = __webpack_require__(1368);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const microsoftStoreAds = _objectSpread({}, _productFeed.MicrosoftStoreAdsPageGA, {
  name: _TL_('Microsoft Store Ads'),
  description: _TL_('Create and manage ads targeted towards customers browsing the Microsoft Store.')
});

exports.microsoftStoreAds = microsoftStoreAds;

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTargets = void 0;

var _shared = __webpack_require__(1327);

var _performanceTargets = __webpack_require__(1371);

const performanceTargets = {
  id: 'performance-targets',
  name: _TL_('Performance Targets'),
  description: _TL_('Set targets and review performance for groups of campaigns.'),
  oldUIScope: [_shared.Scope.Account],
  children: [_performanceTargets.performanceTargets]
};
exports.performanceTargets = performanceTargets;

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preview = void 0;

var _shared = __webpack_require__(1327);

var _adinsight = __webpack_require__(1454);

const preview = {
  id: 'preview',
  name: _TL_('Previewer'),
  description: _TL_('Preview your ad location in Microsoft Bing search results.'),
  campaignTypes: _shared.alwaysDisplayed,
  children: [_adinsight.adPreview]
};
exports.preview = preview;

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productFeed = void 0;

var _productFeed = __webpack_require__(1368);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const productFeed = _objectSpread({}, _productFeed.ProductFeedPage, {
  description: _TL_('Partner with retailers selling your products.')
});

exports.productFeed = productFeed;

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reports = void 0;

var _reportsV = __webpack_require__(1435);

var _shared = __webpack_require__(1327);

const reports = {
  id: 'reports-v4',
  name: _TL_('Reporting'),
  description: _TL_('View performance data with instant reports or by creating custom reports.'),
  route: 'reports-v4',
  fixedRoute: 'reports-v4',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  children: [_reportsV.defaultReportsPage, _reportsV.myReportsPage]
};
const tree = (0, _shared.buildTree)([reports], _shared.alwaysDisplayedItem, true, undefined, true)[0];
exports.reports = tree;

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;

var _shared = __webpack_require__(1327);

var _configs = __webpack_require__(1326);

var _settings = __webpack_require__(1493);

var _accountAccess = __webpack_require__(1494);

const settings = {
  id: 'settings',
  name: _TL_('Settings'),
  route: 'Settings/ViewDefaults',
  scope: _shared.allScopes,
  campaignTypes: _shared.alwaysDisplayed,
  fixed: true,
  children: [_settings.viewDefaults, _settings.accountSettings, _settings.emailSettings, _settings.managerAccountSettings, _settings.mySettings, _settings.advancedSettings, _settings.verificationHub, _accountAccess.userManagement, _accountAccess.directManager]
};
const tree = (0, _shared.buildTree)([settings], _configs.ccAlwaysDisplayedItem, true, undefined, true)[0];
exports.settings = tree;

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartPage = void 0;

var _shared = __webpack_require__(1327);

const smartPage = {
  id: 'smart-page',
  name: _TL_('Smart Page'),
  description: _TL_('Create a free website for your business.'),
  scope: [_shared.Scope.Account],
  externalLink: `${window.location.origin}/campaign/sp/landing${window.location.search}`,
  checkPermission: permissions => permissions.dynamic.PMaxLite && !(0, _shared.isSmartPageStandalone)(permissions) && !permissions.IsUnifiedSmartMode && !permissions.IsSmartMode
};
exports.smartPage = smartPage;

/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactions = void 0;

var _attributedTransactions = __webpack_require__(1393);

var _shared = __webpack_require__(1327);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const transactions = _objectSpread({}, _shared.defaultCCItemProperties, {
  id: 'attributed-transactions',
  name: _TL_('Transactions'),
  description: _TL_('Sync transactions data'),
  route: 'Billing/CashbackApproval',
  children: [_attributedTransactions.attributedTransactions]
});

exports.transactions = transactions;

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.websiteExclusion = void 0;

var _siteExclusionListsAccountLevelViewLists = __webpack_require__(1372);

var _siteExclusionListsCustomerLevelCreateLists = __webpack_require__(1373);

// need to confirm with PM and designer
const websiteExclusion = {
  id: 'site-exlusion',
  name: _TL_('Website exclusion'),
  description: _TL_('Keep ads from showing on specific websites using account level website exclusion lists.'),
  children: [_siteExclusionListsAccountLevelViewLists.siteExclusionViewLists, _siteExclusionListsCustomerLevelCreateLists.siteExclusionListCreate]
};
exports.websiteExclusion = websiteExclusion;

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__162__;

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__183__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__327__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__533__;

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__559__;

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__574__;

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__867__;

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__870__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
